{
    "logo": "Logo céphable",
    "add": "Ajouter",
    "all": "Tous",
    "edit": "Modifier",
    "create": "Créer",
    "delete": "Supprimer",
    "next": "Suivant",
    "previous": "Précédent",
    "search": "Recherche",
    "loading": "Chargement...",
    "reload": "Recharger",
    "cancel": "Annuler",
    "copy": "Copie",
    "save": "Sauvegarder",
    "saveAndFinish": "Enregistrer et terminer",
    "saveAndContinue": "Sauvegarder et continuer",
    "saved": "Enregistré",
    "done": "Fait",
    "back": "Dos",
    "play": "Jouer",
    "pause": "Pause",
    "success": "Succès",
    "continue": "Continuer",
    "options": "Possibilités",
    "share": "Partager",
    "finish": "Finition",
    "finishEdit": "Terminer Modifier",
    "advancedOptions": "Afficher les options avancées",
    "authenticating": "Authentification...",
    "skip": "Sauter",
    "close": "Fermer",
    "notFound": "Page non trouvée",
    "notFoundDescription": "Ah non ! Nous avons fouillé la mer et nous ne trouvons pas votre page !",
    "exitSetup": "Quitter la configuration",
    "experimental": "Expérimental",
    "letGetStarted": "Commençons!",
    "exploreInputControls": "Explorer les contrôles de saisie",
    "when": "Quand je ...",
    "thenMacro": "Cephable fonctionnera...",
    "controls": "Contrôles",
    "welcome": "Accueillir.",
    "beta": "bêta",
    "macroEmpty": "Aucune macro ne correspond à ces critères.",
    "you": "Toi",
    "step": "Étape",
    "steps": "Pas",
    "learnMore": "Apprendre encore plus",
    "dangerZone": "Zone dangereuse",
    "connected": "Connecté",
    "notConnected": "Pas connecté",
    "connectAndLearn": "Connectez-vous et apprenez",
    "tryAgain": "Essayer à nouveau",
    "by": "Par : {{value}}",
    "noName": "- sans nom -",
    "details": "Détails",
    "controlFeed": "Alimentation de contrôle",
    "wifi": {
        "disconnected": "Le Wi-Fi est déconnecté.",
        "connected": "Le Wi-Fi est connecté.",
        "description": "Connectez-vous au Wi-Fi pour permettre à Cephable de fonctionner avec vos connexions et logiciels. Vos capacités d'utilisation actuelles peuvent être limitées."
    },
    "signalR": {
        "disconnected": "La synchronisation est déconnectée.",
        "action": "Reconnecter",
        "description": "Il semble y avoir un problème de synchronisation avec Cephable. Cela pourrait entraîner des problèmes d'enregistrement de vos paramètres ou de communication avec d'autres connexions.",
        "disconnectedDevice": "Impossible de synchroniser avec {{name}}.",
        "disconnectedDeviceDescription": "Il semble y avoir un problème de synchronisation, probablement lié à l'authentification ou à la connexion Internet. L'envoi et la réception de données à distance sont impossibles. Veuillez vérifier la connexion des deux côtés.",
        "connected": "La synchronisation est établie.",
        "connectedDescription": "Cephable se synchronise correctement et devrait communiquer avec vos connexions et extensions comme prévu.",
        "swap": "Basculer vers la connexion à l'appareil local",
        "unlinkedDevice": "Connexion supprimée.",
        "unlinkedDeviceDescription": "Cette connexion a été dissociée de votre compte.",
        "featureRestricted": "Les fonctionnalités Créer et Automatiser ne sont pas disponibles pour les connexions à distance.",
        "featureRestrictedDescription": "Cette fonctionnalité n'est actuellement pas disponible pour les connexions à distance. Veuillez utiliser la connexion à votre appareil local pour bénéficier de toutes les possibilités de création et d'automatisation de vos tâches."
    },
    "billing": {
        "title": "Facturation",
        "expires": "Prochaine facturation : {{value}}",
        "isEmployeeAccess": {
            "title": "Professionnel",
            "titleLong": "Céphable Professionnel",
            "short": "Pro",
            "description": "Cephable Professional offre aux utilisateurs plus de puissance de productivité, en étendant l'IA locale et privée aux capacités génératives.",
            "supportedFeatures": {
                "tag": "Tout en Plus, plus",
                "features": [
                    "Flux de travail d'IA embarqués",
                    "Gestion de l'organisation d'entreprise",
                    "Restrictions d'entreprise",
                    "Installations illimitées sur les appareils",
                    "Commandes d'application pré-entraînées illimitées"
                ]
            }
        },
        "isDeveloperAccess": {
            "title": "Kit de développement logiciel (SDK)",
            "titleLong": "Kit de développement logiciel (SDK) Cephable",
            "short": "SDK",
            "description": "Les SDK Cephable vous permettent d'intégrer de puissants contrôles adaptatifs (voix, visage, tête, etc.) dans votre logiciel avec un minimum d'effort et un gain maximal.",
            "supportedFeatures": {
                "tag": "Tout en Plus, plus",
                "features": [
                    "Prise en charge de Windows et MacOS",
                    "SDK légers et intégrables pour la saisie hors ligne de la voix, du visage, de la tête et des actions rapides",
                    "Prise en charge API/webhook pour les actions de sortie personnalisées",
                    "Documentation du développeur",
                    "Exemples de projets",
                    "Transformez les commandes en automatisation et navigation de documents",
                    "Portail des développeurs pour gérer vos projets, vos clients d'authentification, vos types d'appareils, etc."
                ]
            }
        },
        "isStudentAccess": {
            "title": "Étudiant",
            "titleLong": "Éducation Céphable",
            "short": "Éducation",
            "description": "Cephable Education favorise l'apprentissage personnalisé et les classes inclusives. Cephable fonctionne hors ligne, sur appareil et ne nécessite aucune intégration tierce.",
            "supportedFeatures": {
                "tag": "Tout en Plus, plus",
                "features": [
                    "Installations d'appareils illimitées",
                    "Contrôles d'application pré-entraînés illimités",
                    "Partage illimité des contrôles d'application personnalisés"
                ]
            }
        },
        "viewProducts": "Voir les produits",
        "description": "Gérez la facturation de votre organisation, les sièges, les mises à niveau d'abonnement, le renouvellement ou l'annulation.",
        "view": "Gérer la facturation",
        "isResellerAccess": {
            "title": "Revendeur",
            "titleLong": "Revendeur Cephable",
            "description": "Cephable Reseller est une licence payante qui vous permet de créer de nouvelles organisations et d'attribuer des clés de licence. Cela inclut l'utilisation de Cephable avec votre propre suite logicielle et l'amélioration de votre expérience utilisateur.",
            "short": "Revendeur"
        },
        "error": "Veuillez contacter votre administrateur système pour gérer votre facturation.",
        "included": "Inclus avec votre licence {{licenseType}}.",
        "upgrade": {
            "description": "Effectuez une mise à niveau maintenant et faites passer vos commandes au niveau supérieur.",
            "action": "Mettre à niveau maintenant",
            "error": "Erreur lors de la mise à jour. Veuillez réessayer ultérieurement.",
            "requiredDetail": "Une licence {{licenseType}} est requise pour cette fonctionnalité. Vous pouvez passer à une version supérieure ou démarrer un essai gratuit dans les paramètres de votre compte.",
            "enableTextGeneration": "Générez du contenu en utilisant l'IA et votre voix.",
            "longDescription": "Passez à une licence payante pour accéder à toutes les fonctionnalités de Cephable. Des appareils multiples aux commandes avancées en passant par les intégrations personnalisées, Cephable vous offre tout ce dont vous avez besoin pour atteindre un niveau de productivité supérieur.",
            "compare": "Comparer les plans",
            "enableAiDictation": {
                "title": "Passez à la dictée intelligente",
                "description": "Effectuez une mise à niveau pour débloquer la dictée améliorée par l'IA. Je peux ajouter de la ponctuation, corriger les majuscules et m'adapter à votre style pour une écriture soignée sans effort supplémentaire."
            },
            "enableAiWorkflows": "Passez à la version supérieure pour automatiser vos tâches de bureau et de navigateur grâce aux flux de travail d'IA."
        },
        "isPlusAccess": {
            "title": "Plus",
            "titleLong": "Cephable Plus",
            "short": "Plus",
            "description": "Cephable Plus est destiné aux utilisateurs expérimentés qui souhaitent aller plus loin avec une voix intelligente, une dictée intelligente, des centaines de commandes d'applications et bien plus encore.",
            "supportedFeatures": {
                "tag": "Tout dans Basic, plus",
                "features": [
                    "Commandes vocales intelligentes (langage naturel)",
                    "Dictée intelligente (améliorée par l'IA)",
                    "Tâches intelligentes (Génération, Traduction, Réécriture)",
                    "Des centaines de commandes d'application pré-entraînées"
                ]
            }
        },
        "personal": {
            "short": "Basique",
            "title": "Basique",
            "titleLong": "Céphable Basic",
            "description": "Cephable Basic est gratuit à vie et conçu pour vous aider à progresser plus rapidement, à vous exprimer et à accomplir vos tâches à votre façon. Les fonctionnalités incluses dans la version Basic sont accessibles à tous les utilisateurs.",
            "upgrade": {
                "title": "Passez au niveau supérieur en matière de contrôle",
                "description": "Passez à la version Plus ou Pro pour débloquer toutes mes fonctionnalités. Plus de précision. Plus de connexions. Plus de contrôle. Plus de puissance pour booster votre productivité.",
                "featureHeading": "Voici comment je peux vous aider :",
                "control": "Je vous guide plus rapidement entre les applications et les outils grâce à votre voix ou à des actions rapides, sans interruption. Avec la Voix Intelligente, nous pouvons simplement discuter.",
                "create": "Je réécris, dicte, génère et traduis directement dans vos applications — sans copier, coller ni changer d'écran.",
                "automate": "J'exécute des tâches intelligentes et des actions rapides pour optimiser votre flux de travail. Des commandes simples aux macros complexes, je prends en charge les tâches fastidieuses pour que vous puissiez vous concentrer sur l'essentiel.",
                "local": "Intelligence artificielle entièrement locale. Aucun traitement dans le cloud."
            }
        },
        "mostPopular": "Le plus populaire",
        "subscription": {
            "options": "Options d'abonnement",
            "monthly": "Payer mensuellement",
            "billedMonthly": "/mois",
            "yearly": "Paiement annuel",
            "billedYearly": "/année"
        }
    },
    "organization": {
        "title": "Organisation",
        "titlePlural": "Organisations",
        "titleLong": "Professionnel céphable pour les organisations",
        "description": "Les organisations sont des groupes d'utilisateurs qui peuvent collaborer sur des projets et partager des ressources. Vous pouvez gérer votre équipe, les profils d’équipe, la facturation et bien plus encore ici.",
        "noAccess": {
            "title": "Accès refusé.",
            "description": "Vos autorisations ont récemment changé et vous n'avez plus accès à cette fonctionnalité. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur de votre organisation."
        },
        "member": {
            "title": "Membre",
            "titlePlural": "Membres",
            "me": "Mon adhésion",
            "description": "Les membres sont des utilisateurs qui font partie de votre organisation. Ils peuvent être affectés à différents rôles et avoir accès à différentes parties de l’organisation.",
            "edit": "Modifier les membres",
            "removed": "Vous avez été supprimé d'une équipe.",
            "removedDescription": "Vous avez été retiré de l'équipe. Vous ne pouvez plus accéder à l'organisation. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur de votre organisation.",
            "updated": "Bravo, l'adhésion de {{value}} a été mise à jour.",
            "error": "Erreur lors de la mise à jour de l'adhésion de {{value}}.",
            "delete": "Succès, {{value}} a été supprimé.",
            "deleteError": "Erreur lors de la suppression de {{value}}.",
            "deleteConfirmation": {
                "title": "Etes-vous sûr de vouloir supprimer ce membre ?",
                "description": "Une fois ce membre supprimé, il n'aura plus accès à l'organisation. Vous pourrez toujours le réinviter plus tard.",
                "confirm": "Oui, supprimer le membre"
            },
            "viewAll": {
                "title": "Voir tous les membres",
                "description": "Affichez tous les membres de votre organisation et gérez leurs rôles et autorisations."
            },
            "seats": {
                "title": "Sièges des membres",
                "description": "Chaque membre de votre organisation dispose d'un siège. Le type d'autorisations dont ils disposent peut être modifié par l'administrateur de l'organisation.",
                "stats": "sièges sur {{value}}",
                "max": "Nombre de places max.",
                "current": "Sièges actuels",
                "limit": {
                    "title": "Nombre maximal de sièges atteint",
                    "description": "Votre forfait actuel a atteint sa limite de {{ maxSeats }} sièges disponibles. Vous ne pouvez pas inviter de membres supplémentaires. Veuillez contacter votre administrateur pour mettre à niveau le forfait ou gérer votre attribution de sièges."
                },
                "updateLimit": {
                    "title": "Mettez à niveau votre forfait pour ajouter plus de sièges",
                    "description": "Votre forfait actuel a atteint le nombre maximal de sièges : {{ maxSeats }}. Effectuez une mise à niveau dès maintenant pour débloquer des sièges supplémentaires et garantir que votre équipe puisse continuer à se développer en toute transparence.",
                    "action": "Plan de mise à niveau"
                },
                "maxSeatValue": "Nombre maximal de sièges : {{value}}"
            },
            "aboutMe": "Sur moi",
            "loadError": "Erreur lors du chargement des membres de l'organisation.",
            "orgTitle": "Membres de {{value}} ",
            "emailExists": "L'e-mail existe déjà dans l'organisation. Veuillez saisir une autre adresse e-mail."
        },
        "invite": {
            "title": "Inviter",
            "titlePlural": "Invitations",
            "description": "Des invitations sont envoyées aux utilisateurs pour qu'ils rejoignent votre organisation. Vous pouvez inviter des utilisateurs à rejoindre votre organisation et leur attribuer différents rôles.",
            "edit": "Créer une nouvelle invitation",
            "view": "Afficher toutes les invitations",
            "emailRequired": "L'e-mail est requis",
            "emailInvalid": "Le courriel est invalide. S'il vous plaît, mettez une adresse email valide.",
            "emailExists": "L'e-mail dispose déjà d'une invitation d'organisation. Veuillez saisir une autre adresse e-mail.",
            "emailPlaceholder": "Entrer l'adresse e-mail",
            "expiration": "Expire ",
            "delete": "Supprimer l'invitation",
            "confirm": "Êtes-vous sûr de vouloir supprimer cette invitation ?",
            "confirmLong": "Une fois cette invitation supprimée, l'utilisateur ne pourra plus rejoindre l'organisation. Vous pourrez toujours les réinviter plus tard.",
            "accept": "Accepter l'invitation",
            "acceptSuccess": {
                "title": "Bienvenue dans l'équipe.",
                "description": "Vous avez rejoint l'organisation avec succès. ",
                "action": "Afficher votre nouvelle organisation"
            },
            "acceptError": {
                "title": "Oops. On dirait qu'il y a un problème.",
                "description": "Une erreur s'est produite lors de l'adhésion à l'organisation. Veuillez réessayer plus tard. Si le problème persiste, veuillez contacter l'administrateur de votre organisation. ",
                "action": "Retour à la page d'accueil"
            },
            "send": {
                "success": "Invitation à {{value}} envoyée.",
                "error": "Erreur lors de l'envoi de l'invitation à {{value}}.",
                "title": "Envoyer une invitation"
            },
            "viewDescription": "Voir toutes les invitations actuelles qui n'ont pas été acceptées.",
            "new": "Inviter un membre",
            "stat": "invitations actives",
            "noInvites": {
                "title": "Aucune invitation.",
                "description": "Il semble qu'il n'y ait aucune invitation active pour votre organisation."
            },
            "error": "Erreur lors du chargement des invitations.",
            "orgTitle": "Invitations de {{ value }}",
            "editDescription": "Créez une nouvelle invitation pour qu'un utilisateur rejoigne votre organisation."
        },
        "role": {
            "title": "Rôle",
            "titlePlural": "Les rôles",
            "description": "Les rôles correspondent aux différents niveaux d'accès dont un utilisateur peut disposer dans votre organisation. Vous pouvez attribuer différents rôles aux utilisateurs pour contrôler ce qu'ils peuvent faire."
        },
        "isAdmin": {
            "title": "Administrateur",
            "description": "Les administrateurs ont un accès complet à l'organisation et peuvent gérer tous les aspects de l'organisation.",
            "conflict": "Ce membre est un administrateur. Vous n'êtes pas autorisé à modifier leurs rôles."
        },
        "canViewMembers": {
            "title": "Afficher les membres",
            "description": "Les utilisateurs disposant de cette autorisation peuvent voir tous les membres de l'organisation."
        },
        "canInviteMembers": {
            "title": "Inviter des membres",
            "description": "Les utilisateurs disposant de cette autorisation peuvent inviter de nouveaux membres dans l'organisation et gérer les invitations existantes."
        },
        "canChangeMemberPermissions": {
            "title": "Modifier les rôles des membres",
            "description": "Les utilisateurs disposant de cette autorisation peuvent modifier le rôle des autres membres de l'organisation."
        },
        "canRemoveMembers": {
            "title": "Supprimer des membres",
            "titleSingle": "Supprimer un membre",
            "action": "Retirer",
            "description": "Les utilisateurs disposant de cette autorisation peuvent supprimer d'autres membres de l'organisation.",
            "confirm": "Êtes-vous sûr de vouloir supprimer ce membre de l'organisation?",
            "confirmLong": "Une fois que vous aurez supprimé ce membre, il n’aura plus accès à l’organisation. Vous pourrez toujours les réinviter plus tard."
        },
        "canCreateAuthClients": {
            "title": "Créer des clients d'authentification",
            "description": "Les utilisateurs disposant de cette autorisation peuvent créer de nouveaux clients d'authentification pour l'organisation."
        },
        "canManageBilling": {
            "title": "Gérer la facturation",
            "description": "Les utilisateurs disposant de cette autorisation peuvent gérer les paramètres de facturation de l'organisation.",
            "error": "Vous n'êtes pas autorisé à gérer la facturation de cette organisation."
        },
        "metrics": {
            "lineChart": {
                "title": "Connexions Simultanées Moyennes",
                "description": "Ce graphique montre les connexions simultanées moyennes pour l'organisation et les données du projet au fil du temps.",
                "max": "Connexions Max: {{maxConnections}}",
                "project": "Total du Projet",
                "org": "Organisation Total"
            },
            "title": "Métrique",
            "description": "Les métriques sont des points de données qui vous aident à comprendre comment votre organisation utilise Cephable.",
            "view": "Afficher les métriques",
            "orgTitle": "Métriques de {{ valeur }}",
            "manage": {
                "title": "Indicateurs de performance",
                "description": "Téléchargez ou effacez les mesures de performances collectées lors de l’inférence du modèle."
            },
            "download": {
                "button": "Télécharger les métriques",
                "success": "Le fichier de métriques a été enregistré dans votre dossier Téléchargements.",
                "error": "Échec du téléchargement du fichier de métriques.",
                "noFile": "Aucun fichier de métriques trouvé. Essayez d'abord d'exécuter le modèle."
            },
            "clear": {
                "button": "Des indicateurs clairs",
                "success": "Les métriques ont été effacées.",
                "error": "Échec de l'effacement du fichier de métriques.",
                "confirm": {
                    "title": "Indicateurs de performance clairs",
                    "description": "Voulez-vous vraiment effacer tous les indicateurs de performance enregistrés ? Cette action est irréversible.",
                    "cancel": "Annuler",
                    "confirm": "Des indicateurs clairs"
                }
            }
        },
        "noOrg": {
            "title": "Aucune licence associée.",
            "description": "Vous n'êtes actuellement associé à aucune licence ni à aucun groupe de développeurs. L'accès au portail est réservé aux utilisateurs disposant d'une licence Cephable payante. Pour exploiter pleinement le potentiel de Cephable, commencez un essai gratuit."
        },
        "projects": {
            "title": "Projets",
            "description": "Utilisez des projets pour gérer l'accès sécurisé, configurer les interactions des appareils et rationaliser la manière dont vos applications envoient et reçoivent des commandes sur différentes plates-formes.",
            "name": "Nom de l'application",
            "stats": {
                "title": "Statistiques du projet",
                "connections": "Connexions totales",
                "all": {
                    "title": "Toutes les mesures du projet",
                    "description": "Métriques agrégées pour tous les projets associés à {{ orgName }}"
                },
                "card": "projets sur {{value}}",
                "users": "nombre total d'utilisateurs depuis {{date}}",
                "avgUsers": "Nombre moyen mensuel d'utilisateurs.",
                "concurrent": {
                    "title": "Nombre moyen de connexions simultanées au cours des {{days}} derniers jours",
                    "label": "Moy. simultanée",
                    "max": "Connexions maximales",
                    "overage": "Excédent",
                    "description": "Les connexions simultanées correspondent au nombre d'utilisateurs connectés à votre projet en même temps. Cette mesure vous aide à comprendre combien d'utilisateurs utilisent votre application simultanément."
                }
            },
            "projectType": {
                "title": "Type de projet",
                "description": "Les types de projets sont utilisés pour catégoriser vos projets et nous aider à choisir les SDK qui vous conviennent."
            },
            "accessDenied": {
                "generic": "Vous n'avez pas accès à ce projet.",
                "title": "Accès refusé.",
                "description": "Vous n'avez pas accès aux projets pour les consulter, les créer, les modifier ou les supprimer. Veuillez contacter votre administrateur pour y accéder."
            },
            "upgrade": {
                "title": "Mise à niveau vers le SDK Cephable",
                "description": "Cephable peut être intégré directement dans votre application, jeu ou service à l'aide de nos SDK. Les projets ne sont actuellement pas disponibles avec votre compte. Si vous pensez qu'il y a une erreur, veuillez contacter support@cephable.com.",
                "shortDescription": "Les projets ne sont actuellement pas disponibles avec votre compte. Contactez-nous pour effectuer une mise à niveau."
            },
            "limit": {
                "title": "Vous voulez plus de projets ?",
                "error": "Limite du projet atteinte.",
                "description": "Vous avez atteint le nombre maximum de projets pour votre organisation. Veuillez contacter votre administrateur pour mettre à niveau votre compte."
            },
            "create": {
                "title": "Créer un projet",
                "titleLong": "Commençons.",
                "first": {
                    "title": "Démarrez votre projet.",
                    "description": "Il semble que vous n'ayez pas encore créé de projet. Les clés et les appareils clients sont essentiels pour sécuriser la communication entre vos applications et nos services. Avec une clé client, vous pourrez intégrer les commandes vocales et de mouvement de la tête dans vos applications rapidement et en toute sécurité."
                },
                "details": {
                    "title": "Détails du projet",
                    "description": "Créez un nouveau projet pour gérer l'autorisation de votre application, les fonctionnalités de votre appareil et les intégrations SDK. Suivez les étapes ci-dessous pour configurer des interactions sécurisées et personnalisables pour vos utilisateurs."
                }
            },
            "sdk": {
                "title": "Télécharger le SDK",
                "description": "Accédez à notre puissant SDK développé pour faciliter les contrôles adaptatifs.",
                "select": {
                    "title": "Sélectionner le SDK",
                    "description": "Sélectionnez le SDK que vous souhaitez utiliser pour ce projet. Nos SDK permettent une intégration transparente des commandes adaptatives de voix et de mouvement de la tête sur différentes plateformes."
                }
            },
            "clients": {
                "title": "Autorisation des clients",
                "description": "Les clients d'autorisation gèrent l'accès sécurisé à vos applications. Définissez un client d'autorisation pour authentifier les utilisateurs et contrôler les interactions avec votre application.",
                "settings": "Paramètres d'autorisation",
                "configure": "Configurer le client d'autorisation",
                "create": "Créer un client d'autorisation",
                "max": "Projets max : {{value}}"
            },
            "secret": {
                "title": "Secret du client",
                "created": "Votre secret client a été créé.",
                "description": "Votre secret client ne sera affiché qu'une seule fois. Copiez-le maintenant et stockez-le dans un endroit sûr et sécurisé. <br> <br> Utilisez-le uniquement pour votre propre développement. Ne le partagez pas avec des services ou des applications tiers.",
                "copy": "Copie secrète",
                "rotate": {
                    "title": "Faire pivoter le secret client",
                    "description": "AVERTISSEMENT : cette action révoquera votre secret client existant et créera un nouveau secret client. Cela vous obligera à mettre à jour toutes vos utilisations existantes dans toutes vos applications. Cette action ne peut pas être annulée.",
                    "error": "Erreur lors de la rotation du secret. Veuillez réessayer plus tard."
                }
            },
            "key": {
                "title": "Clé client",
                "view": "Afficher la clé client",
                "delete": {
                    "title": "Supprimer la clé client",
                    "description": "AVERTISSEMENT : cette action supprimera votre clé client existante et tous les paramètres associés. Cette action ne peut pas être annulée.",
                    "error": "Erreur lors de la suppression de votre clé client.",
                    "success": "Votre projet a été supprimé."
                },
                "copy": "Copier la clé"
            },
            "tokenRedirect": {
                "title": "URL de redirection de jeton",
                "description": "Les URL de redirection de jetons sont les points de terminaison où les jetons d'accès sont envoyés une fois l'authentification terminée. Ces URL permettent à votre application de recevoir en toute sécurité les jetons nécessaires pour accéder aux données et services utilisateur."
            },
            "authRedirect": {
                "title": "URL de redirection du code d'autorisation",
                "description": "L'URL de redirection AuthCode est le point de terminaison où les codes d'autorisation sont envoyés après qu'un utilisateur a accordé l'autorisation à votre application. Cette URL est essentielle dans les flux OAuth, car elle garantit la transmission sécurisée du code d'autorisation du serveur d'autorisation à votre application, vous permettant ainsi de demander des jetons d'accès au nom de l'utilisateur."
            },
            "scopes": {
                "title": "Portées",
                "titleLong": "Portées des autorisations API",
                "configure": "Définir les périmètres",
                "description": "Les portées définissent les autorisations dont disposera ce client d'autorisation. Définissez des portées pour limiter l'accès à des données et fonctionnalités spécifiques, en veillant à ce que les utilisateurs n'obtiennent que l'accès dont ils ont besoin.",
                "manage": "Gérer les portées d'autorisation"
            },
            "deviceScopes": {
                "title": "Types d'appareils associés",
                "titleLong": "Types d'appareils autorisés",
                "action": "Ajouter un nouveau type d'appareil",
                "configure": "Configurer les types d'appareils autorisés",
                "descriptionShort": "Définissez quel type d’appareils peuvent accéder à ce projet.",
                "titles": "Types d'appareils associés",
                "description": "Le type d'appareil définit les autorisations et les niveaux d'accès dont dispose un appareil dans votre application. En attribuant des types d'appareils spécifiques, vous pouvez contrôler les actions et les données auxquelles chaque appareil peut accéder, garantissant ainsi que votre application reste sécurisée et conforme à vos politiques de confidentialité."
            },
            "deviceType": {
                "title": "Types d'appareils",
                "description": "Un DeviceType définit une catégorie d'appareils, détaillant leurs capacités d'entrée/sortie et les fonctionnalités prises en charge (par exemple, la voix, les gestes, les types de contrôleur). Il garantit que seuls les appareils autorisés peuvent interagir avec une application, permettant un accès limité via des configurations d'appareils spécifiques, telles que Xbox ou PlayStation.",
                "action": "Créer un type d'appareil",
                "name": "Nom du type d'appareil",
                "descriptionLong": "Description du type d'appareil",
                "features": {
                    "title": "Fonctionnalités prises en charge",
                    "description": "Définissez les entrées et les sorties prises en charge par votre application. Cela nous aide à optimiser l'expérience utilisateur sur Cephable.",
                    "supportsVoiceInput": "Saisie vocale",
                    "supportsPhysicalInput": "Entrée physique",
                    "supportsKeyboardOutput": "Sortie clavier",
                    "supportsPlayStationControllerOutput": "Manette PlayStation",
                    "supportsFaceInput": "Saisie faciale",
                    "supportsGestureInput": "Saisie gestuelle",
                    "supportsXboxControllerOutput": "Manette Xbox",
                    "supportsDigitalExtensions": "Extensions numériques",
                    "supportsPhysicalExtensions": "Extensions physiques",
                    "supportsNintendoControllerOutput": "Manette Nintendo",
                    "supportsGenericControllerOutput": "Sortie du contrôleur générique"
                },
                "canAutoStart": {
                    "title": "Prend en charge les démarrages à contrôle automatique",
                    "description": "[canAutoStart] si activé, le SDK vérifiera les paramètres utilisateur et tentera de démarrer immédiatement les commandes de la caméra ou du microphone après la connexion de l'utilisateur."
                },
                "isSupported": {
                    "title": "Actif",
                    "description": "[isSupported] Si cette option est désactivée, Cephable n'enverra, ne recevra et n'accusera réception d'aucun appareil utilisateur associé à cette option. Équivalent à obsolète."
                },
                "locale": {
                    "title": "Langue par défaut",
                    "description": "[defaultLocale] Paramètres régionaux par défaut pour ce type d'appareil. Ils seront utilisés comme langue par défaut pour l'appareil.",
                    "support": "Langues prises en charge",
                    "warn": "** Il semble que vous ayez configuré des contrôles personnalisés. Veuillez vous assurer que vous avez mis à jour les contrôles personnalisés pour les langues associées.**",
                    "name": "{{lang}} - Nom du type d'appareil",
                    "langDescription": "{{lang}} - Description"
                },
                "customControls": {
                    "title": "Contrôles personnalisés",
                    "object": "{{lang}} - Objet de contrôles personnalisés",
                    "description": "Les contrôles personnalisés sont une option avancée permettant aux utilisateurs de configurer et de modifier manuellement les contrôles d'application associés à cet appareil. Si vous souhaitez que les utilisateurs contrôlent votre appareil directement depuis Cephable, vous devez enregistrer les contrôles de votre appareil ici. Consultez l'API Cephable pour plus de détails sur les options.",
                    "addControl": "Ajouter un contrôle",
                    "empty": "Aucun contrôle personnalisé pour le moment. Utilisez « Ajouter un contrôle » pour créer votre premier.",
                    "untitled": "Contrôle sans titre",
                    "controlId": "ID de contrôle",
                    "controlIdHelp": "Identifiant unique de ce contrôle. Définissez-le avant d'enregistrer ; il ne pourra plus être modifié par la suite.",
                    "fallback": "Retomber",
                    "controlName": "Nom du contrôle",
                    "controlDescription": "Description du contrôle",
                    "defaultCommandsLabel": "Commandes vocales par défaut",
                    "defaultCommandsHelp": "Voici les commandes vocales par défaut que les utilisateurs voient pour cette fonction dans la langue actuelle.",
                    "sharedAcrossLanguages": "Partagé dans toutes les langues",
                    "sharedAcrossLanguagesHelp": "La modification de ces champs met à jour la valeur pour toutes les langues simultanément.",
                    "iconUrl": "URL de l'icône",
                    "contextGroupName": "Groupe de contexte",
                    "isProfileControl": "Contrôle du profil",
                    "isPrefixVoiceCommand": "Commande vocale préfixée",
                    "allowWhenDictating": "Autoriser lors de la dictée",
                    "allowsHold": "Autorise la mise en attente",
                    "isDeprecated": "Déprécié",
                    "requiresEmployeeAccess": "Nécessite un accès employé",
                    "requiresStudentAccess": "Nécessite un accès étudiant",
                    "requiresGenericLicense": "Nécessite une licence générique",
                    "requiresPlusAccess": "Nécessite un abonnement Plus",
                    "allIncomplete": "Toutes les langues présentent des contrôles personnalisés incomplets. Veuillez compléter au moins une langue avant d'enregistrer.",
                    "savedWithIncomplete": "Enregistré. Paramètres régionaux des contrôles personnalisés incomplets non enregistrés : {{incompleteLocales}}"
                },
                "success": {
                    "title": "Succès!",
                    "description": "Vous avez créé un nouveau type d'appareil. {{name}} Vous pouvez désormais mettre à jour la portée de votre appareil client d'autorisation selon vos besoins."
                },
                "id": "ID du type d'appareil",
                "throttleRules": {
                    "title": "Règles de commande des gaz",
                    "description": "Configurez les règles de limitation pour contrôler le flux des commandes et les restrictions d'entrée pour ce type de périphérique.",
                    "disableVoiceInput": "Désactiver la saisie vocale",
                    "disableHotkeyInput": "Désactiver la saisie par raccourci clavier",
                    "disableCameraInput": "Désactiver l'entrée caméra",
                    "disableMultiInputs": "Désactiver les entrées multiples",
                    "maximumCommandsPerSecond": "Nombre maximal de commandes par seconde",
                    "maximumCommandsPerMinute": "Nombre maximal de commandes par minute",
                    "maximumMacroLength": "Longueur maximale des macros",
                    "jitter": {
                        "title": "Gigue de synchronisation",
                        "description": "Ajoutez des variations aléatoires aux durées de maintien et de pause pour créer des schémas d'entrée plus naturels.",
                        "holdTimeJitterMin": "Gigue du temps de maintien min (ms)",
                        "holdTimeJitterMax": "Gigue maximale du temps de maintien (ms)",
                        "pauseTimeJitterMin": "Temps de pause (ms)",
                        "pauseTimeJitterMax": "Temps de pause : gigue maximale (ms)"
                    },
                    "incompatibleActions": {
                        "title": "Groupes d'action incompatibles",
                        "description": "Définir des groupes d'actions qui ne peuvent pas coexister dans la même macro.",
                        "addGroup": "Ajouter un groupe",
                        "removeGroup": "Supprimer le groupe",
                        "addAction": "Ajouter une action",
                        "removeAction": "Supprimer l'action",
                        "reason": "Raison",
                        "reasonPlaceholder": "Pourquoi ces actions sont incompatibles",
                        "eventType": "Type d'événement",
                        "key": "Clé",
                        "customActionId": "ID d'action personnalisée",
                        "emptyGroup": "Aucune action dans ce groupe. Ajoutez au moins deux actions."
                    },
                    "requiredPause": {
                        "title": "Pause requise entre les actions",
                        "description": "Définissez des paires d'actions qui nécessitent une pause minimale entre elles dans la même macro.",
                        "addRule": "Ajouter une règle",
                        "removeRule": "Supprimer la règle",
                        "actionA": "Action A",
                        "actionB": "Action B",
                        "minimumPause": "Pause minimale (ms)",
                        "bidirectional": "Bidirectionnel",
                        "bidirectionalHelp": "Lorsqu'elle est activée, la pause est requise dans les deux sens (A→B et B→A)."
                    },
                    "macroStepRules": {
                        "title": "Règles des étapes de macro",
                        "holdTimeJitterMin": "Maintien de la gigue min (ms)",
                        "holdTimeJitterMax": "Maintien de la gigue max (ms)"
                    }
                }
            },
            "view": "Voir les projets",
            "error": "Erreur lors du chargement des projets.",
            "type": {
                "title": "Type d'implémentation"
            },
            "originHost": {
                "title": "Hôte d'origine",
                "description": "L'URL qui servira de source principale pour la demande et les données lors des interactions API."
            },
            "orgTitle": "Projets de {{ valeur }}"
        },
        "viewOrganization": "Voir L'organisation",
        "update": "Votre organisation a été mise à jour ! Actualisation de l'application.",
        "error": "Erreur lors du chargement de l'organisation. Veuillez réessayer ultérieurement.",
        "new": {
            "name": {
                "label": "Nom de l'organisation",
                "placeholder": "Entrez le nom de votre organisation"
            },
            "description": {
                "label": "Description de l'organisation",
                "placeholder": "Quels sont vos objectifs en utilisant Cephable Professional ?"
            },
            "details": "Détails de l'organisation"
        },
        "expired": {
            "user": "Il semblerait que votre licence Cephable ait expiré. Vous êtes donc passé à la version gratuite Cephable Basic. Pour la renouveler, veuillez contacter l'administrateur de votre organisation.",
            "admin": "Il semblerait que votre licence Cephable ait expiré. Vous êtes donc passé à la version gratuite Cephable Basic. Veuillez renouveler votre licence pour continuer à utiliser les fonctionnalités avancées.",
            "multiple": "Il semblerait que vos licences Cephable aient expiré. Vous êtes donc passé à la version gratuite Cephable Basic. Veuillez renouveler au moins une de vos licences pour continuer à utiliser les fonctionnalités avancées.",
            "dialog": {
                "title": "Sélectionnez une organisation",
                "description": "Plusieurs organisations sont associées à votre compte. Veuillez sélectionner l'organisation que vous souhaitez renouveler."
            },
            "title": "Votre licence Cephable a expiré",
            "titlePlural": "Vos licences Cephable ont expiré",
            "banner": "Il semblerait que votre licence Cephable ait expiré. Vous êtes donc passé à la version gratuite Cephable Basic. En renouvelant votre licence, vous bénéficierez de fonctionnalités supplémentaires telles que les commandes vocales améliorées, les tâches intelligentes basées sur l'IA et de nombreuses commandes d'applications prédéfinies."
        },
        "orgName": "Nom de l'organisation",
        "menu": {
            "title": "Menu Organisation",
            "view": "Voir le menu",
            "expand": "Développer le menu"
        },
        "settings": {
            "title": "Paramètres de l'organisation",
            "description": "Gérez la facturation, le nom, la description et les ressources de votre organisation.",
            "view": "Afficher les paramètres",
            "general": {
                "title": "Général"
            },
            "resources": {
                "edit": "Modifier les ressources",
                "description": "Utilisez l'éditeur Markdown sur la gauche pour mettre à jour et formater des ressources utiles pour tous les membres de l'organisation. Au fur et à mesure que vous saisissez du texte, l'aperçu sur la droite montre comment votre contenu apparaîtra aux utilisateurs. Vous pouvez ajouter des titres, des listes, des liens et d'autres éléments de mise en forme à l'aide de la syntaxe Markdown. Les modifications seront visibles pour les membres une fois enregistrées."
            },
            "other": {
                "title": "Autres paramètres",
                "description": "Gérez la facturation, le nom, la description et les ressources de votre organisation."
            }
        },
        "managed": {
            "title": "Organisation gérée",
            "titlePlural": "Organisations gérées",
            "description": "Les organisations gérées sont des organisations gérées par un revendeur Cephable. Les revendeurs peuvent gérer votre équipe, les profils d'équipe, la facturation et bien plus encore ici.",
            "error": "Erreur lors du chargement des organisations gérées.",
            "empty": {
                "title": "Aucune organisation gérée trouvée.",
                "description": "Il ne semble pas qu'aucune organisation gérée ne corresponde à ces critères. Ou vos clés de licence n'ont pas encore été activées."
            },
            "titleShort": "Géré"
        },
        "canManageChildOrganizations": {
            "title": "Gérer les organisations pour enfants",
            "description": "Les utilisateurs disposant de cette autorisation peuvent créer et gérer des organisations enfants en tant qu’administrateur."
        },
        "canViewAnalytics": {
            "title": "Voir les analyses",
            "description": "Les utilisateurs disposant de cette autorisation peuvent afficher les mesures et les analyses de l’organisation."
        },
        "create": "Créer une nouvelle organisation",
        "orgCustomBillingUrl": {
            "title": "URL de facturation personnalisée",
            "description": "Il s'agit d'une URL personnalisée qui sera utilisée pour rediriger l'utilisateur vers votre système de facturation (celui du revendeur). Doit commencer par « https:// » ou « mailTo : »"
        },
        "upgrade": {
            "existing": {
                "title": "Vous faites partie d'une licence existante.",
                "description": "Veuillez effectuer une mise à niveau en cliquant sur « {{action}} » dans le menu latéral."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "IA générative désactivée",
                "description": "Votre organisation a désactivé l'accès aux fonctionnalités d'IA générative. Veuillez contacter l'administrateur de votre organisation pour plus d'informations."
            },
            "isRemoteControlDisabled": {
                "title": "Synchronisation entre appareils désactivée",
                "description": "Votre organisation a désactivé l'accès à la synchronisation. Vous ne pourrez donc pas utiliser notre application compagnon ni contrôler les appareils externes. Veuillez contacter l'administrateur de votre organisation pour plus d'informations."
            }
        },
        "troubleshooting": {
            "title": "Dépannage",
            "editorDescription": "[Facultatif] Cette section est visible par tous les utilisateurs via la page des détails de connexion dans les applications mobiles et de bureau Cephable.",
            "description": "Si vous rencontrez des problèmes avec Cephable, essayez les étapes ci-dessous pour résoudre les problèmes courants."
        },
        "onboarding": {
            "title": "Intégration",
            "editorDescription": "[Facultatif] Un message d'accueil s'affiche lorsque ce type d'appareil est ajouté à votre compte. C'est l'endroit idéal pour fournir des instructions sur la configuration et l'utilisation de cet appareil avec votre application."
        },
        "documents": "Documents",
        "completionStatus": {
            "title": "État d'achèvement",
            "error": "",
            "complete": "Complet.",
            "incomplete": "Incomplet."
        },
        "metadata": {
            "title": "Métadonnées",
            "urlError": "L'URL doit commencer par http:// ou https://",
            "metatitle": {
                "label": "Meta Title",
                "placeholder": "Saisissez un titre court"
            },
            "shortDescription": {
                "label": "Description courte",
                "placeholder": "Saisissez une brève description (150 caractères maximum)"
            },
            "externalLink": {
                "label": "URL du lien externe",
                "placeholder": "https://example.com/device-info",
                "description": "Un lien direct vers un site web ou une ressource externe fournissant des informations supplémentaires sur la première configuration de cet appareil. Si vous utilisez ce lien, nous n'utiliserons pas le balisage Markdown de la liste des clients."
            },
            "iconUrl": {
                "label": "URL de l'icône de l'appareil",
                "placeholder": "https://example.com/device-icon.png",
                "description": "Lien direct vers une image représentant ce type d'appareil. Cette icône sera affichée dans l'application Cephable et sur les listes d'appareils."
            },
            "darkModeIconUrl": {
                "label": "URL de l'icône de l'appareil en mode sombre",
                "placeholder": "https://example.com/device-icon-dark.png",
                "description": "Lien direct vers une image représentant ce type d'appareil en mode sombre. Cette icône s'affichera dans l'application Cephable et sur les listes d'appareils lorsque le mode sombre est activé."
            },
            "editorDescription": "Lorsque votre appareil est sélectionné pour figurer dans l'application Cephable en tant qu'extension ou connexion, nous utilisons ces informations pour les afficher aux utilisateurs qui configurent de nouvelles connexions."
        },
        "client-listing": {
            "title": "Liste des clients",
            "editorDescription": "Instructions détaillées pour les nouveaux utilisateurs afin de configurer des connexions avec ce type d'appareil. Ce texte s'affichera dans l'application Cephable lors de l'ajout d'une nouvelle connexion."
        },
        "canAccessOrganizationProfiles": {
            "title": "Afficher les commandes de l'application Organisation",
            "description": "Les utilisateurs disposant de cette autorisation peuvent consulter les commandes de l'application d'organisation associées à cette organisation."
        },
        "canEditOrganizationProfiles": {
            "title": "Gérer les contrôles de l'application de l'organisation",
            "description": "Les utilisateurs disposant de cette autorisation peuvent créer, modifier et supprimer les contrôles d'application d'organisation associés à cette organisation."
        },
        "profiles": {
            "title": "Contrôles de l'application Organisation",
            "description": "Les contrôles d'application d'organisation sont des profils partagés permettant de distribuer les contrôles d'application au sein de votre organisation ou de les partager avec vos utilisateurs d'intégration.",
            "view": "Afficher les commandes de l'application Organisation",
            "editDescription": "Modifiez les commandes de l'application d'organisation pour personnaliser les paramètres.",
            "empty": "Aucune application de contrôle d'organisation trouvée. Créez-en une pour commencer.",
            "error": "Erreur lors du chargement des commandes de l'application d'organisation.",
            "titleShort": "Commandes de l'application"
        },
        "canViewAuthClients": {
            "title": "Voir les projets",
            "description": "Les utilisateurs disposant de cette autorisation peuvent consulter les clients d'authentification et les projets de l'organisation."
        },
        "governance": {
            "title": "Gouvernance",
            "orgTitle": "{{valeur}} Gouvernance",
            "description": "Définissez les règles de sécurité qui encadrent l'utilisation de l'assistant Cephable par votre équipe.",
            "automation": {
                "title": "Règles d'automatisation",
                "description": "Contrôlez les domaines où Cephable peut automatiser et fournissez des instructions qui façonnent son comportement pour votre organisation.",
                "rulesTitle": "Règles",
                "create": "Créer une règle d'automatisation",
                "edit": "Modifier la règle d'automatisation",
                "created": "Règle d'automatisation créée.",
                "updated": "Règle d'automatisation mise à jour.",
                "deleted": "Règle d'automatisation supprimée.",
                "loadError": "Impossible de charger les règles d'automatisation.",
                "saveError": "Impossible d'enregistrer la règle d'automatisation.",
                "deleteError": "Impossible de supprimer la règle d'automatisation.",
                "searchPlaceholder": "Règles de recherche par application, site web, invite ou étendue",
                "promptOnly": "l'instruction d'assistant",
                "editorDescription": "Choisissez le type de règle, ciblez éventuellement une application ou un site web, et ajoutez des instructions claires pour Cephable.",
                "validation": "Ajoutez une application ou un site web, des instructions d'assistance, ou les deux.",
                "appOrDomain": {
                    "label": "Application ou site web",
                    "helper": "Utilisez un nom d'application ou un domaine reconnaissable, comme Slack, gmail.com ou github.com."
                },
                "prompt": {
                    "label": "Instructions de l'assistant",
                    "helper": "Décrivez ce que Cephable doit ou ne doit pas faire. Veillez à ce que les instructions soient précises et applicables."
                },
                "type": {
                    "label": "Type de règle",
                    "block": "Bloc",
                    "allow": "Permettre"
                },
                "scope": {
                    "organization": "À l'échelle de l'organisation",
                    "organizationDescription": "Appliquez cette règle à tous les membres actuels et futurs.",
                    "members": "membres spécifiques",
                    "membersDescription": "Enregistrez la règle, puis attribuez-la uniquement aux membres qui en ont besoin."
                },
                "assign": "Attribuer des membres",
                "delete": {
                    "title": "Supprimer la règle d'automatisation ?",
                    "description": "Cela supprime définitivement la règle et toutes les affectations de membres qui l'utilisent."
                },
                "empty": {
                    "title": "Aucune règle d'automatisation pour le moment.",
                    "description": "Créez une règle pour définir le premier garde-fou de votre organisation en matière d'assistance aux assistants."
                },
                "guidance": {
                    "block": {
                        "title": "Restreindre les applications et les sites web",
                        "description": "Utilisez une règle de blocage avec un nom d'application ou un domaine pour empêcher Cephable d'interagir avec celui-ci."
                    },
                    "prompt": {
                        "title": "Ajouter le contexte de l'assistant",
                        "description": "Utilisez les instructions de l'assistant pour communiquer les politiques, les vérifications requises ou les méthodes de travail sécuritaires."
                    },
                    "scope": {
                        "title": "Choisissez la bonne lunette",
                        "description": "Appliquer des règles de sécurité communes à l'ensemble de l'organisation, ou limiter les exceptions à certains membres."
                    }
                },
                "assignment": {
                    "title": "Attribuer une règle à un membre",
                    "description": "Gérer l'affectation spécifique au membre pour {{value}}.",
                    "memberLabel": "Membre",
                    "apply": "Appliquer la règle",
                    "remove": "Supprimer la règle",
                    "assigned": "Cette règle est attribuée au membre sélectionné.",
                    "notAssigned": "Cette règle n'est pas attribuée au membre sélectionné.",
                    "applied": "Règle appliquée au membre.",
                    "removed": "Règle supprimée pour le membre.",
                    "loadError": "Impossible de charger les membres de l'organisation.",
                    "statusError": "Impossible de charger les règles d'automatisation de ce membre.",
                    "saveError": "Impossible de mettre à jour l'affectation du membre."
                }
            },
            "moreControls": {
                "title": "D'autres mécanismes de contrôle de la gouvernance sont en préparation.",
                "description": "Ce hub s'enrichira de commandes permettant de contrôler les fonctionnalités que votre équipe peut utiliser et les fournisseurs auxquels elle peut se connecter.",
                "skills": "Compétences",
                "mcp": "Outils MCP",
                "ai": "Apportez votre propre IA"
            }
        },
        "canManageGlobalAutomationRules": {
            "title": "Gérer la gouvernance",
            "description": "Les utilisateurs disposant de cette autorisation peuvent gérer les règles d'automatisation de l'organisation et les affectations des membres."
        }
    },
    "customControls": {
        "title": "Contrôles globaux et des appareils",
        "prefixDisclaimer": " Il s'agit d'un contrôle de préfixe ; il écoutera les mots après la commande, puis recherchera la phrase suivante pour trouver des correspondances.",
        "allowPausedDisclaimer": " Cette commande fonctionnera même lorsque le microphone est en pause.",
        "conflictIndicators": {
            "warn": "Avertissement: ",
            "title": "Conflits de configuration d'entrée détectés",
            "globalControls": "Conflits de configuration de contrôle global",
            "deviceControls": "Conflits de configuration du contrôle des périphériques",
            "usedInput": " est utilisé comme entrée pour ",
            "description": "Certaines entrées de vos contrôles globaux et d'appareil sont également utilisées dans un ou plusieurs de vos contrôles d'application. Cela peut entraîner des conflits avec Cephable. Dans ce cas, nous privilégierons toujours le contrôle d'application par rapport au contrôle global ou d'appareil.",
            "item": "L&#39;entrée <strong>{{value}}</strong> est utilisée dans les contrôles de votre application : ",
            "globalDescription": "Les contrôles globaux suivants ont des entrées en conflit avec les contrôles de votre application.",
            "deviceDescription": "Les commandes de l'appareil suivantes ont des entrées en conflit avec les commandes de votre application."
        },
        "globalControls": {
            "title": "Contrôles globaux",
            "empty": "Vous n'avez pas encore de contrôles globaux. Cliquez ci-dessous pour en créer un.",
            "edit": "Modifier les contrôles globaux",
            "description": "Les commandes globales sont toujours disponibles, quels que soient les contrôles de l'application ou l'appareil utilisé. Certaines fonctionnent même lorsque les commandes de votre microphone ou de votre appareil photo sont en pause."
        },
        "deviceControls": {
            "title": "Contrôles des appareils",
            "empty": "Vous n'avez pas encore de commandes d'appareil. Cliquez ci-dessous pour en créer un.",
            "edit": "Modifier les contrôles de l'appareil",
            "controls": {
                "cephable-open-app": {
                    "success": "Ouvrir l'application : {{value}}",
                    "error": "Impossible de trouver l'application : {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["fermer"],
                    "name": "Fermer l'application par nom",
                    "description": "Utilisez cette commande avec les commandes vocales pour fermer une application sur votre ordinateur par son nom.",
                    "success": "Fermer l'application : {{value}}",
                    "error": "Impossible de trouver l'application : {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimiser"],
                    "name": "Réduire l'application actuellement sélectionnée.",
                    "description": "Utilisez cette commande avec les commandes vocales pour minimiser l’application actuellement sélectionnée.",
                    "success": "Minimisez le succès des applications ciblées !",
                    "error": "Erreur lors de la minimisation de l'application focalisée."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["maximiser"],
                    "name": "Maximisez l'application actuellement sélectionnée.",
                    "description": "Utilisez cette commande avec les commandes vocales pour maximiser l'application actuellement sélectionnée.",
                    "success": "Maximisez le succès de votre application ciblée !",
                    "error": "Erreur lors de la minimisation de l'application focalisée."
                },
                "cephable-generate-text": {
                    "commands": ["générer"],
                    "name": "Générez du texte en fournissant l'invite suivant cette commande.",
                    "description": "Utilisez cette commande avec des commandes vocales suivies de votre invite pour générer du texte associé."
                },
                "cephable-stop-generate-text": {
                    "commands": [
                        "arrêter de générer",
                        "arrêter la génération",
                        "annuler générer",
                        "annuler la génération"
                    ],
                    "name": "Arrêtez de générer du texte.",
                    "description": "Utilisez cette commande avec les commandes vocales pour arrêter de générer du texte"
                },
                "cephable-open-panel": {
                    "commands": ["afficher le panneau"],
                    "name": "Ouvrir le panneau Cephable",
                    "description": "Utilisez cette commande avec les commandes vocales pour ouvrir le panneau Cephable."
                },
                "cephable-close-panel": {
                    "commands": ["masquer le panneau"],
                    "name": "Masquer le panneau Cephable",
                    "description": "Utilisez cette commande avec les commandes vocales pour masquer ou réduire le panneau Cephable."
                },
                "cephable-close-focused-app": {
                    "commands": ["courant proche"],
                    "name": "Fermez l'application actuellement sélectionnée.",
                    "description": "Utilisez cette commande avec les commandes vocales pour fermer l’application actuellement sélectionnée.",
                    "success": "Fermer l'application actuelle avec succès !",
                    "error": "Erreur lors de la fermeture de l'application actuelle."
                },
                "cephable-rewrite-text": {
                    "commands": ["récrire"],
                    "name": "Réécrivez le texte en fournissant l'invite suivant cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales suivies de votre invite pour réécrire votre texte en surbrillance actuel."
                },
                "cephable-summarize-text": {
                    "commands": ["résumer"],
                    "name": "Résumez le texte en fournissant l’invite suivant cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales suivies de votre invite pour résumer votre texte actuellement en surbrillance."
                },
                "cephable-translate-text": {
                    "commands": ["traduire"],
                    "name": "Traduisez le texte en fournissant l'invite suivant cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales suivies de votre invite pour traduire votre texte actuellement en surbrillance."
                },
                "cephable-click-by-name": {
                    "commands": ["robinet", "frapper", "naviguer vers", "aller à"],
                    "name": "Appuyez sur l'élément par nom",
                    "description": "Touchez un élément de la page par son nom, par exemple « toucher enregistrer », pour cliquer sur un bouton nommé « Enregistrer ». Cela revient à utiliser la souris vocale : cliquer sur des éléments par commandes vocales plutôt qu’avec une souris."
                },
                "cephable-automate": {
                    "commands": [
                        "automatiser",
                        "essayer",
                        "avoir céphable",
                        "effectuer un flux de travail pour",
                        "travailler sur"
                    ],
                    "name": "Exécutez un flux de travail d'IA en décrivant une tâche après cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales, suivie d'une tâche, telle que « automatiser l'envoi d'un e-mail à mon équipe », et Cephable l'exécutera sous forme de flux de travail d'IA."
                }
            },
            "description": "Les commandes de l'appareil sont liées à l'appareil ou à la connexion que vous utilisez. Elles sont disponibles sans avoir à les ajouter aux commandes de votre application et sont particulièrement utiles pour les fonctionnalités ou événements uniquement pris en charge sur certains appareils."
        },
        "resetControls": {
            "title": "Réinitialiser les Commandes",
            "description": "La langue de votre voix a changé depuis la dernière mise à jour de vos commandes. Remarque : cette opération réinitialisera vos commandes pour qu'elles correspondent à {{language}} et vous risquez de perdre toutes les commandes personnalisées. Êtes-vous sûr de vouloir réinitialiser ?",
            "confirm": "Oui, réinitialiser les commandes",
            "error": "Une erreur s'est produite lors de la réinitialisation de vos commandes. Veuillez réessayer ultérieurement."
        },
        "warn": "Le microphone n'est pas activé. Vous devez activer votre microphone pour utiliser les commandes globales et celles de l'appareil.",
        "changeProfile": {
            "success": "Modifier les contrôles de l'application : {{value}}",
            "error": "Impossible de trouver les contrôles de l'application : « {{value}} »"
        },
        "descriptionShort": "Les commandes globales et d'appareil sont des actions toujours disponibles, conçues pour fonctionner avec tous les logiciels. Les commandes globales, comme « Arrêter la caméra », sont applicables à l'ensemble du système et indépendantes des applications, tandis que les commandes d'appareil sont adaptées à chaque connexion et débloquent des fonctionnalités plus avancées que les commandes d'application standard.",
        "description": "Les commandes globales et celles des appareils sont des actions toujours disponibles, conçues pour fonctionner avec tous les logiciels. Les commandes globales, comme « Arrêter la caméra », sont applicables à l'ensemble du système et indépendantes des applications, tandis que les commandes des appareils sont adaptées à chaque connexion et débloquent des fonctionnalités plus avancées que les commandes d'application standard. Ces commandes sont actuellement accessibles par commande vocale, mais nous prendrons en charge d'autres commandes ultérieurement.",
        "noDevice": "Cette étape utilise une extension personnalisée que vous n'avez pas configurée pour votre compte. Ajoutez l'extension pour débloquer cette étape."
    },
    "notifications": {
        "title": "Notifications",
        "center": "Centre de notification",
        "empty": "Vous n'avez aucune notification pour le moment. Revenez une autre fois.",
        "seen": "Vu",
        "markAsRead": "Marquer comme lu",
        "view": "Afficher toutes les notifications {{value}}"
    },
    "unsaved": {
        "title": "Vous avez des changements non enregistrés.",
        "description": "Vous avez des changements non enregistrés. Êtes-vous sûr de vouloir quitter cette page ?",
        "cancel": "Quitter sans sauvegarder",
        "confirm": "Sauvegarder et quitter"
    },
    "login": {
        "welcome": "Bienvenue chez Céphable !",
        "subtitle": "Contrôlez votre technologie selon <strong>vos</strong> conditions.",
        "create": "Créer un compte",
        "signIn": "Se connecter",
        "loading": "Redirection vers la connexion...",
        "error": "Une erreur s'est produite lors de votre connexion. Veuillez vous reconnecter.",
        "existingAccount": "Vous avez déjà un compte?",
        "description": "Contrôlez. Créez. Automatisez. Cephable — votre IA personnelle pour des commandes rapides, la rédaction contextuelle et des flux de travail entièrement automatisés. Aucun traitement dans le cloud. Une assistance fluide qui vous suit partout."
    },
    "home": {
        "title": "Maison",
        "startControls": "Allume ça!",
        "manage": "Configurer",
        "profileGenerate": {
            "title": "Oups. On dirait que vous n'avez pas encore de contrôles d'application.",
            "description": "Pour que Cephable puisse contrôler votre ordinateur, nous devons savoir ce que vous souhaitez contrôler. Vous pouvez créer des contrôles d'application de A à Z ou nous demander de vous aider à en créer un grâce à notre générateur de contrôles."
        }
    },
    "wizard": {
        "description": "Cephable utilisera ensuite ces informations pour générer des contrôles que vous pourrez examiner et essayer !",
        "includeDefaultKeysQuestion": "Inclure les commandes vocales par défaut pour les touches et les clics de souris ?",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Code, etc.",
        "generate": "Générer des contrôles",
        "complete": {
            "title": "Très bien, nous avons terminé !",
            "description": "Cliquez sur le bouton ci-dessous pour afficher les contrôles que nous avons générés. Vous pourrez modifier, ajouter ou supprimer manuellement n'importe quel aspect pour le perfectionner vous-même.",
            "viewControls": "Voir mes contrôles"
        },
        "error": {
            "emptyInput": "Veuillez sélectionner au moins une méthode de saisie",
            "emptyApp": "Veuillez saisir au moins un nom d'application",
            "generatingProfile": "Erreur lors de la génération des contrôles de l'application"
        },
        "loading": {
            "title": "Nous rassemblons toutes les pièces",
            "description": "Cela peut prendre jusqu'à environ une minute. Ne quittez pas cette page et ne revenez pas en arrière, sinon elle cessera de générer."
        },
        "selectedTips": {
            "title": "Conseil n° {{count}}",
            "previous": "Conseil précédent",
            "next": "Prochain conseil",
            "two": "Vous pouvez contrôler la sensibilité de vos entrées dans la section « Paramètres de contrôle d'expression » du panneau principal. Cela vous permet d'affiner davantage la manière dont Cephable interprète les entrées qui vous sont spécifiques. Et Cephable s'améliore avec le temps à mesure qu'il fonctionne avec vous !",
            "three": "Après avoir configuré cela, vous avez toujours un contrôle total sur la configuration. Nous vous donnons une base de référence, mais à tout moment, vous pouvez modifier le mappage entre ce que vous faites et ce qu'il fait sur l'ordinateur.",
            "four": "Vous pouvez imprimer vos contrôles pour en avoir une copie physique lorsque vous utilisez Cephable. Nous savons que tout cela est nouveau et qu’il faut un certain temps pour s’y habituer. La pratique rend meilleur !",
            "one": "Saviez-vous que vous pouvez utiliser Cephable sur un appareil pour en contrôler un autre ? Téléchargez Cephable sur votre mobile, votre tablette ou même un autre ordinateur et choisissez la connexion que vous souhaitez contrôler (peut-être celle-ci). Vos profils personnels et de saisie sont cohérents sur tous vos appareils ! Assurez-vous simplement que Cephable est actif sur votre appareil et vos connexions."
        },
        "steps": {
            "one": "Étape 1. Tapez le nom d'une application que vous souhaitez contrôler.",
            "two": "Étape 2. Confirmez les contrôles de saisie que vous souhaitez utiliser :",
            "three": "Étape 3. (facultatif) ",
            "threeContinued": "Décrivez toutes les actions spécifiques que vous souhaiteriez configurer pour les commandes que vous utilisez couramment ou pour lesquelles vous avez une forte préférence. Veuillez utiliser un anglais simple comme ceux ci-dessous"
        },
        "noOptionsText": "Commencez à taper pour trouver une application que vous souhaitez contrôler",
        "title": "Générer des contrôles d'application",
        "titleLong": "Générer des contrôles d'application",
        "try": "Essayez le générateur de contrôle",
        "placeholder": "Assurez-vous que les commandes vocales soient courtes.\n\nJe souhaite pouvoir dire « avancer » pour passer à la diapositive suivante de la présentation.\n\nJe souhaite utiliser les mouvements de la tête pour déplacer le curseur et les commandes vocales pour modifier les raccourcis.\n\nAjouter des boutons d'action rapide pour tous les mouvements et capacités de mon personnage."
    },
    "macros": {
        "title": "Contrôle",
        "titlePlural": "Contrôles",
        "description": "Les contrôles contiennent une entrée (action que vous faites comme incliner la tête) et les étapes que Cephable effectuera après l'enregistrement de cette action d'entrée. Vous pouvez utiliser des contrôles pour créer une combinaison d'étapes déclenchées par une seule entrée.",
        "new": "Créer un nouveau contrôle",
        "newDescription": "Créez un nouveau contrôle pour combiner plusieurs étapes et entrées.",
        "add": "Ajouter un contrôle",
        "create": "Créer un contrôle",
        "name": {
            "title": "Nom du contrôle",
            "question": "Comment voulez-vous appeler ce contrôle ?",
            "description": "Donnez un nom à votre contrôle afin de pouvoir le retrouver facilement plus tard.",
            "placeholder": "action que ce contrôle fait comme \"sauter\" ou \"zoomer\""
        },
        "empty": "Vous n'avez pas encore de contrôles. Cliquez ci-dessous pour en créer un.",
        "copySuffix": "{{name}}_copie"
    },
    "event": {
        "title": "Étape",
        "titlePlural": "Pas",
        "previewSummaryPlural": "{{first}} et {{total}} autres événements",
        "add": "Ajouter une étape",
        "stepType": "Type d'étape",
        "select": "Sélectionnez le type d'étape que vous souhaitez ajouter.",
        "question": "Quel type d’actions souhaitez-vous que Cephable effectue ?",
        "setup": "Configurez votre étape",
        "description": "Les étapes sont les actions que Cephable effectuera une fois l'entrée déclenchée. Vous pouvez ajouter plusieurs étapes à un contrôle pour créer une combinaison d'actions.",
        "expand": "Développez pour voir le reste des étapes",
        "stepUp": "Progresser",
        "stepDown": "Descendre",
        "stepCopy": "Étape de copie",
        "stepRemove": "Supprimer l'étape",
        "insertStep": "Insérer l'étape ci-dessous",
        "showOptions": "Afficher les options",
        "hideOptions": "Masquer les options",
        "hold": "Temps de maintien (en millisecondes)",
        "error": "Vous devez configurer votre étape.",
        "multiple": "Plusieurs étapes",
        "deviceTypeCustomAction": {
            "title": "Action personnalisée sur l'appareil"
        },
        "keyPress": {
            "title": "Appuyez sur la touche ou le bouton ",
            "short": "Presse",
            "fieldSet": "Touches ou boutons sur lesquels appuyer",
            "label": "Clé ou bouton",
            "holdTime": "Temps de maintien de la touche (en millisecondes)",
            "description": "Appuyez sur une touche du clavier sans utiliser le clavier.",
            "longDescription": "Cette fonction simule l'appui sur une touche de votre clavier. Par exemple, si vous rencontrez des difficultés pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre méthode de saisie pour « appuyer » virtuellement sur une touche.",
            "example": "Dites « Entrée » pour envoyer un e-mail sans appuyer physiquement sur la touche Entrée.",
            "timing": "Synchronisation des touches",
            "tap": "Robinet",
            "tapLong": "Appuyez sur le bouton",
            "latch": "Loquet",
            "latchLong": "Tenir jusqu'à ce qu'il soit relâché",
            "hold": "Prise",
            "holdLong": "Tenir pendant un certain temps",
            "toggle": "Basculer",
            "toggleLong": "Basculer l'action",
            "release": "Relâcher",
            "releaseLong": "Relâcher l'action",
            "latchLabel": "Conservez <strong>{{value}}</strong> jusqu&#39;à ce qu&#39;il soit libéré",
            "tapLabel": "Appuyez sur <strong>{{value}}</strong>",
            "pressLabel": "Appuyez sur <strong>{{value}}</strong> pendant <strong>{{time}}</strong> millisecondes",
            "remove": "Supprimer la touche enfoncée",
            "add": "Ajouter une touche/un bouton sur lequel appuyer"
        },
        "keyRelease": {
            "title": "Relâcher la touche ou le bouton",
            "short": "Libérer",
            "selected": "Clés sélectionnées à libérer",
            "description": "Lâchez une touche du clavier que vous avez enfoncée et maintenue enfoncée.",
            "longDescription": "Cette fonction simule le relâchement d'une touche de votre clavier. Il doit être utilisé conjointement avec une pression sur une touche maintenue indéfiniment. Par exemple, si vous rencontrez des difficultés pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre méthode de saisie pour « relâcher » virtuellement une touche.",
            "example": "Dites « Stop » après avoir dit « Toggle Run » pour arrêter de fonctionner.",
            "label": "Libérer <strong>{{value}}</strong>",
            "add": "Ajouter une clé/un bouton pour libérer",
            "remove": "Supprimer la version de clé"
        },
        "keyToggle": {
            "title": "Touche ou bouton à bascule",
            "short": "Basculer",
            "selected": "Touches sélectionnées à basculer",
            "description": "Allumez ou éteignez une touche du clavier comme un interrupteur d'éclairage avec une seule commande.",
            "longDescription": "Cela active ou désactive la fonction d'une touche, comme un interrupteur. C'est utile pour les clés que vous souhaitez conserver pendant une durée indéterminée. Vous pouvez l'utiliser pour conserver la même action pour l'appui sur une touche et pour le relâchement ou l'arrêt d'une touche.",
            "example": "Dites « Toggle Run » pour commencer à courir. Dites « Toggle Run » pour arrêter de fonctionner.",
            "label": "Basculer <strong>{{value}}</strong>",
            "add": "Ajouter une clé/un bouton pour basculer",
            "remove": "Supprimer la bascule de clé"
        },
        "pause": {
            "title": "Pause",
            "description": "Ajoutez un bref délai entre les actions.",
            "longDescription": "Cette fonction vous permet d'insérer un bref délai entre les actions, ce qui est essentiel dans les situations où une action doit être complètement terminée avant que la suivante ne commence. Par exemple, si vous utilisez une commande pour mettre le texte en gras dans un document, vous devrez peut-être d'abord ouvrir un menu contextuel. La fonction Pause donne suffisamment de temps pour que le menu contextuel s'ouvre et devienne actif avant de passer à l'étape suivante, garantissant ainsi un fonctionnement fluide et sans erreur.",
            "example": "Imaginez que vous modifiez un document à l'aide de commandes vocales. Vous dites « Formater le texte », ce qui ouvre un menu contextuel. Ensuite, après une brève pause pour permettre au menu d'apparaître entièrement, vous dites « Gras » pour appliquer une mise en forme en gras au texte sélectionné. La fonction Pause garantit que le menu contextuel est prêt à recevoir votre prochaine commande.",
            "label": "Pause pendant <strong>{{value}}</strong> millisecondes"
        },
        "type": {
            "title": "Taper",
            "field": "Phrase à saisir",
            "placeholder": "phrase dactylographiée",
            "question": "Quel texte souhaitez-vous taper ?",
            "description": "Écrivez du texte comme si vous utilisiez un clavier.",
            "longDescription": "Cela imite la saisie d’une chaîne de texte, comme si vous tapiez sur un clavier. C'est idéal pour saisir du texte plus long sans avoir besoin d'appuyer sur chaque touche. Si vous souhaitez saisir du texte de manière dynamique, vous pouvez utiliser la fonction Dictée.",
            "example": "Dites « Nom » pour saisir « Bonjour, je m'appelle Ellen Ripley ». dans une fenêtre de discussion.",
            "label": "Tapez <strong>{{value}}</strong>"
        },
        "mouseMove": {
            "title": "Déplacez la souris",
            "description": "Déplacez le pointeur sur l'écran.",
            "longDescription": "Déplacez le curseur ou le pointeur de votre écran sans souris physique. Ceci est particulièrement utile pour les utilisateurs ayant une mobilité limitée des mains. Ceci est utile pour un contrôle précis des mouvements de la souris, nécessaire dans certains jeux. Si vous souhaitez simuler tous les mouvements de la souris en utilisant le mouvement de votre tête, vous pouvez essayer le « Mouvement de la tête pour le contrôle de la souris » dans les paramètres de la caméra.",
            "example": "Dites « Déplacer la souris vers la droite » pour déplacer le curseur vers la droite de 100 px.",
            "moveX": "Déplacement de la souris vers la gauche/droite",
            "numberMoveX": "Nombre de pixels à déplacer vers la gauche/droite",
            "moveY": "Déplacement de la souris vers le haut/bas des pixels",
            "numberMoveY": "Nombre de pixels à déplacer vers le haut/bas",
            "label": "Déplacez la souris <strong>{{value}}</strong>",
            "command": "Déplacement de la souris : {{commande}}",
            "commandLabel": "Déplacement de la souris",
            "startCommand": "Déplacement de la souris Début",
            "stopCommand": "Arrêter le déplacement de la souris"
        },
        "joystickMove": {
            "title": "Déplacer les joysticks",
            "description": "Utilisez un joystick pour déplacer les éléments sur l'écran.",
            "longDescription": "Cette fonction simule le mouvement d'un joystick. Par exemple, si vous rencontrez des difficultés pour utiliser un joystick physique, vous pouvez utiliser une commande vocale ou une autre méthode de saisie pour déplacer virtuellement un joystick.",
            "example": "Dites « Déplacer le joystick vers la gauche » pour déplacer le joystick vers la gauche de 100 px.",
            "prefix": "Déplacez le joystick gauche",
            "left": "Manette gauche",
            "leftX": "X gauche",
            "leftY": "Y gauche",
            "right": "Manette droite",
            "rightX": "X droit",
            "rightY": "Y droit",
            "x": "Force de l'axe X",
            "y": "Force de l'axe Y",
            "moveXLabel": "Déplacer X : {{value}}",
            "moveYLabel": "Déplacement Y : {{value}}",
            "labelLeft": "Déplacez le joystick gauche ",
            "labelRight": "Déplacez le joystick droit ",
            "latch": "Le loquet maintiendra la position jusqu'à ce que vous le relâchiez à l'aide d'une commande « Arrêter tout »."
        },
        "playAudio": {
            "title": "Lire l'audio",
            "placeholder": "phrase de déclaration que Cephable dira",
            "description": "Jouez un son, un mot ou une phrase.",
            "longDescription": "Cette fonction permet aux utilisateurs de convertir des phrases saisies en mots prononcés. C'est particulièrement utile pour les personnes qui peuvent avoir des difficultés à parler. En tapant une phrase, la fonction PlayAudio articulera le texte à haute voix à l'aide d'une parole synthétisée. Cela peut faciliter la communication ou dans les situations où un utilisateur a besoin de relayer des informations verbalement mais préfère ou nécessite une alternative à l'utilisation de sa propre voix.",
            "example": "Souriez pour jouer le mot « Bonjour ».",
            "label": "Dites <strong>{{value}}</strong>"
        },
        "stopOutputs": {
            "title": "Arrêter toutes les sorties",
            "titleLong": "Arrêtez toutes les sorties (relâchez toutes les touches et boutons, arrêtez tous les mouvements de la souris, arrêtez toute saisie)",
            "description": "Arrêtez toutes les actions en cours comme l'appui sur une touche.",
            "longDescription": "Arrêtez immédiatement toutes les sorties ou actions en cours. Il s'agit d'une fonction de sécurité ou de commodité permettant d'arrêter tout processus. Nous le ferons automatiquement pour vous lorsque vous fermez ou mettez en pause les commandes de la caméra ou du microphone.",
            "example": "Dites « Stop » pour arrêter toutes les sorties.",
            "label": "Arrêtez toutes les sorties et relâchez les touches"
        },
        "custom": {
            "title": "Coutume"
        },
        "options": {
            "moveUp": "Déplacer vers le haut",
            "moveDown": "Descendre",
            "moveLeft": "Se déplacer à gauche",
            "moveRight": "Déplacer vers la droite",
            "copyStep": "Étape de copie",
            "removeStep": "Supprimer l'étape"
        },
        "directions": {
            "up": "En haut",
            "down": "Vers le bas",
            "left": "Gauche",
            "right": "Droite"
        }
    },
    "expression": {
        "title": "Expression du visage",
        "titlePlural": "Expressions du visage",
        "label": "Expression / Geste",
        "start": "Démarrer les contrôles d’expression",
        "startSmiling": {
            "title": "Commencez à sourire",
            "description": "Si vous commencez à sourire sans sourire, puis à sourire, cette commande se déclenchera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande « Ouvrir/Fermer la bouche » peut entraîner des conflits."
        },
        "stopSmiling": {
            "title": "Arrêtez de sourire",
            "description": "Si vous souriez puis cessez, cette commande s'activera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande « Ouvrir/Fermer la bouche » peut entraîner des conflits."
        },
        "eyebrows": {
            "title": "Lève sourcils",
            "description": "Si vous soulevez vos deux sourcils par rapport à votre position de repos de base, cette commande se déclenchera."
        },
        "openMouth": {
            "title": "Bouche ouverte",
            "description": "Si votre bouche est fermée (ou légèrement ouverte), et que vous l'ouvrez davantage, cette commande se déclenchera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande du sourire peut entraîner des conflits."
        },
        "closeMouth": {
            "title": "Fermer la bouche",
            "description": "Si votre bouche est ouverte et que vous la fermez complètement, cette commande se déclenchera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande de sourire peut entraîner des conflits."
        },
        "description": "Améliorez votre expérience numérique grâce aux expressions faciales. Utilisez des gestes comme lever les sourcils, sourires et autres mouvements pour contrôler facilement le pointeur de votre souris, effectuer des actions ou personnaliser vos interactions."
    },
    "head": {
        "title": "Mouvement de la tête",
        "titlePlural": "Mouvements de tête",
        "label": "Mouvement de la tête/du corps",
        "question": "Quel type de mouvement souhaitez-vous utiliser ?",
        "tilt": {
            "title": "Inclinaison de la tête",
            "left": {
                "title": "Incliner la tête vers la gauche",
                "description": "Si vous regardez la caméra et inclinez la tête vers la gauche, cette commande se déclenchera."
            },
            "right": {
                "title": "Incliner la tête vers la droite",
                "description": "Si vous regardez la caméra et inclinez la tête vers la droite, cette commande se déclenchera."
            },
            "back": {
                "title": "Incliner la tête vers l'arrière",
                "description": "Si vous regardez la caméra, inclinez la tête en arrière et regardez vers le haut, cette commande se déclenchera."
            },
            "forward": {
                "title": "Incliner la tête vers l'avant",
                "description": "Si vous regardez la caméra et inclinez la tête vers l’avant et regardez vers le bas, cette commande se déclenchera."
            },
            "description": "Inclinez votre tête vers la gauche ou la droite pour un contrôle amélioré ou une navigation avec la souris."
        },
        "turn": {
            "title": "Tour de tête",
            "left": {
                "title": "Tourner la tête à gauche",
                "description": "Si vous regardez la caméra et tournez la tête et regardez vers votre gauche, cette commande se déclenchera."
            },
            "right": {
                "title": "Tourner la tête à droite",
                "description": "Si vous regardez la caméra et tournez la tête et regardez vers votre droite, cette commande se déclenchera."
            },
            "description": "Tournez la tête vers la gauche ou la droite pour un contrôle amélioré ou une navigation avec la souris."
        },
        "lean": {
            "title": "Tête maigre",
            "left": {
                "title": "Pencher la tête à gauche",
                "description": "Si vous regardez la caméra et que vous vous penchez vers la gauche pour que votre visage soit plus à gauche dans le cadre de la caméra, cette commande se déclenchera."
            },
            "right": {
                "title": "Pencher la tête à droite",
                "description": "Si vous regardez la caméra et que vous vous penchez vers la droite pour que votre visage soit plus à droite dans le cadre de la caméra, cette commande se déclenchera."
            },
            "back": {
                "title": "Pencher la tête en arrière",
                "description": "Si vous regardez la caméra et que vous vous penchez en arrière pour que votre visage soit plus éloigné de la caméra, cette commande se déclenchera."
            },
            "forward": {
                "title": "Penchez-vous la tête en avant",
                "description": "Si vous regardez la caméra et que vous vous penchez en avant pour que votre visage soit plus proche de la caméra, cette commande se déclenchera."
            },
            "up": {
                "title": "Déplacer le corps vers le haut",
                "description": "Si vous regardez la caméra et que vous relevez la tête en étirant votre cou ou en déplaçant tout votre corps vers le haut, cette commande se déclenchera."
            },
            "down": {
                "title": "Descendre le corps",
                "description": "Si vous regardez la caméra et baissez la tête en froissant le cou, en vous baissant ou en abaissant tout votre corps, cette commande se déclenchera."
            },
            "center": {
                "title": "Centrez votre tête",
                "description": "Si vous regardez la caméra et déplacez votre tête vers la position centrale correspondant à la ligne de base, cette commande se déclenchera."
            },
            "description": "Penchez votre tête vers la gauche ou la droite pour un meilleur contrôle ou une meilleure navigation avec la souris."
        },
        "description": "Contrôlez votre appareil ou votre connexion par des mouvements de tête comme incliner, hocher la tête ou tourner. Grâce à la caméra de votre appareil, Cephable garantit une expérience privée et intuitive pour un contrôle et une navigation optimisés."
    },
    "voice": {
        "title": "Commande vocale",
        "titlePlural": "Commandes vocales",
        "placeholder": "Voix ou phrase que Cephable écoutera",
        "question": "Quelle déclaration ou expression voulez-vous dire pour ce contrôle ?",
        "when": "Quand je dis...",
        "say": "Dites « {{value}} »",
        "load": {
            "fail": {
                "title": "{{language}} Commandes vocales indisponibles",
                "description": "Oh non! Nous n'avons pas pu charger {{language}} pour les commandes vocales. S'il vous plaît, vérifiez votre connexion à internet et réessayez. Utiliser l'anglais (États-Unis) jusqu'à ce que la connexion soit rétablie."
            }
        },
        "description": "Activer le microphone permet des commandes vocales intelligentes et naturelles, permettant aux utilisateurs d'interagir facilement avec leur ordinateur, que ce soit pour les applications ou les logiciels. Exécutez des commandes ou dictez du texte en parlant naturellement, pour une expérience intuitive et intuitive."
    },
    "motion": {
        "title": "Contrôle de mouvement",
        "titlePlural": "Commandes de mouvement",
        "question": "Quel type de mouvement avec un téléphone ou une tablette souhaitez-vous utiliser ?",
        "start": "Démarrer les commandes de mouvement",
        "settings": "Paramètres de mouvement",
        "descriptionShort": "Inclinez, tournez ou secouez votre appareil pour contrôler Cephable.",
        "description": "Les commandes de mouvement vous permettent de transformer les mouvements de votre téléphone ou de votre tablette dans l'application Companion en commandes pour votre appareil. Inclinez ou secouez votre téléphone dans différentes directions pour créer de nouvelles sorties.",
        "up": {
            "title": "Inclinez votre appareil vers le haut",
            "description": "Si votre appareil est à plat sur une surface et que vous l'inclinez vers vous, cette commande se déclenchera."
        },
        "down": {
            "title": "Inclinez votre appareil vers le bas",
            "description": "Si votre appareil est à plat sur une surface et que vous l'inclinez pour qu'il soit face à vous, cette commande se déclenchera."
        },
        "left": {
            "title": "Inclinez votre appareil vers la gauche",
            "description": "Si votre appareil est plat sur une surface et que vous l'inclinez vers la gauche pour faire face vers la gauche, cette commande se déclenchera."
        },
        "right": {
            "title": "Inclinez votre appareil vers la droite",
            "description": "Si votre appareil est plat sur une surface et que vous l'inclinez vers la droite, cette commande se déclenchera."
        },
        "shake": {
            "title": "Secouez votre appareil",
            "description": "Si vous secouez votre appareil, cette commande se déclenchera."
        },
        "edit": {
            "title": "Modifier les paramètres de mouvement",
            "description": "Modifiez vos paramètres de contrôle de mouvement pour ajuster la quantité dont vous avez besoin pour déplacer votre téléphone pendant l'exécution vers l'application Companion.",
            "sensitivity": {
                "title": "Paramètres de sensibilité du contrôle de mouvement",
                "description": "La sensibilité indique à Cephable jusqu'où vous devez incliner votre appareil pour déclencher un contrôle. Plus la valeur est grande (la plus à droite sur le curseur), plus la sensibilité est élevée, et donc moins il faut incliner pour déclencher la commande."
            },
            "tilt": {
                "title": "Sensibilité à l'inclinaison",
                "description": "Ces valeurs déterminent jusqu'où vous devez incliner votre appareil vers le haut, le bas, la gauche et la droite pour qu'une entrée soit reconnue."
            },
            "mouse": {
                "title": "Commandes de mouvement pour le mouvement de la souris",
                "description": "Déterminez si et comment vous souhaitez utiliser les commandes de mouvement pour déplacer votre souris au lieu de déclencher les commandes",
                "enable": {
                    "title": "Activer les commandes de mouvement pour le mouvement de la souris",
                    "description": "Si cette option est activée, certaines de vos commandes de mouvement seront utilisées pour déplacer votre souris au lieu de déclencher des commandes.",
                    "option": "Utiliser les commandes de mouvement pour les mouvements de la souris ?"
                },
                "invert": {
                    "title": "Inverser le mouvement de la souris",
                    "description": "Pour l'axe X : si cette option est activée, un déplacement vers la gauche déplacera votre souris vers la droite et un déplacement vers la droite la déplacera vers la gauche. Pour l'axe Y : si cette option est activée, le fait de descendre déplacera votre souris vers le haut et le fait de monter la fera descendre.",
                    "x": "Inverser le mouvement de la souris sur l'axe X ?",
                    "y": "Inverser le mouvement de la souris sur l'axe Y ?"
                }
            }
        }
    },
    "keys": {
        "title": "Clé ou bouton",
        "titlePlural": "Touches ou boutons",
        "label": "Clé/bouton externe",
        "question": "Sur quelle touche ou bouton souhaitez-vous appuyer ?",
        "edit": "Modifier les touches et les boutons",
        "defaultOption": "Inclure les commandes vocales par défaut pour les touches et les clics de souris ?",
        "description": "Les touches et les boutons vous permettent de mapper vos différentes commandes d'entrée aux pressions du clavier et des boutons du contrôleur.",
        "then": "Cephable va appuyer...",
        "empty": "Aucun contrôle clé ne correspond à ces critères.",
        "backspace": "Retour arrière",
        "delete": "Supprimer",
        "enter": "Entrer",
        "space": "Barre d'espace",
        "tab": "Languette",
        "shift": "Changement",
        "ctrl": "Ctrl",
        "leftCtrl": "Ctrl gauche",
        "rightCtrl": "Ctrl droit",
        "leftShift": "Décalage à gauche",
        "rightShift": "Maj droite",
        "alt": "Tout",
        "leftAlt": "Alt gauche",
        "escape": "S'échapper",
        "up": "Flèche vers le haut",
        "down": "Flèche vers le bas",
        "left": "Flèche gauche",
        "right": "Flèche droite",
        "command": "Commande",
        "caps": "Verrouillage des majuscules",
        "reset": {
            "title": "Réinitialiser les raccourcis clavier",
            "confirm": "Réinitialiser tous les raccourcis clavier ?",
            "confirmDescription": "Choisissez comment réinitialiser les raccourcis clavier. Cette action est irréversible sans enregistrement.",
            "confirmButton": "Réinitialiser les raccourcis clavier",
            "defaultOption": "Rétablir les valeurs par défaut pour la langue actuelle",
            "emptyOption": "Réinitialiser à zéro (effacer toutes les commandes)"
        }
    },
    "talkback": {
        "title": "Répondre",
        "question": "Que veux-tu que Céphable dise ?",
        "description": "Configurez des contrôles qui permettront à Cephable de parler pour vous. Vous pouvez attribuer des commandes aux différentes phrases que vous souhaitez prononcer.",
        "thenMacro": "alors Céphable dira...",
        "empty": "Il n'existe aucun contrôle de réponse correspondant à ces critères.",
        "add": "Ajouter un nouveau contrôle Talkback",
        "remove": "Supprimer le contrôle Talkback",
        "edit": "Modifier les commandes Talkback",
        "deprecatedNotice": "Talkback est désormais intégré directement aux commandes principales de l'application. Vos commandes d'application comportent d'anciens événements Talkback qui doivent être mis à jour."
    },
    "dictation": {
        "title": "Dictation",
        "question": "Quelle phrase doit déclencher le mode dictée ?",
        "thenMacro": "Céphable va...",
        "empty": "Il n'existe aucun contrôle de dictée correspondant à ces critères.",
        "type": "taper",
        "edit": "Modifier les phrases de dictée",
        "remove": "Supprimer une phrase de dictée",
        "add": "Ajouter une nouvelle phrase de dictée",
        "on": "Dictée",
        "off": "Commandes",
        "onboarding": {
            "tourLabel": "Dictée",
            "learn": "Apprenez à utiliser le mode dictée pour convertir votre discours en texte en mains libres.",
            "welcome": {
                "title": "Dictée",
                "description": "La dictée vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C'est comme avoir un assistant personnel qui saisit tout ce que vous dites."
            },
            "microphone": {
                "title": "Allumez votre microphone",
                "description": "Tout d'abord, activez votre microphone. Cliquez sur l'icône « Microphone » dans le panneau Cephable."
            },
            "activate": {
                "title": "Démarrer le mode dictée",
                "description": "La voix démarre en mode commande. Pour lancer la dictée, dites « Démarrer la dictée » ou cliquez sur le bouton « Dictée ». Activons maintenant le mode dictée."
            },
            "speaking": {
                "title": "Cliquez sur un document ou un champ et commencez à parler",
                "description": "La dictée enregistre en temps réel ce que vous dites. Cliquez sur un champ de texte ou un document, puis commencez à parler. Par exemple, dites : « Voici comment utiliser le mode dictée. »"
            },
            "pauseResume": {
                "title": "Pause de la dictée",
                "description": "Besoin d'une pause sans désactiver la dictée ? Dites simplement « Suspendre la dictée ». Vous pouvez la reprendre à tout moment avec « Démarrer la dictée ». Vous pouvez personnaliser davantage cette option grâce aux commandes globales et aux commandes de l'appareil toujours actives."
            },
            "stop": {
                "title": "Arrêter la dictée",
                "description": "Besoin de revenir aux commandes de votre application ? Dites simplement « Arrêter la dictée ». Cela arrêtera le mode dictée et vous ramènera au mode commande. Vous pouvez reprendre à tout moment en cliquant à nouveau sur « Démarrer la dictée »."
            },
            "complete": {
                "title": "Bravo!",
                "description": "Et voilà ! Vous pouvez désormais dicter, mettre en pause, reprendre et passer du mode dictée au mode commande. La dictée est un outil puissant pour la saisie mains libres. Utilisez-la pour rédiger des e-mails, des documents ou tout ce que vous devez saisir à voix haute."
            }
        },
        "description": "La dictée vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C'est comme avoir un assistant personnel qui saisit tout ce que vous dites."
    },
    "face": {
        "title": "Expression du visage",
        "titlePlural": "Expressions du visage",
        "try": "Essayez les contrôles d'expression du visage",
        "question": "Quel type d’expression de visage souhaitez-vous utiliser ?",
        "descriptionShort": "Utilisez différents mouvements du visage pour des contrôles améliorés.",
        "description": "Les expressions faciales font partie des Contrôles d'expression. Elles vous permettent d'utiliser différents mouvements du visage pour des contrôles améliorés. Vous pouvez utiliser les mouvements des sourcils, de la bouche, etc. pour créer différents rendus."
    },
    "other": {
        "title": "Autre",
        "titlePlural": "Autres contrôles",
        "label": "Autre contrôle",
        "placeholder": "autre commande expérimentale",
        "question": "Quelle commande supplémentaire souhaitez-vous utiliser ? Ces commandes sont généralement destinées aux connexions non Cephable qui ne correspondent pas aux autres catégories. Elles peuvent également fonctionner comme des commandes vocales lorsque vous prononcez le mot ou la phrase spécifié. Remarque : ces commandes sont expérimentales et peuvent ne pas être entièrement prises en charge.",
        "description": "Les autres commandes sont expérimentales et peuvent ne pas être entièrement prises en charge. Elles peuvent être utilisées pour des connexions non Cephable ou comme commandes vocales lorsque vous prononcez le mot ou la phrase spécifié."
    },
    "support": {
        "title": "Soutien",
        "profiles": "Introduction aux contrôles d'application",
        "question": "Vous ne trouvez toujours pas ce dont vous avez besoin ?",
        "more": "Apprenez-en plus sur Cephable.com avec des guides étape par étape, des tutoriels, des vidéos et plus encore."
    },
    "community": {
        "title": "Rejoignez la communauté",
        "description": "Obtenez du soutien, partagez des idées ou devenez membre des communautés Cephable.",
        "discord": "Communauté Discorde",
        "facebook": "Groupe Facebook"
    },
    "resources": {
        "title": "Ressources utiles",
        "description": "Trouvez les réponses à vos questions sur les caractéristiques et fonctions de Cephable.",
        "guides": "Guides étape par étape"
    },
    "feedback": {
        "title": "Retour",
        "description": "Parlez-nous de votre expérience avec Cephable.",
        "contact": "Contactez-nous",
        "feature": "Suggérer une fonctionnalité",
        "bug": "Signaler un problème"
    },
    "settings": {
        "title": "Paramètres",
        "general": "Paramètres généraux de l'application",
        "description": "Il s'agit de votre canevas pour personnaliser votre expérience en affinant vos commandes.",
        "orgTitle": "Paramètres de {{ value }}",
        "advanced": {
            "title": "Paramètres avancés",
            "description": "Cliquez ici pour accéder aux paramètres avancés de votre IA, aux commandes de l'application, aux connexions, aux extensions et plus encore."
        },
        "quick": "Voici les paramètres contextuels du panneau. Utilisez-les pour personnaliser votre expérience."
    },
    "account": {
        "title": "Compte",
        "settings": "Paramètres du compte",
        "description": "Mettez à jour les informations clés pour rester connecté avec Cephable.",
        "usernameLabel": "Nom d'utilisateur: ",
        "emailLabel": "E-mail: ",
        "password": {
            "change": "Changer le mot de passe",
            "description": "Mettez à jour votre mot de passe pour sécuriser votre compte.",
            "old": "ancien mot de passe",
            "current": "Votre mot de passe actuel",
            "new": "nouveau mot de passe",
            "desired": "Votre nouveau mot de passe souhaité",
            "confirm": "Confirmer le nouveau mot de passe",
            "update": "Mettre à jour le mot de passe"
        },
        "isEmailVerified": {
            "title": "L'email n'est pas verifié.",
            "description": "Votre email n'est pas vérifié. Veuillez vérifier votre courrier électronique pour un lien de vérification.",
            "resend": "Ré-envoyer l'email",
            "success": "Nous vous avons envoyé un nouvel e-mail de vérification.",
            "error": "Une erreur s'est produite lors de l'envoi de l'e-mail de vérification. Veuillez réessayer plus tard.",
            "org": "Votre adresse e-mail n'est pas vérifiée. Elle est requise pour accéder aux informations de la licence. Veuillez consulter votre adresse e-mail pour obtenir un lien de vérification.",
            "titleAlt": "Vérifiez votre adresse e-mail",
            "descriptionLong": "Bienvenue sur Cephable ! Un e-mail de vérification a été envoyé à {{email}}. Veuillez vérifier votre boîte de réception ou votre dossier spam et cliquer sur le lien. Si vous ne le voyez pas, vous pouvez renvoyer l'e-mail de vérification.",
            "appBlock": "Vous y êtes presque ! Un e-mail de vérification a été envoyé à {{email}}. Veuillez consulter votre boîte de réception et cliquer sur le lien pour vérifier votre adresse e-mail. Si vous ne le voyez pas, vérifiez vos spams."
        },
        "signout": {
            "title": "Se déconnecter",
            "question": "Êtes-vous certain de vouloir vous déconnecter?",
            "confirm": "Oui, déconnectez-vous",
            "warn": {
                "title": "Vous êtes sur le point d’être déconnecté.",
                "description": "Il semblerait que vous ayez été inactif pendant un certain temps. Pour des raisons de sécurité, nous vous déconnecterons dans XX secondes. Si vous souhaitez rester connecté, cliquez sur « Rester connecté » ci-dessous.",
                "confirm": "Rester connecté",
                "cancel": "Déconnectez-vous maintenant"
            },
            "description": "Une fois déconnecté, cette connexion sera supprimée de votre compte et ne sera plus visible depuis l'application Companion ou d'autres connexions.",
            "confirmDescription": "Vous déconnecter et supprimer cette connexion"
        },
        "marketing": {
            "title": "Préférences de messagerie",
            "description": "Mettez à jour vos préférences de messagerie pour recevoir des mises à jour et des nouvelles de Cephable.",
            "marketing": "E-mails marketing",
            "optIn": "Je souhaite recevoir des tutoriels, des conseils, des mises à jour et des newsletters pour améliorer mon expérience Cephable"
        },
        "error": {
            "save": "Erreur lors de l'enregistrement des paramètres du compte.",
            "password": "Erreur lors de la mise à jour du mot de passe.",
            "signout": "Erreur de déconnexion.",
            "old": "L'ancien mot de passe est requis.",
            "new": "Un nouveau mot de passe est requis.",
            "match": "Les mots de passe ne correspondent pas.",
            "marketing": "Erreur lors de la mise à jour des préférences de messagerie.",
            "userPreferences": "Erreur lors de l'enregistrement des préférences utilisateur."
        },
        "success": {
            "save": "Paramètres du compte enregistrés.",
            "password": "Mot de passe mis à jour.",
            "marketing": "Préférences de courrier électronique mises à jour.",
            "userPreferences": "Préférences utilisateur mises à jour."
        },
        "userPreferences": {
            "title": "Préférences de l'utilisateur",
            "description": "Mettez à jour vos préférences pour créer l'expérience Cephable qui vous convient.",
            "warningOptOut": "Masquer les avertissements lorsque j'enregistre ou mets à jour les contrôles de l'application",
            "enableTranscribeTask": "Activer la tâche de transcription de fichiers expérimentaux dans le panneau Cephable",
            "enableGamepadSupport": "Activer la prise en charge de la manette pour le pilote local et l'émulation du contrôleur Xbox",
            "enableMetrics": "Activez l'affichage des métriques d'utilisation pour les tests de performance. Vous pourrez télécharger les journaux.",
            "enableCameraControls": "Activez les commandes de la caméra dans le panneau Cephable"
        },
        "menu": "Menu utilisateur",
        "delete": {
            "title": "Supprimer le compte",
            "description": "Vous pouvez supprimer définitivement votre compte et effacer toute trace de vos informations personnelles. La suppression de votre compte entraînera la suppression de vos connexions, qui ne seront plus actives ni associées à votre compte. Vos paramètres et commandes d'application seront également perdus. Cette action est irréversible.",
            "button": "Supprimer définitivement le compte",
            "confirmation": "Êtes-vous sûr de vouloir supprimer votre compte ?",
            "note": "Cette action est irréversible.",
            "confirm": "Oui, supprimez mon compte"
        },
        "communication": {
            "title": "Préférences de communication"
        },
        "name": {
            "title": "Nom d'affichage"
        },
        "email": {
            "title": "Adresse e-mail",
            "description": "Votre adresse e-mail enregistrée"
        }
    },
    "appSettings": {
        "description": "Ces paramètres s'appliquent uniquement à cette application. Si vous souhaitez modifier les paramètres de l'application Cephable sur un autre ordinateur ou appareil mobile, modifiez les paramètres dans cette application.",
        "autostart": {
            "title": "Démarrer automatiquement Cephable",
            "description": "Avec ce paramètre activé, l'application Cephable démarrera automatiquement lorsque vous vous connecterez à votre appareil. Si vous disposez également de commandes automatiques de voix et d’expression, celles-ci démarreront également immédiatement.",
            "question": "Démarrage automatique de l'application Cephable ?"
        },
        "position": {
            "topLeft": "En haut à gauche",
            "top": "Centre supérieur",
            "topRight": "En haut à droite",
            "bottom": "En bas au centre",
            "bottomLeft": "En bas à gauche",
            "bottomRight": "En bas à droite",
            "label": "Sélectionner la position d'alimentation de commande",
            "description": "Sélectionnez l’endroit où vous souhaitez que le flux de commandes apparaisse sur votre écran."
        },
        "micPosition": {
            "title": "Position de la fenêtre d'entrée du microphone",
            "description": "Sélectionnez l'endroit où vous souhaitez que les commandes du microphone pour la voix et la dictée soient positionnées sur votre écran.",
            "label": "Sélectionnez la position de la fenêtre d’entrée du microphone"
        },
        "cameraPosition": {
            "title": "Position de la fenêtre d'entrée de la caméra",
            "description": "Sélectionnez l'endroit où vous souhaitez que les commandes de la caméra pour les mouvements du visage et de la tête soient positionnées sur votre écran.",
            "label": "Sélectionner la position de la fenêtre d'entrée de la caméra"
        },
        "theme": {
            "title": "Thème",
            "description": "Choisissez un thème qui correspond à votre style.",
            "label": "Sélectionnez un thème",
            "light": "Lumière",
            "dark": "Sombre",
            "system": "Utiliser les paramètres du système d'exploitation"
        },
        "overlay": {
            "title": "Flux de commandes",
            "description": "Le flux de commandes affiche les différentes commandes que vous utilisez et celles envoyées à votre ordinateur. Il est accessible par clic, mais il est toujours visible par-dessus les autres fenêtres. Lorsque ce paramètre est activé, l'application Cephable s'affiche et est toujours visible par-dessus les autres fenêtres et applications.",
            "question": "Afficher le flux de commandes ?"
        },
        "transparent": {
            "title": "Transparence du flux de commandes",
            "description": "Détermine l'opacité du texte. Plus la valeur est faible, plus le flux sera transparent."
        },
        "panelAutoHide": {
            "title": "Masquer automatiquement le panneau Cephable",
            "delay": "Attendre avant de se cacher",
            "denominator": "secondes",
            "time": "{{value}} secondes"
        },
        "title": "Paramètres généraux de l'application",
        "scale": {
            "description": "Ajustez la taille du texte dans toute l'application.",
            "label": "Taille du texte",
            "small": "Petit",
            "large": "Grand"
        },
        "panelScale": {
            "description": "Ajustez la taille du bouton du panneau réduit.",
            "label": "Taille des boutons du panneau"
        },
        "aiNewFiles": {
            "title": "Dossier pour les nouveaux fichiers IA",
            "description": "Choisissez l'emplacement où l'agent IA enregistre les nouveaux fichiers par défaut, sauf si vous lui indiquez un emplacement précis. Si vous conservez la valeur par défaut, les nouveaux fichiers sont enregistrés dans un dossier « Cephable-Work » de votre dossier personnel, créé automatiquement lors de la première utilisation.",
            "selectButton": "Sélectionner un dossier",
            "clearButton": "Utiliser le dossier par défaut",
            "current": "Les nouveaux fichiers sont enregistrés dans : {{folder}}",
            "default": "Les nouveaux fichiers sont enregistrés dans le dossier par défaut « Cephable-Work » de votre dossier personnel.",
            "openButton": "Ouvrir le dossier",
            "openError": "Impossible d'ouvrir le dossier. Il a peut-être été déplacé ou supprimé."
        },
        "aiWorkspace": {
            "title": "Dossier Espace de travail IA",
            "description": "Choisissez un dossier que l'agent IA embarqué utilisera pour rechercher, lire et modifier des fichiers, ainsi que pour exécuter des commandes. Par défaut, l'agent a accès à l'intégralité de votre ordinateur.",
            "selectButton": "Sélectionner un dossier",
            "clearButton": "Utiliser l'intégralité de l'ordinateur",
            "current": "Dossier de l'espace de travail actuel :",
            "none": "Aucun dossier d'espace de travail sélectionné. L'agent IA peut accéder à l'intégralité de votre ordinateur.",
            "restrictQuestion": "Limiter l'agent IA à ce dossier uniquement.",
            "restrictDescription": "Lorsqu'elle est activée, l'interface d'IA permet aux outils de fichiers et de commandes de l'agent de lire ou de modifier tout élément situé en dehors du dossier sélectionné."
        },
        "documentTemplates": {
            "title": "Modèles de documents",
            "description": "Choisissez un modèle de document que l'agent IA utilisera pour créer de nouveaux documents. Laissez le type par défaut Cephable pour appliquer le style de marque Cephable intégré. Word, PowerPoint et Excel possèdent chacun leur propre modèle.",
            "word": "Modèle Word",
            "wordDescription": "Modèle à partir duquel l'agent d'IA démarre pour les nouveaux documents Word (.docx).",
            "powerpoint": "Modèle PowerPoint",
            "powerpointDescription": "Modèle à partir duquel l'agent d'IA démarre pour les nouvelles présentations PowerPoint (.pptx).",
            "excel": "Modèle Excel",
            "excelDescription": "Modèle à partir duquel l'agent d'IA démarre pour les nouveaux classeurs Excel (.xlsx).",
            "selectButton": "Choisir un fichier",
            "clearButton": "Utiliser la valeur par défaut de Cephable",
            "current": "Modèle: ",
            "default": "Utilisation du modèle par défaut intégré de Cephable avec le style de la marque."
        },
        "automationBrowser": {
            "title": "Visibilité du navigateur d'automatisation",
            "description": "Lorsque l'agent IA utilise le navigateur Cephable (recherche web, Google Docs/Sheets/Slides, Gmail, Drive), il fonctionne généralement en arrière-plan sans vous déranger. Activez cette option pour observer son fonctionnement.",
            "question": "Afficher le navigateur d'automatisation pendant que l'IA fonctionne ?"
        }
    },
    "input": {
        "title": "Saisir",
        "titlePlural": "Contrôles d'entrée",
        "explore": "Explorer les contrôles de saisie",
        "descriptionShort": "Explorez les différents contrôles d'entrée utilisés par Cephable pour créer une meilleure expérience numérique pour vous.",
        "typeLabel": "Type de contrôle d'entrée",
        "toolTip": "Cela utilise {{alt}}",
        "remove": "Supprimer le contrôle d'entrée",
        "filter": "Filtrer par type d'entrée",
        "select": "Sélectionnez une entrée",
        "question": "Quel type d'entrée souhaitez-vous utiliser ?",
        "add": "Ajouter une entrée",
        "addMore": "Ajouter une autre entrée",
        "removeItem": "Supprimer l'élément {{index}}",
        "item": "Article {{index}} : {{label}}",
        "duplicate": "Les articles en double ne sont pas autorisés.",
        "maximum": "Maximum de {{maxItems}} éléments autorisés.",
        "description": "Les commandes d'entrée sont les différentes méthodes utilisées pour contrôler votre appareil. Elles incluent votre voix, les mouvements de la tête, les expressions faciales et d'autres connexions. Explorez les différentes commandes d'entrée ci-dessous pour en savoir plus."
    },
    "time": {
        "soon": "À venir",
        "now": "Maintenant",
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "minutesAgo": "il y a {{count}} minute",
        "minutesAgo_plural": "il y a {{count}} minutes",
        "daysAgo": "Il y a {{count}} jours",
        "daysAgo_plural": "il y a {{count}} jours",
        "monthsAgo": "il y a {{count}} mois",
        "monthsAgo_plural": "il y a {{count}} mois",
        "yearsAgo": "Il y a {{count}} an",
        "yearsAgo_plural": "il y a {{count}} ans",
        "minutesAhead": "dans {{count}} minutes",
        "todayAhead": "plus tard aujourd'hui",
        "tomorrow": "demain",
        "daysAhead": "dans {{count}} jours",
        "monthsAhead": "dans {{count}} mois",
        "yearsAhead": "dans {{count}} ans"
    },
    "peripherals": {
        "empty": "Aucun périphérique détecté",
        "switch": "Changer",
        "keyboard": "Clavier",
        "gamepad": "Manette de jeu",
        "companionApp": "Application compagnon",
        "available": "disponible à l'emploi",
        "error": "Vérifiez vos paramètres."
    },
    "camera": {
        "windowTitle": "Commandes de caméra céphable",
        "title": "Caméra",
        "titlePlural": "Appareils photo",
        "settings": "Les paramètres de la caméra",
        "start": "Démarrer la caméra",
        "restart": "Redémarrer la caméra",
        "descriptionShort": "Permet l'expression du visage et le mouvement de la tête.",
        "description": "Utilisez votre appareil photo pour détecter les expressions du visage et les gestes du corps comme différentes commandes.",
        "empty": "Aucune caméra trouvée.",
        "search": "Rechercher par nom de caméra",
        "loading": "Chargement des commandes de la caméra...",
        "error": "Erreur inattendue lors du chargement des commandes de la caméra. Veuillez vérifier votre caméra et réessayer.",
        "manage": {
            "title": "Cliquez pour afficher et gérer les détails de vos caméras.",
            "description": ""
        },
        "detected": {
            "face": "Visage détecté.",
            "noFace": "Aucun visage détecté. Veuillez ajuster votre caméra ou votre position et réessayer.",
            "command": "Détecté : {{commande}}"
        },
        "permission": {
            "title": "Autorisations de caméra requises",
            "description": "Vous devez autoriser Cephable à utiliser votre appareil photo pour utiliser les commandes du visage et du corps.",
            "button": "Paramètres d'autorisation d'ouverture",
            "no": "Pas d'accès à la caméra",
            "help": "Cephable a besoin d&#39;accéder à votre caméra pour utiliser les commandes d&#39;expression et de tête. Accédez à <strong>Paramètres système</strong>  <strong>Confidentialité</strong>  <strong>Caméra</strong> et activez Cephable pour accéder à votre caméra."
        },
        "controls": {
            "startData": "J'ai commencé à enregistrer les données du visage. Appuyez à nouveau sur le raccourci dans la fenêtre de l'appareil photo pour arrêter l'enregistrement et le téléchargement.",
            "downloadData": "Enregistrement arrêté, téléchargement de données",
            "paused": "Commandes de caméra suspendues.",
            "pause": "Suspendre les commandes de la caméra",
            "resume": "Reprendre les commandes de la caméra",
            "resumed": "Reprise des contrôles de la caméra.",
            "linesOn": "Activer les lignes du visage",
            "linesOff": "Désactiver les lignes du visage",
            "linesToggle": "Activer/désactiver le dessin des lignes du visage",
            "noDeviceTitle": "Aucune caméra détectée pouvant être utilisée avec Cephable.",
            "noDeviceDescription": "Vous devez connecter une caméra compatible avec les applications mobiles.",
            "noDeviceConnectedDescription": "Le contrôle de la caméra sert d'aperçu de l'interface. Aucune étape ne sera exécutée avec succès. Connectez cet appareil compagnon à un autre, afin de lancer des commandes.",
            "lines": "Lignes du visage"
        },
        "switch": {
            "title": "Changer de caméra",
            "description": "Sélectionnez une autre caméra à utiliser pour les commandes du visage et du corps.",
            "select": "Sélectionnez la caméra",
            "next": "Caméra suivante",
            "nextLong": "Passer à la caméra suivante",
            "empty": "Aucune autre caméra trouvée.",
            "search": "Rechercher par nom de caméra"
        },
        "baseline": {
            "title": "Référence",
            "description": "La ligne de base est la position par défaut de votre visage et de votre corps que Cephable utilise pour déterminer vos mouvements. Vous pouvez mettre à jour et réinitialiser la ligne de base ici.",
            "update": "Mettre à jour la référence",
            "reset": "Réinitialiser la ligne de base",
            "updated": "Base de référence mise à jour",
            "tooltip": "Cliquez pour mettre à jour votre ligne de base vers votre position de repos actuelle."
        },
        "edit": {
            "title": "Modifier les paramètres de la caméra",
            "description": "Vous pouvez affiner les paramètres de vos entrées nécessitant une caméra pour mieux répondre à vos besoins.",
            "autoStart": {
                "title": "Démarrer automatiquement la caméra",
                "option": "Démarrage automatique de la caméra et des commandes de tête/expression ?",
                "description": "Lorsque ce paramètre est activé, votre manette activera votre caméra, vous permettant d'utiliser les expressions faciales et les mouvements de la tête dès le démarrage de l'application. Si ce paramètre est désactivé, appuyez sur le bouton « Démarrer la caméra » sur votre page de connexion."
            },
            "head": {
                "title": "Sensibilité aux mouvements de la tête",
                "description": "La sensibilité indique à Cephable jusqu'où vous devez vous déplacer pour déclencher un contrôle. Plus la valeur est grande (la plus à droite du curseur), plus la sensibilité est élevée, et donc moins vous aurez besoin de vous déplacer pour déclencher la commande.",
                "tilt": {
                    "title": "Sensibilité à l'inclinaison de la tête",
                    "description": "Ces valeurs déterminent jusqu'où vous devez incliner la tête vers le haut, le bas, la gauche et la droite pour déclencher les commandes.",
                    "up": "Sensibilité à l'inclinaison",
                    "down": "Sensibilité d'inclinaison vers le bas",
                    "left": "Sensibilité d'inclinaison à gauche",
                    "right": "Sensibilité d'inclinaison à droite",
                    "scaleHigh": "Légère inclinaison",
                    "scaleLow": "Grande inclinaison"
                },
                "turn": {
                    "title": "Sensibilité au tour de tête",
                    "description": "Ces valeurs déterminent jusqu'où vous devez tourner la tête vers la gauche et la droite pour déclencher les commandes.",
                    "left": "Tourner à gauche Sensibilité",
                    "right": "Tourner à droite Sensibilité",
                    "scaleHigh": "Léger virage",
                    "scaleLow": "Grand virage"
                },
                "lean": {
                    "title": "Sensibilité de la tête maigre",
                    "description": "Ces valeurs déterminent jusqu'où vous devez pencher la tête en avant et en arrière pour déclencher les commandes.",
                    "forward": "Sensibilité à se pencher vers l’avant",
                    "back": "Sensibilité à se pencher en arrière",
                    "right": "Sensibilité maigre à droite",
                    "left": "Sensibilité maigre à gauche",
                    "scaleHigh": "Légèrement penché",
                    "scaleLow": "Grand maigre"
                },
                "duck": {
                    "title": "Sensibilité tête canard/montée",
                    "description": "Ces valeurs déterminent jusqu'où vous devez baisser ou relever la tête pour déclencher les commandes.",
                    "down": "Sensibilité au duvet de canard",
                    "up": "Augmentez la sensibilité",
                    "scaleHigh": "Léger décalage",
                    "scaleLow": "Grand changement"
                }
            },
            "face": {
                "title": "Sensibilité à l'expression du visage",
                "description": "La sensibilité indique à Cephable à quel point une expression est exagérée dont vous avez besoin pour déclencher un contrôle. Plus la valeur est grande (la plus à droite du curseur), plus la sensibilité est élevée, et donc moins vous aurez besoin de vous déplacer pour déclencher la commande.",
                "eyebrow": {
                    "title": "Sensibilité des sourcils",
                    "description": "Ces valeurs déterminent jusqu'où vous devez lever ou baisser vos sourcils pour déclencher les commandes.",
                    "up": "Augmenter la sensibilité des sourcils",
                    "scaleHigh": "Légère augmentation",
                    "scaleLow": "Augmentation importante"
                },
                "mouth": {
                    "title": "Sensibilité buccale",
                    "description": "Ces valeurs déterminent jusqu'où vous devez ouvrir ou fermer la bouche pour déclencher les commandes.",
                    "open": "Sensibilité à la bouche ouverte",
                    "close": "Sensibilité de la bouche fermée",
                    "smile": "Sensibilité du sourire",
                    "scaleHigh": "Légèrement ouvert",
                    "scaleLow": "Grand Ouvert",
                    "closeScaleHigh": "Légèrement fermé",
                    "closeScaleLow": "Bien fermé",
                    "smileScaleHigh": "Léger sourire",
                    "smileScaleLow": "Grand sourire"
                }
            },
            "mouse": {
                "title": "Mouvement de la tête pour les commandes de la souris",
                "description": "Déterminez si et comment vous souhaitez utiliser les commandes de mouvements de la tête pour déplacer votre souris au lieu de déclencher d'autres sorties.",
                "enable": {
                    "title": "Activer le mouvement de la tête pour les commandes de la souris",
                    "description": "Si cette option est activée, certaines de vos commandes de mouvement de la tête seront utilisées pour déplacer votre souris au lieu des commandes de déclenchement.",
                    "option": "Utiliser les commandes de la tête pour le mouvement de la souris ?"
                },
                "input": {
                    "title": "Type d'entrée de la souris",
                    "description": "Sélectionnez le type de gestes de la tête que vous souhaitez attribuer aux commandes de la souris. Par exemple, Head Tilting signifie que vous pouvez incliner votre tête vers la gauche et la droite pour déplacer votre souris vers la gauche et la droite, Head Turning signifie que vous pouvez tourner la tête vers la gauche et la droite pour déplacer votre souris et Head Leaning signifie que vous pouvez vous pencher vers la gauche et la droite pour bouger. votre souris.",
                    "option": "Sélectionnez le type d'entrée",
                    "optionLong": "Sélectionnez le type de mouvement de tête que vous souhaitez utiliser pour contrôler votre souris."
                },
                "invert": {
                    "title": "Inverser le mouvement de la souris",
                    "description": "Si cette option est activée, la direction dans laquelle vous déplacez votre tête sera inversée par rapport à la direction dans laquelle votre souris se déplace. Pour l'axe X : si cette option est activée, un déplacement vers la gauche déplacera votre souris vers la droite et un déplacement vers la droite la déplacera vers la gauche. Pour l'axe Y : si cette option est activée, le fait de descendre déplacera votre souris vers le haut et le fait de monter la fera descendre.",
                    "x": "Inverser le mouvement de la souris sur l'axe X ?",
                    "y": "Inverser le mouvement de la souris sur l'axe Y ?"
                },
                "mode": {
                    "title": "Mode de déplacement de la souris",
                    "description": "Sélectionnez la manière dont vous souhaitez que le curseur réagisse aux mouvements de votre tête."
                },
                "speed": {
                    "title": "Vitesse de la souris",
                    "description": "Déterminez la vitesse constante à laquelle vous souhaitez que le curseur se déplace.",
                    "fast": "Rapide",
                    "slow": "Lent"
                },
                "linear": {
                    "title": "Mouvement linéaire de la souris",
                    "description": "Si cette option est activée, le curseur se déplace uniquement en lignes droites horizontales ou verticales, ce qui facilite la navigation dans ces directions spécifiques sans aucune dérive diagonale.",
                    "option": "Utiliser le mouvement linéaire de la souris ?"
                },
                "accelerationRate": {
                    "title": "Taux d'accélération de la souris",
                    "description": "Ajustez la vitesse à laquelle le curseur accélère au fur et à mesure que vous maintenez votre tête immobile."
                },
                "accelerationCurve": {
                    "title": "Courbe d'accélération de la souris",
                    "description": "Ajustez la vitesse à laquelle la vitesse du curseur augmente par rapport au mouvement de la tête.",
                    "linear": "Linéaire",
                    "exponential": "Exponentiel",
                    "sublinear": "Sous-linéaire"
                },
                "maximumSpeed": {
                    "title": "Vitesse maximale de la souris",
                    "description": "Déterminez le nombre maximal de pixels que le curseur peut déplacer par seconde."
                },
                "steadyGlide": {
                    "title": "Glisse stable",
                    "description": "Lorsque vous déplacez votre tête au-delà d’un certain point, le curseur glisse continuellement dans cette direction à une vitesse constante."
                },
                "speedBoost": {
                    "title": "Augmentation de la vitesse",
                    "description": "Le curseur commence à se déplacer plus rapidement à mesure que vous gardez la tête dans la même position. Plus vous gardez la tête immobile longtemps, plus le curseur accélère rapidement."
                },
                "dynamicGlide": {
                    "title": "Glisse dynamique",
                    "description": "La vitesse du curseur augmente en fonction de la distance à laquelle vous bougez la tête. Plus vous bougez la tête, plus le curseur glisse vite."
                },
                "proportionalSpeed": {
                    "title": "Vitesse proportionnelle",
                    "description": "Le curseur suit le bout de votre nez proportionnellement aux dimensions de votre écran."
                },
                "off": {
                    "title": "Désactivé",
                    "description": "Le mouvement de la souris est désactivé."
                },
                "disabled": "Cette fonctionnalité est désactivée pour les connexions et extensions distantes."
            }
        },
        "stop": "Arrêter la caméra",
        "show": "Afficher la caméra",
        "hide": "Masquer la caméra",
        "warn": "Les commandes de la caméra n'ont pas été démarrées, démarrez votre caméra pour autoriser les commandes du visage et du corps.",
        "draw": {
            "error": "Erreur lors du chargement du flux de la caméra. Veuillez vérifier votre caméra et réessayer."
        },
        "select": "Sélectionnez une caméra avec laquelle vous souhaitez vous associer pour des commandes améliorées à l'aide de votre visage, de votre corps et des boutons d'action rapide.",
        "extension": {
            "title": "Extension : Caméra",
            "enabledTitle": "Activer les commandes de la caméra",
            "enabledDescription": "Lorsque ce paramètre est activé, Cephable utilise votre caméra pour détecter les mouvements de votre visage et de votre tête afin de vous permettre de contrôler votre appareil par des expressions et des gestes, notamment en utilisant les mouvements de votre tête comme une souris."
        },
        "live": "EN DIRECT",
        "paused": "La caméra s'est arrêtée."
    },
    "microphone": {
        "windowTitle": "Commandes vocales céphables",
        "title": "Microphone",
        "titlePlural": "Micros",
        "settings": "Paramètres du microphone",
        "start": "Démarrer le microphone",
        "stop": "Arrêter le microphone",
        "descriptionShort": "Permet les commandes vocales et la dictée.",
        "description": "Utilisez votre microphone intégré pour activer les commandes vocales et la dictée.",
        "select": "Sélectionnez un microphone avec lequel vous souhaitez vous associer pour des commandes améliorées à l'aide de votre voix.",
        "empty": "Aucun microphone trouvé.",
        "search": "Rechercher par nom de microphone",
        "manage": {
            "title": "Cliquez pour afficher et gérer les détails de vos microphones.",
            "description": ""
        },
        "permission": {
            "title": "Autorisations de microphone requises",
            "description": "Vous devez autoriser Cephable à utiliser votre microphone pour utiliser les commandes vocales.",
            "button": "Paramètres d'autorisation d'ouverture",
            "no": "Pas d'accès au microphone",
            "help": "Cephable a besoin d&#39;accéder à votre microphone pour utiliser les commandes vocales. Accédez à <strong>Paramètres système</strong>  <strong>Confidentialité</strong>  <strong>Microphone</strong> et activez Cephable pour accéder à votre microphone."
        },
        "controls": {
            "pause": "Suspendre les commandes vocales",
            "paused": "Contrôles suspendus.",
            "resume": "Reprendre les commandes vocales",
            "dictationPlay": "Démarrer le mode dictée",
            "dictationPause": "Arrêter le mode dictée",
            "prompt": "Commencez à parler pour voir vos commandes vocales ici...",
            "dictationPrompt": "Commencez à parler pour taper ce que vous dites...",
            "latency": "Latence élevée détectée. Pensez à fermer certaines applications susceptibles de consommer trop de ressources.",
            "noDeviceConnectedDescription": "Le contrôle du microphone sert d'aperçu de l'interface. Aucune étape ne sera exécutée avec succès. Connectez cet appareil compagnon à un autre, afin de lancer des commandes.",
            "status": {
                "paused": "En pause.",
                "dictating": "Dicter.",
                "optimistic": "Optimiste:",
                "listening": "Écoute:",
                "loadingModel": "Chargement du modèle vocal...",
                "thinking": "Pensée...",
                "loadingPhiModel": "Chargement du modèle de génération de texte...",
                "generatingText": "Générateur...",
                "preparingPhiModel": "Préparation du modèle de génération de texte...",
                "permission": "Vérification des autorisations du microphone...",
                "typing": "Dactylographie..."
            },
            "loadingDetail": "Cela peut prendre quelques minutes.",
            "generatingTextDetail": "Arrêtez la génération en changeant d'application ou en disant « arrêtez de générer »",
            "command": "Commande",
            "contextual": "Contextuel",
            "send": "Envoyer",
            "typedInputLabel": "Saisissez une commande ou un texte à envoyer",
            "listeningPlaceholder": "Écoute...",
            "dictationListeningPlaceholder": "Écoute...",
            "pausedPlaceholder": "La voix s'est interrompue..."
        },
        "edit": {
            "title": "Modifier les paramètres du microphone",
            "autoStart": {
                "title": "Microphone à démarrage automatique",
                "option": "Microphone à démarrage automatique",
                "description": "L'écoute des commandes vocales se lance automatiquement à la mise sous tension de l'appareil. Si cette fonction est désactivée, appuyez sur « Démarrer l'écoute » pour l'activer."
            },
            "optimistic": {
                "title": "Commandes vocales plus rapides et optimistes",
                "option": "Commandes vocales plus rapides et optimistes",
                "description": "Ce mode rend les commandes vocales plus rapides et plus réactives, mais moins tolérantes. Utilisez le mode Standard si vous souhaitez la dictée vocale ou une plus grande flexibilité. Remarque : le mode optimiste peut s’activer accidentellement si vous ne prononcez pas les commandes exactement."
            },
            "confirm": {
                "title": "Vous avez des changements non enregistrés.",
                "description": "Modifications non enregistrées détectées. Souhaitez-vous enregistrer avant de quitter ?"
            },
            "aiCommands": {
                "title": "Commandes vocales intelligentes",
                "description": "Énoncez les commandes naturellement — l'IA de Cephable comprend ce que vous voulez dire sans avoir besoin d'une correspondance exacte.",
                "option": "Commandes vocales intelligentes"
            },
            "aiDictation": {
                "title": "Dictée intelligente et saisie rapide",
                "description": "Écoute vocale améliorée avec ponctuation automatique, noms propres et structure des phrases. Dites « tapez [quelque chose] » pour utiliser la saisie rapide et obtenir une dictée plus intelligente et plus naturelle.",
                "option": "Dictée intelligente et saisie rapide"
            },
            "description": "Gérez vos commandes vocales et vos paramètres de dictée pour cette connexion."
        },
        "warn": "Votre microphone n'est pas activé. Activez-le pour autoriser les commandes vocales et la dictée.",
        "devices": {
            "error": "Périphérique d'entrée du microphone introuvable."
        },
        "startDescription": "Allumez le microphone pour commencer à écouter les commandes.",
        "modes": {
            "title": "Mode",
            "generate": {
                "label": "Générer",
                "placeholder": "Décrivez ce que vous souhaitez générer"
            },
            "rewrite": {
                "label": "Récrire",
                "placeholder": "Comment dois-je réécrire le texte ?"
            },
            "translate": {
                "label": "Traduire",
                "placeholder": "Traduire dans quelle langue ?"
            },
            "automate": {
                "label": "Automatiser",
                "placeholder": "Décrivez les étapes que vous souhaitez automatiser."
            },
            "auto": {
                "label": "Auto",
                "placeholder": "Saisissez n'importe quoi — Cephable choisit le meilleur mode",
                "upgrade": "Cephable a besoin de {{tier}} pour exécuter cette action."
            },
            "control": {
                "label": "Contrôle",
                "placeholder": "Saisissez une commande ou un texte à envoyer"
            }
        },
        "context": {
            "add": "Ajouter du contexte",
            "title": "Ajouter du contexte",
            "highlighted": "Texte mis en évidence",
            "clipboard": "presse-papiers",
            "other": "Autre…",
            "otherTitle": "Ajouter un contexte personnalisé",
            "otherPlaceholder": "Saisissez ou collez le contexte à utiliser",
            "otherConfirm": "Ajouter",
            "otherCancel": "Annuler",
            "remove": "Supprimer le contexte",
            "required": "Le contexte est requis pour {{mode}}",
            "files": "Fichiers…",
            "folders": "Dossiers…",
            "removeAttachment": "Supprimer la pièce jointe",
            "dropToAttach": "Glissez-déposez des fichiers ou des dossiers pour les joindre en tant que contexte"
        }
    },
    "localization": {
        "title": "Paramètres de langue",
        "titleShort": "Langue",
        "description": "Choisissez votre langue préférée dans une liste de langues prises en charge.",
        "newUserDescription": "Veuillez sélectionner une langue préférée avant de continuer.",
        "edit": "Modifier les préférences",
        "display": {
            "title": "Langue d'affichage",
            "description": "Langue d'affichage lors de l'utilisation de Cephable. Cela inclut les menus, les notifications et les commandes des applications, affichés dans la langue de votre choix."
        },
        "voice": {
            "title": "Langue de commande vocale",
            "description": "C'est la langue utilisée lors de la reconnaissance des dictées et des commandes vocales. La spécification de la langue améliore la précision de vos saisies vocales.",
            "settings": {
                "title": "Reconnaissance vocale et langue d'affichage",
                "description": "Ajustez vos paramètres de langue pour l'affichage et les commandes vocales. Cette option vous permet de sélectionner vos langues préférées pour le texte à l'écran et les interactions avec le microphone, comme les commandes vocales et la dictée."
            }
        },
        "locales": {
            "en": "English - Anglais",
            "en-us": "English (US) - Anglais (États-Unis)",
            "es": "Español - Espagnol",
            "fr": "Français",
            "it": "Italiano — Italien",
            "de": "Deutsch - Allemand",
            "ja": "日本語 - Japonais",
            "en-gb": "English (UK) - Anglais (Royaume-Uni)",
            "en-in": "English (India) - Anglais (Inde)"
        },
        "save": {
            "success": "Préférences locales de l'utilisateur enregistrées !",
            "error": "Erreur lors de l'enregistrement des préférences de paramètres régionaux de l'utilisateur"
        },
        "profile": {
            "view": "Variantes",
            "title": "Langue de contrôle des applications",
            "question": "Quelle langue de contrôle d'application souhaitez-vous modifier ?",
            "description": "Certaines commandes d'application proposent des variantes linguistiques. Changez de langue pour les modifier et les personnaliser.",
            "change": "Changer de langue"
        },
        "unsupported": {
            "title": "Langue non prise en charge {{locale}}",
            "description": "La langue sélectionnée n'est pas prise en charge. Veuillez choisir une autre langue."
        },
        "select": "Sélectionner la langue",
        "localesShort": {
            "en": "Anglais",
            "en-us": "Anglais (États-Unis)",
            "es": "Espagnol",
            "fr": "Français",
            "it": "italien",
            "de": "Allemand",
            "ja": "japonais",
            "en-gb": "Anglais (Royaume-Uni)",
            "en-in": "Anglais (Inde)"
        }
    },
    "mobileApp": {
        "title": "Application mobile"
    },
    "skipToMain": "Accéder au Contenu Principal",
    "dashboard": {
        "title": "Tableau de bord"
    },
    "developer": {
        "title": "Promoteur",
        "titleLong": "Ressources pour les développeurs",
        "description": "Cephable peut être intégré directement dans votre application, jeu ou service à l'aide de nos SDK.",
        "sdk": {
            "title": "Découvrez nos SDK",
            "description": "Nous fournissons des SDK de premier ordre conçus pour intégrer de manière transparente la reconnaissance vocale et les contrôles adaptatifs dans vos applications. Nos outils sont conçus pour améliorer l'interaction des utilisateurs grâce à des commandes intuitives et pour favoriser l'accessibilité, garantissant ainsi que votre logiciel peut être utilisé plus efficacement par tous les utilisateurs.",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "Web",
                "description": "Intégrez les commandes vocales et adaptatives directement dans vos applications Web.",
                "action": "Obtenir le Package NPM"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Applications Windows",
                "description": "Exploitez la puissance de .NET pour créer des applications avec nos SDK WPF et WinUI3.",
                "actionCore": "Obtenez le Package de base",
                "actionWpf": "Obtenir le Package WPF"
            },
            "android": {
                "title": "Androïde",
                "subtitle": "Appareils mobiles",
                "description": "Applications Android conçues pour faciliter les capacités de voix et de mouvement de la tête.",
                "action": "Obtenir le SDK Android"
            },
            "more": {
                "title": "Plus",
                "description": "Vous ne trouvez pas ce que vous cherchez ? Contactez-nous et nous pourrons vous aider.",
                "action": "Demander un SDK"
            },
            "docs": {
                "title": "Documentation",
                "description": "Explorez la documentation détaillée, les exemples de projets et les guides pour commencer à développer avec Cephable.",
                "action": "Consulter les documents"
            }
        },
        "demo": {
            "title": "Démos",
            "titleLong": "Découvrez nos SDK en action",
            "description": "Découvrez la puissance de nos technologies de contrôle de la voix et des mouvements de la tête grâce à nos exemples d'applications. Des jeux interactifs aux applications Web et mobiles dynamiques, chaque exemple démontre la polyvalence et l'efficacité de nos SDK. Explorez ces exemples pour obtenir des informations et des idées pour intégrer une accessibilité améliorée et des expériences immersives dans vos propres projets.",
            "game": {
                "title": "Jeu 2048",
                "subtitle": "Web",
                "description": "Améliorez le gameplay traditionnel avec des commandes adaptatives de voix et de mouvement de la tête.",
                "action": "Jouer le jeu"
            },
            "unity": {
                "title": "Unité",
                "subtitle": "Développement de jeux",
                "description": "Découvrez comment les commandes adaptatives peuvent être exploitées dans les jeux pour offrir une expérience utilisateur plus attrayante.",
                "action": "Obtenir l'échantillon"
            },
            "samples": "Documents et exemples",
            "other": {
                "title": "Autres démos",
                "description": "Découvrez de première main comment Cephable peut améliorer votre application, votre jeu ou votre appareil.",
                "action": "Voir plus de démos"
            },
            "web": {
                "title": "Exemples de SDK Web",
                "subtitle": "Web",
                "description": "Intégration simple de toutes nos fonctionnalités principales dans les applications Web.",
                "action": "Découvrez le SDK"
            },
            "docs": {
                "title": "Documentation et exemples pour les développeurs",
                "description": "Explorez la documentation détaillée, les exemples de projets et les guides pour commencer à développer avec Cephable.",
                "action": "Consulter les documents"
            }
        },
        "other": {
            "title": "Autres ressources",
            "description": "Si vous ne trouvez pas ce dont vous avez besoin dans nos SDK, essayez de travailler directement avec nos API ou contactez la communauté pour obtenir de l'aide, de l'inspiration et du soutien.",
            "api": {
                "title": "API",
                "description": "Nos API vous permettent d'interagir directement avec Cephable. Vous pouvez utiliser nos API pour créer des intégrations personnalisées."
            },
            "support": {
                "title": "Soutien",
                "description": "Vous ne trouvez pas ce que vous cherchez ? Contactez notre communauté via Discord.",
                "action": "Rejoignez Discord"
            }
        }
    },
    "invalidNumber": "N/A",
    "upgrade": "Mise à niveau",
    "license": {
        "trial": {
            "subtitle": "Vous pouvez inviter {{count}} collègues à essayer Cephable avec vous.",
            "noUsersSubtitle": "Il ne vous reste plus d'utilisateurs d'essai. Passez à une licence payante pour ajouter plus d'utilisateurs.",
            "expired": {
                "user": "Votre mise à niveau gratuite vers {{productName}} expire le {{date}}. Pour effectuer une mise à niveau, veuillez contacter l'administrateur de votre organisation : {{admin}}.",
                "admin": "Votre mise à niveau gratuite vers {{productName}} expire le {{date}}.",
                "userLong": "Il semblerait que votre mise à niveau gratuite vers {{productName}} ait expiré. Pour effectuer une mise à niveau, veuillez contacter l'administrateur de votre organisation : {{admin}}.",
                "adminLong": "Il semblerait que votre mise à niveau gratuite vers {{productName}} ait expiré. Vous pouvez mettre à niveau votre licence pour continuer à accéder aux fonctionnalités avancées non disponibles dans Cephable Basic."
            },
            "start": "Commencez un essai gratuit",
            "title": {
                "single": "Vous avez bénéficié d'une mise à niveau gratuite vers {{productName}} avec {{days}} jours restants.",
                "multiple": "{{organization}} est en essai gratuit avec {{days}} jours restants"
            },
            "upgrade": "En effectuant une mise à niveau, conservez votre accès à des fonctionnalités telles que les commandes vocales améliorées, les tâches intelligentes de l'IA et de nombreuses commandes d'applications prédéfinies."
        },
        "required": {
            "title": "Une licence professionnelle Cephable est requise",
            "description": "Il semble que vous utilisiez Cephable Basic, qui ne prend pas en charge l'utilisation commerciale de Cephable. Veuillez passer à une licence professionnelle pour continuer à utiliser l'application."
        },
        "upgrade": {
            "professional": "Mise à niveau vers la Licence Professionnelle Cephable",
            "generic": {
                "title": "Améliorez Votre Expérience Cephable",
                "description": "La plateforme Cephable propose différents produits destinés à une utilisation commerciale au travail, à l'école ou intégrés dans des solutions natives."
            },
            "fallback": {
                "title": "Erreur lors du chargement du portail de facturation",
                "description": "Impossible de charger le portail de facturation. Veuillez cliquer sur le bouton ci-dessous pour contacter sales@cephable.com afin de poursuivre la mise à niveau."
            }
        },
        "activate": {
            "question": "Vous avez déjà une clé de licence ?",
            "button": "Activer",
            "title": "Activer la Clé de Licence",
            "description": "Saisissez votre clé de licence pour mettre à niveau Cephable. Si vous n'en avez pas, démarrez un essai gratuit ou achetez une licence.",
            "fieldLabel": "Clé de Licence",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "success": "Félicitations. Votre compte a été mis à niveau vers {{license}} !",
            "invalid": {
                "key": "Clé non valide. Veuillez vous assurer que vous avez saisi la bonne clé.",
                "empty": {
                    "key": "Clé non valide. Veuillez vérifier la valeur saisie.",
                    "name": "Nom d'organisation non valide. Veuillez vérifier la valeur saisie."
                }
            },
            "descriptionLong": "Saisissez votre clé de licence pour mettre à niveau Cephable. Si vous n'en avez pas, démarrez un essai gratuit ou achetez une licence."
        },
        "welcome": {
            "title": "Bienvenue chez {{license}}.",
            "description": "Vous avez rejoint avec succès {{organization}}. {{description}}"
        },
        "redirect": {
            "title": "Redirection",
            "description": "Vous avez été redirigé vers un portail de facturation externe. Cela ouvrira un nouvel onglet dans votre navigateur. Si vous n'êtes pas redirigé dans quelques secondes, veuillez cliquer sur le bouton ci-dessous.",
            "error": "Erreur de redirection de facturation",
            "external": "Redirection effectuée. Veuillez vérifier votre navigateur."
        },
        "key": {
            "title": "Clé de licence",
            "titlePlural": "Clés de licence",
            "description": "Une clé de licence est un identifiant unique utilisé pour accorder l'accès aux fonctionnalités Cephable Professional, Education ou Developer.",
            "details": "Détails de la clé de licence",
            "assigned": "Utilisé le : {{date}}",
            "expires": "Expire le : {{date}}",
            "assign": "Attribuer une clé à une nouvelle organisation",
            "error": "Erreur lors du chargement de la clé de licence.",
            "empty": {
                "title": "Aucune clé de licence trouvée.",
                "description": "Il ne semble pas qu'il existe de clés de licence correspondant à ces critères. Ou vous n'avez pas encore acheté de clé de licence."
            },
            "product": {
                "title": "Achat",
                "titleLong": "Acheter des clés de licence",
                "description": "Achetez une clé de licence pour exploiter tout le potentiel de Cephable. Consultez les différents plans et options de tarification disponibles.",
                "action": "Achetez maintenant",
                "empty": {
                    "title": "Aucun produit trouvé.",
                    "description": "Il semble que vous n'ayez aucun produit. Veuillez contacter notre équipe commerciale ou votre représentant pour vous aider à résoudre ce problème."
                },
                "yearly": "Facturé annuellement",
                "years": "Facturé tous les {{value}} ans",
                "days": "Facturé tous les {{value}} jours",
                "Subscription": {
                    "title": "Abonnement"
                },
                "MeteredConsumption": {
                    "title": "Consommation mesurée"
                },
                "PayDown": {
                    "title": "Payer"
                },
                "OneTime": {
                    "title": "Une fois"
                }
            }
        },
        "pro": {
            "tag": "Pro",
            "detail": "Il s'agit d'une fonctionnalité réservée à Cephable Professional",
            "requiredDetail": "Une licence Cephable Professionnelle est requise pour cette fonctionnalité. Vous pouvez mettre à niveau ou démarrer un essai gratuit dans les paramètres de votre compte."
        },
        "titlePlural": "Licences"
    },
    "purchase": "Achat",
    "saveError": "Erreur lors de l'enregistrement des modifications.",
    "description": "Description",
    "expand": "Développer",
    "expandMenu": "Développer le menu",
    "editor": {
        "title": "Éditeur Markdown",
        "bold": "Audacieux",
        "italic": "Italique",
        "underline": "Souligner",
        "hr": "Règle horizontale",
        "link": "Lien",
        "quote": "Citation",
        "code": "Code",
        "codeBlock": "Bloc de code",
        "comment": "Commentaire",
        "image": "Image",
        "table": "Tableau",
        "unordered-list": "Liste non ordonnée",
        "ordered-list": "Liste ordonnée",
        "checked-list": "Liste de contrôle",
        "help": "Aide",
        "edit": "Modifier",
        "live": "En direct",
        "preview": "Aperçu",
        "fullscreen": "Plein écran",
        "placeholder": "Veuillez saisir le texte Markdown ici...",
        "strikethrough": "Barré"
    },
    "created": "Créé : {{value}}",
    "updated": "Mis à jour : {{value}}",
    "deleted": "Supprimé : {{value}}",
    "expires": "Expire : {{value}}",
    "expired": "Expiré : {{value}}",
    "used": "Utilisé : {{value}}",
    "results": "Résultats",
    "panel": {
        "title": "Panneau Céphable",
        "question": "Panneau de démarrage automatique ?",
        "position": {
            "top": "Haut",
            "right": "Droite",
            "left": "Gauche",
            "bottom": "Bas ",
            "description": "Sélectionnez l'endroit où vous souhaitez que le panneau Cephable apparaisse sur votre écran.",
            "label": "Position"
        },
        "sections": {
            "description": "Choisissez les sections visibles du panneau. Vous pouvez masquer des sections selon vos préférences pour optimiser l'espace du panneau.",
            "microphone": "Microphone et commandes vocales",
            "camera": "Commandes de la caméra et du visage/de la tête",
            "profile": "Contrôles et aperçus de l'application",
            "globalControls": "Contrôles globaux et de périphérique",
            "tasks": "Tâches intelligentes",
            "buttons": "Boutons d'action rapide"
        },
        "titleShort": "Panneau",
        "description": "Voici le panneau de contrôle principal. Toujours visible, il vous permet de contrôler vos applications à la voix, et bien plus encore.",
        "reconnecting": "Se reconnecter…",
        "reconnectRetry": "Réessayer"
    },
    "resume": "CV",
    "textGeneration": {
        "settings": "Paramètres de génération de texte",
        "edit": {
            "title": "Modifier les paramètres de génération de texte",
            "description": "Vous pouvez affiner les paramètres de votre génération de texte intelligente pour créer les meilleures sorties pour vous.",
            "autoStart": {
                "title": "Génération automatique de texte de préchauffage",
                "description": "Lorsque cette option est activée, Cephable AI effectue automatiquement un préchauffage des modèles d'IA utilisés pour les tâches de création ou d'automatisation. Ce préchauffage améliore leur performance, mais consomme davantage de ressources système. Désactiver cette option permet d'économiser des ressources, mais peut ralentir l'exécution des tâches.",
                "option": "Modèles d'IA de génération de texte à préchauffage automatique ?"
            },
            "prompt": {
                "title": "Informations complémentaires pour la génération de texte",
                "description": "Saisissez les informations supplémentaires à utiliser avec l'IA de Cephable pour générer du texte. Utilisez ce champ pour indiquer vos préférences concernant le ton, le style d'écriture ou tout autre détail.",
                "field": "Invite supplémentaire",
                "placeholder": "Par exemple, adoptez un ton amical, écrivez comme un professionnel, soyez concis et direct. Lorsque vous écrivez du code, laissez des commentaires pertinents, mais pas trop nombreux, etc."
            },
            "enableTextGen": {
                "title": "Activer la génération de texte intelligente",
                "description": "Lorsque ce paramètre est activé, Cephable AI peut rédiger, réécrire, résumer et traduire du contenu, ou automatiser des actions de bureau dans toutes vos applications.",
                "option": "Utiliser la génération de texte intelligente ?"
            },
            "terminate": {
                "title": "Ressources d'IA claires",
                "description": "Cliquez pour libérer les ressources utilisées par les tâches de création ou d'automatisation. Cela libérera des ressources sur votre ordinateur, mais pourrait ralentir ces tâches lors de leur prochaine utilisation.",
                "button": "Ressources claires",
                "success": "Effacement des ressources de génération de texte.",
                "confirm": {
                    "title": "Ressources d'IA claires",
                    "description": "Êtes-vous sûr de vouloir libérer les ressources utilisées pour les tâches de création ou d'automatisation ? Cette action libérera des ressources sur votre ordinateur, mais pourrait ralentir ces tâches lors de leur prochaine utilisation.",
                    "confirm": "Oui, des ressources claires",
                    "cancel": "Annuler"
                }
            },
            "clearModelCache": {
                "title": "Vider le cache des modèles d'IA",
                "description": "Cela libérera de l'espace de stockage sur votre ordinateur et téléchargera à nouveau le modèle actuellement sélectionné.",
                "button": "Effacer et retélécharger",
                "success": "Fichiers de modèle locaux supprimés.",
                "confirm": {
                    "title": "Vider et retélécharger le cache du modèle d'IA",
                    "description": "Êtes-vous sûr de vouloir vider le cache du modèle d'IA et supprimer les fichiers de votre système ? Le modèle actuellement sélectionné sera retéléchargé automatiquement.",
                    "confirm": "Oui, effacer et retélécharger",
                    "cancel": "Annuler"
                },
                "error": "Erreur lors de la suppression des fichiers de modèle locaux."
            },
            "enableHistory": {
                "title": "Activer l'historique de génération de texte",
                "description": "Avec ce paramètre activé, Cephable AI utilisera votre historique de génération de texte pour générer du texte avec le contexte de votre action précédente.",
                "option": "Utiliser l'historique de génération de texte ?"
            },
            "modelSelection": {
                "title": "Modèle d'IA",
                "description": "Choisissez le modèle d'IA (famille et taille) compatible avec cet appareil. Les modèles plus grands offrent de meilleurs résultats, mais consomment davantage de ressources. Téléchargez-en plusieurs pour pouvoir passer rapidement de l'un à l'autre.",
                "family": "Modèle de famille",
                "size": "Taille du modèle",
                "downloaded": "Téléchargé",
                "downloading": "Téléchargement…",
                "download": "Télécharger",
                "delete": "Supprimer le téléchargement",
                "unavailable": "Non pris en charge sur cet appareil",
                "requiresBetterDevice": "Ce modèle nécessite un appareil plus performant pour fonctionner.",
                "selectPrompt": "Sélectionnez un modèle",
                "noModels": "Aucun modèle compatible n'est disponible pour cet appareil pour le moment.",
                "deleteConfirm": {
                    "title": "Supprimer le modèle téléchargé ?",
                    "description": "Cela libère de l'espace disque. Vous pourrez le télécharger à nouveau plus tard."
                },
                "notDownloaded": "Ce modèle est sélectionné mais pas encore téléchargé. Cliquez sur Télécharger pour l'utiliser.",
                "readyToUse": "Téléchargé — prêt à l'emploi",
                "offlineNoModels": "Vous êtes hors ligne et aucun modèle n'est enregistré sur cet appareil. Connectez-vous à Internet pour consulter et télécharger les modèles disponibles.",
                "offlineDownloadUnavailable": "Vous êtes hors ligne, ce modèle ne peut donc pas être téléchargé. Connectez-vous à Internet pour le télécharger, ou choisissez un modèle que vous avez déjà téléchargé.",
                "license": {
                    "upgrade": "Nécessite une mise à niveau de licence",
                    "blockedNeedsDownload": "Ce modèle nécessite une licence. Téléchargez un modèle inférieur ou effectuez une mise à niveau pour continuer."
                },
                "notEnoughSpace": "Espace insuffisant sur l'appareil",
                "notEnoughSpaceDetail": "Nécessite {{requis}} mais seul {{free}} est disponible sur cet appareil. Libérez de l'espace et réessayez.",
                "fallback": {
                    "alert": "{{fallback}} est utilisé à la place de {{preferred}}, ce qui nécessite une mise à niveau.",
                    "active": "{{preferred}} nécessite {{license}}. {{fallback}} est utilisé à la place jusqu'à ce que vous choisissiez un autre modèle ou que vous effectuiez une mise à niveau."
                }
            }
        },
        "prompt": {
            "systemPrompt": "Générez UNIQUEMENT le texte demandé : aucune explication, aucun commentaire, aucun élément superflu. Pas de mise en forme Markdown ni d’explication non sollicitée. Pour le code, fournissez uniquement le code brut : sans balises, sans étiquettes de langage, sans explication. N’expliquez pas votre démarche.",
            "appName": "Vous générez actuellement du texte pour {{appName}}.",
            "userPreferences": "Respectez ces préférences utilisateur quant à la manière dont ils souhaitent que le texte soit généré : {{userPreferences}}."
        },
        "translatePrompt": {
            "systemPrompt": "Traduisez le texte suivant en {{language}}. Affichez UNIQUEMENT le texte traduit. Sans explications, sans préambule, sans mise en forme Markdown, sans balises de code, sans notes, ni remarques entre parenthèses concernant la traduction. Conservez la mise en forme. Pour le code : traduisez uniquement les commentaires et les chaînes de caractères, en préservant la syntaxe à l’identique.",
            "userPreferences": "Respectez ces préférences utilisateur quant à la manière dont ils souhaitent que le texte soit généré : {{userPreferences}}.",
            "genericUserPrompt": "Traduire : {{userRequestText}}"
        },
        "disabled": {
            "title": "Les tâches intelligentes sont désactivées",
            "description": "Il semble que vous ayez désactivé les tâches intelligentes. Mettez à jour vos paramètres pour débloquer la génération et la réécriture de texte, et bien plus encore."
        },
        "skipTyping": {
            "complete": "Génération terminée et prête à être copiée dans votre presse-papiers."
        },
        "summarizePrompt": {
            "systemPrompt": "Résumez le texte fourni de manière concise. Il peut faire partie d'un document plus long. N'utilisez pas la mise en forme Markdown ni les balises de code. Ne fournissez que le résumé : pas de préambule, d'étiquettes, d'explications ni de commentaires, et n'expliquez pas votre démarche.",
            "userPreferences": "Respectez ces préférences utilisateur concernant la manière dont le texte doit être généré : {{userPreferences}}.",
            "summarizeInstructions": "Instructions : {{summarizeInstructions}}.",
            "userPrompt": "Résumé : {{userRequestText}}"
        },
        "rewritePrompt": {
            "systemPrompt": "Réécrivez ou reformatez le texte fourni selon les instructions. En cas de reformatage (listes, tableaux, modifications de structure, etc.), conservez le texte original à l'identique. En cas de réécriture (ton, style, longueur, etc.), conservez le sens, mais pas nécessairement le vocabulaire. Ce texte peut faire partie d'un document plus long. Respectez la mise en forme du texte source : s'il est déjà au format Markdown ou sous forme de code, conservez-la. Sinon, n'ajoutez pas de mise en forme Markdown (titres, gras, puces, balises de code) sauf si les instructions demandent explicitement une liste, un tableau ou une structure similaire. Affichez UNIQUEMENT le résultat, sans préambule, étiquettes, titres, explications ni commentaires.",
            "userPreferences": "Respectez ces préférences utilisateur concernant la manière dont le texte doit être généré : {{userPreferences}}.",
            "rewriteInstructions": "Instructions : {{rewriteInstructions}}."
        }
    },
    "profile": {
        "title": "Contrôles de l'application",
        "titlePlural": "Contrôles de l'application",
        "titlePreview": "Aperçu des commandes",
        "previous": "Contrôles de l'application précédente",
        "manage": "Gérer les contrôles des applications",
        "view": "Contrôles d'affichage",
        "edit": "Modifier les contrôles de l'application",
        "add": "Ajouter des contrôles d'application",
        "create": "Créer des contrôles d'application",
        "warn": "La caméra ou le microphone doivent être démarrés pour utiliser les commandes de votre application.",
        "descriptionShort": "Découvrez les différentes manières dont Cephable vous aide à contrôler vos appareils et logiciels.",
        "name": "Nom de l'application",
        "nameQuestion": "Comment souhaitez-vous appeler ces contrôles d’application ?",
        "newName": "Nouveaux contrôles d'application",
        "search": "Rechercher les contrôles d'application par nom",
        "searchLong": "Rechercher les contrôles d'application par nom ou description",
        "keyboardAndMouse": "Clavier et souris",
        "genericController": "Manette de jeu",
        "keyboardMouseAndController": "Clavier, souris et contrôleur",
        "permissionError": "Vous n'êtes pas autorisé à utiliser ces contrôles d'application.",
        "set": {
            "title": "Il semble que vous n'ayez pas encore défini de contrôles d'application.",
            "cta": "Définir les contrôles de l'application",
            "empty": {
                "auto": "Passez à une autre application pour voir les commandes",
                "select": "Sélectionnez un contrôle pour commencer",
                "none": "Aucun contrôle d'application trouvé"
            },
            "description": "Les contrôles d'application permettent à Cephable de savoir ce qu'il doit écouter et quelles actions il doit entreprendre. Vous pouvez changer de contrôle d'application à tout moment depuis la page d'accueil ou dans vos paramètres de connexion."
        },
        "summary": {
            "title": "Résumé des contrôles de l'application",
            "descriptionLong": "Voici les détails de ces commandes d'application. Vous pouvez rechercher des commandes, des actions et plus encore pour découvrir leurs possibilités.",
            "description": "Obtenez un résumé de ces contrôles d'application, y compris les contrôles existants, les personnalisations, les détails et plus encore.",
            "view": "Afficher le résumé des contrôles de l'application",
            "filter": "Filtrer par type d'entrée",
            "placeholder": "Rechercher les noms de contrôle..."
        },
        "copy": {
            "title": "Copier les contrôles de l'application",
            "duplicate": "Contrôles d'application en double",
            "question": "Créer une copie ?",
            "description": "Vous souhaitez créer une copie de ces contrôles d'application ? Une nouvelle fenêtre s'ouvrira avec ces contrôles copiés, mais ils ne seront ajoutés à votre compte qu'après leur enregistrement.",
            "confirm": "Oui, créer une copie",
            "profileSuffix": "{{name}} (copie)"
        },
        "new": {
            "title": "Créer de nouveaux contrôles d'application",
            "description": "Créez des commandes personnalisées à partir de zéro ou laissez l'IA de pointe générer des commandes personnalisées, vous permettant de naviguer sans effort dans les applications et les logiciels à l'aide de votre voix, de votre tête et de vos gestes du visage.",
            "note": "Recommandé pour les utilisateurs avancés.",
            "scratch": "Créer à partir de zéro"
        },
        "advancedOptions": "Options de contrôle avancées",
        "delete": {
            "title": "Supprimer les contrôles de l'application",
            "titleLong": "Supprimez ces contrôles d'application",
            "description": "Vous pouvez supprimer ces contrôles d'application en cliquant sur « Supprimer les contrôles d'application ».",
            "confirm": "Êtes-vous sûr de vouloir supprimer ces contrôles d'application ?",
            "confirmLong": "Une fois ces contrôles supprimés, vous ne pourrez plus y revenir. Êtes-vous sûr de vouloir supprimer ces contrôles ?",
            "confirmButton": "Oui, supprimez ces contrôles d'application"
        },
        "current": "Contrôles actuels",
        "loading": "Chargement des commandes...",
        "null": "Vous n'avez pas encore de contrôles d'application. Cliquez ci-dessous pour en créer un.",
        "nullButton": "Créez vos premiers contrôles d'application",
        "preview": "Aperçu",
        "features": "Caractéristiques",
        "byline_public": "Par : l'équipe Cephable",
        "byline_shared": "Partagé par : Communauté Cephable",
        "share": {
            "title": "Partager les contrôles de l'application",
            "previewTitle": "Aperçu des contrôles d'applications partagées",
            "description": "Partagez ces contrôles d’application avec d’autres afin qu’ils puissent en obtenir une copie et les personnaliser à partir de là !",
            "descriptionLong": "Partagez ces commandes d'application avec d'autres personnes pour qu'elles puissent en obtenir une copie et les personnaliser ! Choisissez le mode de partage souhaité, puis créez un lien à envoyer.",
            "add": "Créer un lien de partage",
            "confirm": "Partager cette URL",
            "link": "Partager le lien",
            "copy": "Copier le lien",
            "copied": "Copié!",
            "usage": "Montant d'utilisation",
            "created": "Créé {{value}}",
            "expiration": {
                "title": "Expiration",
                "once": "Autoriser une seule utilisation",
                "unlimited": "Autoriser une utilisation illimitée",
                "no": "Aucune expiration",
                "date": "Date d'expiration",
                "dateDescription": "Expire à une date précise"
            },
            "manage": "Gérer les liens de partage précédents",
            "empty": "Aucun partage n'a été créé pour ces contrôles d'application."
        },
        "swap": {
            "title": "Contrôles d'échange",
            "titleLong": "Échangez les commandes de votre application",
            "descriptionShort": "Utilisez différents contrôles d’application pour correspondre au programme ou au logiciel que vous utilisez.",
            "description": "Vous pouvez basculer entre différents contrôles d'application pour correspondre au programme ou au logiciel que vous utilisez."
        },
        "autoProfileSwitching": {
            "title": "Commutation de commande automatique",
            "alerts": {
                "disabled": "La commutation de contrôle automatique est désactivée.",
                "temporarilyDisabled": "La commutation de contrôle automatique est temporairement désactivée.",
                "enabled": "La commutation de contrôle automatique est activée.",
                "error": "Erreur lors de l'enregistrement des préférences de commutation de contrôle automatique"
            },
            "associatedPrograms": {
                "add": "Ajouter un nouveau programme associé",
                "description": {
                    "personal": "Choisissez les logiciels ou programmes que vous souhaitez connecter à ces commandes. Ce système prend en charge la commutation automatique des commandes : Cephable adapte automatiquement les commandes de ces applications au programme que vous utilisez.",
                    "short": "Choisissez le logiciel ou les programmes que vous souhaitez connecter à ces commandes."
                },
                "edit": "Modifier les programmes associés",
                "noOptionsText": "Commencez à taper pour trouver les programmes associés",
                "profileLabel": "Contrôles de l'application :",
                "remove": "Supprimer le programme associé",
                "title": "Programmes associés",
                "when": "Cephable basculera automatiquement les contrôles de mon application sur {{profileName}} lorsque j'utilise...",
                "emptySearch": "Aucun programme n'est associé à ces contrôles.",
                "error": "Erreur lors de l'enregistrement des programmes associés. Veuillez réessayer ultérieurement.",
                "emptyError": "Programme associé vide détecté, veuillez le supprimer avant de continuer."
            },
            "commandOverlay": {
                "command": "Contrôles de commutation d'application : {{value}}"
            },
            "description": "Le changement automatique de contrôle permet à Cephable de s'adapter parfaitement à votre flux de travail. Lorsqu'il est activé, Cephable ajuste les contrôles de votre application en fonction du programme ou du logiciel utilisé. S'il est désactivé, vous pouvez changer manuellement de contrôle d'application à l'aide du bouton « Changer de contrôle » ou des commandes globales."
        },
        "error": {
            "noMatch": "Aucun contrôle d'application ne correspond à votre recherche.",
            "load": "Erreur lors du chargement des contrôles de l'application.",
            "add": "Erreur lors de l'ajout des contrôles d'application.",
            "delete": "Erreur lors de la suppression des contrôles de l'application.",
            "audioEventsWithEmptyCommands": "Il manque des contrôles dans votre réponse. Vérifiez-les pour vous assurer de les remplir complètement.",
            "conflicts": "Erreur lors de l'enregistrement des contrôles de l'application en raison de conflits.",
            "save": "Erreur lors de l'enregistrement des commandes de l'application. Veuillez réessayer.",
            "device": "Contrôle d'application non valide pour cette connexion. Veuillez en essayer un autre."
        },
        "conflictIndicators": {
            "errorTitle": "Erreur lors de l'enregistrement des contrôles de l'application en raison de conflits",
            "warningTitle": "Contrôles d'application enregistrés avec des avertissements",
            "subtitle": "Les contrôles d'application que vous avez créés ont certaines configurations qui peuvent entrer en conflit.",
            "profileNameErrors": "Conflit de nom des contrôles d'application",
            "emptyControlsMapped": "Noms d'entrée vides",
            "emptyControlsMappedDescription": "Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la tête ou une autre commande à votre entrée.",
            "emptyKeybindingControlsMapped": "Noms d'entrée vides pour les raccourcis clavier",
            "emptyKeybindingControlsMappedDescription": "Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la tête ou une autre commande à votre entrée pour les raccourcis clavier.",
            "duplicateNameTitle": "Nom des contrôles d'application en double",
            "duplicateNameDescription": "Vous disposez déjà d'une application portant le même nom. Veuillez la modifier avant de continuer.",
            "emptyNameTitle": "Nom des contrôles d'application vides",
            "emptyNameDescription": "Les commandes de l'application doivent avoir un nom, par exemple Jeu 1, Spotify, Word, etc.",
            "macrosReleaseKeysMissingTitle": "Sorties avec des clés non libérées",
            "macrosReleaseKeysMissingDescription": "Veuillez ajouter une clé de déverrouillage ou arrêter toutes les étapes pour éviter que les clés ne se bloquent.",
            "duplicateInputCommandMacroTitle": "Entrées de commande identiques",
            "duplicateCommandsDescription": "Veuillez supprimer ou modifier les commandes d'entrée en double.",
            "duplicateInputCommandBindingsTitle": "Entrées de contrôle identiques pour les raccourcis clavier",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} avec {{commandOrEventType}}",
            "duplicateMacroNames": "Noms de contrôle en double",
            "duplicateMacroNamesDescription": "Veuillez supprimer ou modifier l’un de vos noms de contrôle identiques.",
            "warningIgnore": "Ignorer",
            "warningDoNotShowAgain": "Ne plus afficher les avertissements",
            "macrosVoiceCommandConflictWithDictationTitle": "Contrôlez les commandes vocales de la même manière que les mots clés de la dictée",
            "keybindingsVoiceCommandConflictWithDictationTitle": "Les raccourcis clavier des commandes vocales sont identiques à ceux des mots clés de la dictée",
            "macrosVoiceCommandConflictWithDictationDescription": "Vos entrées vocales déclencheront la dictée et les commandes vocales.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "Vos entrées vocales déclencheront la dictée et les pressions sur les touches.",
            "macrosVoiceCommandConflictWithGenerationTitle": "Contrôler les commandes vocales de la même manière que les mots clés de génération",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "Les commandes vocales des raccourcis clavier sont identiques aux mots clés de génération",
            "macrosVoiceCommandConflictWithGenerationDescription": "Vos entrées vocales déclencheront la génération et les commandes vocales.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "Vos entrées vocales déclencheront la génération et les pressions sur les touches.",
            "duplicateAssociatedProgramNames": "Noms de programmes associés en double",
            "duplicateAssociatedProgramNamesDescription": "Veuillez supprimer ou modifier l'un de vos programmes associés identiques.",
            "emptyEvent": {
                "title": "Étapes manquantes",
                "description": "Il manque des étapes dans vos contrôles. Cela pourrait empêcher Cephable d'exécuter une action lorsque vous donnez une commande."
            },
            "warningDetails": "Afficher tous les conflits"
        },
        "success": {
            "save": "Contrôles de l'application enregistrés.",
            "add": "Contrôles d'application ajoutés.",
            "delete": "Contrôles de l'application supprimés.",
            "share": "Lien de partage créé et copié dans le presse-papiers",
            "shareDelete": "Lien de partage supprimé.",
            "generate": "Contrôles d'application générés."
        },
        "warning": "Contrôles d'application enregistrés avec des avertissements",
        "customize": "Personnaliser les contrôles de l'application",
        "custom": "{{name}} (Personnalisé)",
        "description": "Les contrôles d'application sont un ensemble de commandes permettant de contrôler votre appareil ou votre connexion. Vous pouvez créer plusieurs contrôles d'application et passer de l'un à l'autre à tout moment."
    },
    "publicProfiles": {
        "toolbar": "Explorer les commandes de l'application",
        "title": "Explorer les commandes de l'application",
        "offline": {
            "title": "Impossible de charger les contrôles d'application publics",
            "description": "Il semble que vous soyez hors ligne. Vous pouvez toujours utiliser les commandes de votre application, mais vous ne pourrez pas charger de nouvelles commandes publiques.",
            "confirm": "D'accord"
        },
        "announcement": "{{count}} De nouveaux contrôles d'application ont été chargés",
        "description": {
            "personal": "Des contrôles d'application publics sont disponibles pour vous aider à démarrer rapidement avec Cephable sur vos applications préférées. Vous pouvez utiliser les contrôles par défaut, les personnaliser selon vos besoins ou créer de toutes nouvelles commandes personnalisées.",
            "pro": "Des contrôles d'application publics sont disponibles pour vous aider à démarrer rapidement avec Cephable sur vos applications préférées. Vous pouvez utiliser les contrôles par défaut, les personnaliser selon vos besoins ou créer de nouveaux contrôles d'application personnalisés grâce au générateur de contrôles."
        },
        "team": "Équipe Cephable"
    },
    "publicTag": "Publique",
    "tray": {
        "panel": "Basculer le panneau",
        "dashboard": "Afficher le tableau de bord",
        "quit": "Quitter Cephable"
    },
    "generate": "Générer",
    "stop": "Arrêt",
    "clear": "Clair",
    "rewrite": "Récrire",
    "translate": "Traduire",
    "smartTasks": {
        "title": "Tâches intelligentes",
        "show": "Afficher les tâches intelligentes",
        "description": "Les tâches intelligentes sont les différentes tâches que l'IA de Cephable peut effectuer pour vous. Ces tâches, alimentées par l'IA intégrée à l'appareil, peuvent être utilisées pour créer du texte, résumer, réécrire, traduire, prendre des notes et discuter avec des documents.",
        "generateText": {
            "title": "Générer du texte",
            "description": "Créez du contenu textuel en fonction de vos entrées ou de vos invites.",
            "label": "Décrivez ce que vous souhaitez générer"
        },
        "summarizeText": {
            "title": "Résumer un texte",
            "description": "Extraire les informations pertinentes des textes longs et créer de courts résumés ou des points clés à retenir.",
            "directions": "Saisissez le texte à résumer, ou Cephable utilisera automatiquement le texte que vous avez mis en évidence.",
            "titleShort": "Résumer",
            "write": "Rédiger un résumé",
            "label": "Comment souhaitez-vous résumer ou condenser le texte ?",
            "outputLabel": "Votre résumé apparaîtra ici.",
            "inputLabel": "Saisissez du texte à condenser"
        },
        "rewriteText": {
            "title": "Réécrire le texte",
            "description": "Surlignez le texte dans une autre application dans laquelle vous écrivez, puis revenez ici et décrivez comment vous souhaitez qu'il soit réécrit.",
            "label": "Décrivez comment vous souhaitez réécrire le texte",
            "inputLabel": "Saisissez le texte à réécrire"
        },
        "translateText": {
            "title": "Traduire le texte",
            "description": "Saisissez le texte à traduire, ou Cephable utilisera automatiquement le texte que vous avez mis en surbrillance.",
            "label": "Entrez le texte à traduire",
            "languageLabel": "Langue à traduire"
        },
        "noteTaker": {
            "title": "Preneur de notes",
            "description": "Laissez Cephable enregistrer et transcrire localement vos réunions ou conversations"
        },
        "documentChat": {
            "title": "Discussion sur les documents",
            "description": "Interagissez avec des documents et interrogez-les pour obtenir des informations rapides."
        },
        "highlightText": {
            "title": "Utiliser le texte en surbrillance",
            "description": "Cephable peut utiliser automatiquement le texte surligné dans n'importe quelle application pour effectuer des tâches telles que la synthèse, la réécriture ou la traduction. Vous pouvez également saisir du texte manuellement si vous le souhaitez.",
            "label": "Entrez le texte à utiliser",
            "placeholder": "Vous pouvez également surligner du texte dans une autre application et revenir ici pour l'utiliser.",
            "noTextFound": "Texte introuvable. Sélectionnez le texte dans une autre application ou collez-le dans le champ et réessayez."
        },
        "pasteText": {
            "title": "Coller du texte",
            "description": "Cephable peut utiliser automatiquement le texte copié dans votre presse-papiers pour effectuer des tâches telles que la synthèse, la réécriture ou la traduction. Vous pouvez également saisir du texte manuellement si vous le souhaitez.",
            "label": "Entrez le texte à utiliser",
            "placeholder": "Vous pouvez également surligner du texte dans une autre application et revenir ici pour l'utiliser."
        },
        "clearCache": "Si vous rencontrez des problèmes lors de la génération, veuillez vider le cache et les ressources dans les paramètres de génération de texte, puis réessayer.",
        "transcribeAudio": {
            "title": "Transcrire l'audio",
            "description": "Convertissez des fichiers audio ou vidéo en texte à l'aide de la transcription IA.",
            "inputMethod": "Choisissez la méthode de saisie",
            "localFile": "Fichier local",
            "url": "URL",
            "selectFile": "Sélectionner un fichier audio/vidéo",
            "urlLabel": "URL audio/vidéo",
            "transcribe": "Transcrire",
            "result": "Résultat de la transcription",
            "invalidFileType": "Veuillez sélectionner un fichier audio ou vidéo valide (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Erreur de transcription",
            "history": {
                "title": "Historique de la transcription",
                "description": "Affichez et gérez vos transcriptions enregistrées.",
                "viewHistory": "Afficher l'historique",
                "empty": "Aucune transcription pour le moment. Commencez à transcrire pour enrichir votre histoire !",
                "titleLabel": "Titre (facultatif)",
                "titlePlaceholder": "Entrez un titre pour cette transcription",
                "textLabel": "Texte de transcription",
                "confirmDelete": "Êtes-vous sûr de vouloir supprimer cette transcription ?"
            }
        },
        "aiWorkflows": {
            "description": "Automatisez vos tâches de bureau et de navigation grâce à l'IA. Décrivez simplement ce que vous souhaitez accomplir, et Cephable se chargera du reste.",
            "label": "Décrivez ce que vous souhaitez accomplir",
            "status": {
                "idle": "Dans l'attente de vos instructions...",
                "initializing": "On prépare tout...",
                "planning": [
                    "Élaborer un plan...",
                    "Analyse de votre demande...",
                    "Élaboration des étapes...",
                    "Organisation du flux de travail...",
                    "Préparation de la stratégie...",
                    "Élaboration d'un plan d'action...",
                    "Trouver la meilleure façon de vous aider...",
                    "Déterminer comment aborder cette question...",
                    "Analyse de votre demande...",
                    "Planification de l'exécution..."
                ],
                "thinking": [
                    "Pensée...",
                    "Analyse de votre demande...",
                    "Trouver la meilleure façon de vous aider...",
                    "Déterminer la suite des opérations...",
                    "Traitement des étapes précédentes...",
                    "Nous travaillons sur votre demande...",
                    "Récupération des détails...",
                    "Révision du plan...",
                    "Envisager les options...",
                    "Créer, évaluer, décider..."
                ],
                "waitingForUser": "Votre contribution est nécessaire pour continuer.",
                "completed": "Succès!",
                "failed": "Votre requête a échoué : {{message}}",
                "canceled": "Votre demande a été annulée.",
                "terminated": "Votre demande a été traitée.",
                "thinkingInteractive": [
                    "Envisager la prochaine étape...",
                    "Récapitulons ce que nous avons fait jusqu'à présent...",
                    "Décider de la suite...",
                    "Analyse des résultats...",
                    "Planification de la suite...",
                    "Évaluation des options...",
                    "Déterminer la meilleure prochaine étape...",
                    "Je travaille sur la suite de votre demande...",
                    "Nous travaillons sur les prochaines étapes...",
                    "Traitement des résultats de l'étape précédente..."
                ],
                "tools": {
                    "click_element_by_index": {
                        "executing-start": "Cliquer sur le bouton correspondant...",
                        "executing-complete": "J'ai cliqué sur {{params.index}}."
                    },
                    "click_element": {
                        "executing-start": "Cliquer sur le numéro en surbrillance...",
                        "executing-complete": "J'ai cliqué sur {{params.elementName}}."
                    },
                    "copy_selection": {
                        "executing-start": "Collecte du contexte...",
                        "executing-complete": "J'ai le contexte, prêt pour la suite de votre demande."
                    },
                    "draft_email": {
                        "executing-start": "Rédiger un courriel...",
                        "executing-complete": "J'ai rédigé un courriel concernant {{params.subject}}."
                    },
                    "execute_app_action": {
                        "executing-start": "Exécution de {{params.actionName}}...",
                        "executing-complete": "{{params.actionName}} terminé."
                    },
                    "find_all_text": {
                        "executing-start": "Recherche de tout le contexte pertinent concernant {{params.searchText}}...",
                        "executing-complete": "J'ai trouvé tout le contexte pertinent concernant {{params.searchText}}."
                    },
                    "find_and_select_text": {
                        "executing-start": "Recherche et sélection du contexte pertinent concernant {{params.searchText}}...",
                        "executing-complete": "J'ai trouvé et sélectionné le contexte pertinent concernant {{params.searchText}}."
                    },
                    "generate_text": {
                        "executing-start": "Création de contenu...",
                        "executing-progress": "Création de contenu...{{progress}}%",
                        "executing-complete": "J'ai créé le contenu demandé."
                    },
                    "get_all_interactive_elements": {
                        "executing-start": "Recherche en cours pour obtenir plus de contexte...",
                        "executing-complete": "Je comprends avec quoi je peux interagir."
                    },
                    "get_all_text_elements_content": {
                        "executing-start": "Je lis pour avoir plus de contexte...",
                        "executing-complete": "Je comprends quel contenu textuel est disponible."
                    },
                    "get_all_text_elements_names": {
                        "executing-start": "Je lis pour avoir plus de contexte...",
                        "executing-complete": "Je comprends quel contenu textuel est disponible."
                    },
                    "get_available_profile_actions": {
                        "executing-start": "Vérification des commandes disponibles dans cette application...",
                        "executing-complete": "Je comprends ce que je peux faire dans cette application."
                    },
                    "get_document_content": {
                        "executing-start": "Je lis pour avoir plus de contexte...",
                        "executing-complete": "J'ai le contexte, prêt pour la suite de votre demande."
                    },
                    "get_installed_apps": {
                        "executing-start": "Déterminer quelle application correspond à votre demande...",
                        "executing-complete": "Je sais quelles applications je peux utiliser."
                    },
                    "get_running_app_names": {
                        "executing-start": "Déterminer quelle application correspond à votre demande...",
                        "executing-complete": "Je sais quelles applications je peux utiliser."
                    },
                    "get_selected_text": {
                        "executing-start": "Lecture du contenu sélectionné...",
                        "executing-complete": "J'ai le contexte du contenu sélectionné."
                    },
                    "get_stored_content": {
                        "executing-start": "Collecte du contexte...",
                        "executing-complete": "J'ai le contexte, prêt pour la suite de votre demande."
                    },
                    "keyboard_shortcut": {
                        "executing-start": "Collecte du contexte...",
                        "executing-complete": "J'ai le contexte, prêt pour la suite de votre demande."
                    },
                    "open_app": {
                        "executing-start": "Ouverture de {{params.appName}}...",
                        "executing-complete": "J'ai ouvert {{params.appName}}."
                    },
                    "open_webpage": {
                        "executing-start": "Ouverture de {{params.url}}...",
                        "executing-complete": "J'ai ouvert {{params.url}}."
                    },
                    "paste_content": {
                        "executing-start": "En écrivant...",
                        "executing-complete": "J'ai fini d'écrire."
                    },
                    "respond_to_user": {
                        "executing-start": "Traitement de votre demande...",
                        "executing-complete:": "J'ai traité votre demande."
                    },
                    "search_browser": {
                        "executing-start": "Recherche sur le Web de {{params.query}}...",
                        "executing-complete": "J'ai cherché sur le web {{params.query}}."
                    },
                    "select_all_text": {
                        "executing-start": "Sélectionner tout le texte...",
                        "executing-complete": "J'ai sélectionné tout le texte."
                    },
                    "summarize_text": {
                        "executing-start": "En résumé, le texte…",
                        "executing-progress": "En résumé...{{progress}}%",
                        "executing-complete": "J'ai résumé le texte."
                    },
                    "translate_text": {
                        "executing-start": "Traduction du texte en {{params.targetLanguage}}...",
                        "executing-progress": "Traduction en cours...{{progress}}%",
                        "executing-complete": "J'ai traduit le texte en {{params.targetLanguage}}."
                    },
                    "type_stored_content": {
                        "executing-start": "En écrivant...",
                        "executing-complete": "J'ai fini d'écrire."
                    },
                    "type_text": {
                        "executing-start": "En écrivant...",
                        "executing-complete": "J'ai fini d'écrire."
                    },
                    "unknown": {
                        "executing-start": "J'ai rencontré un problème en essayant une stratégie différente...",
                        "executing-complete": "J'ai essayé une stratégie différente."
                    },
                    "append_to_file": {
                        "executing-start": "Ajout au fichier...",
                        "executing-complete": "J'ai ajouté du contenu au fichier."
                    },
                    "copy_path": {
                        "executing-start": "Copier...",
                        "executing-complete": "Je l'ai copié."
                    },
                    "create_directory": {
                        "executing-start": "Création du dossier...",
                        "executing-complete": "J'ai créé le dossier."
                    },
                    "delete_path": {
                        "executing-start": "Suppression en cours...",
                        "executing-complete": "Je l'ai supprimé."
                    },
                    "edit_user_file": {
                        "executing-start": "Modification du fichier...",
                        "executing-complete": "J'ai modifié le fichier."
                    },
                    "get_file_info": {
                        "executing-start": "Vérification du fichier...",
                        "executing-complete": "J'ai vérifié le fichier."
                    },
                    "list_directory": {
                        "executing-start": "Lister le dossier...",
                        "executing-complete": "J'ai listé le dossier."
                    },
                    "move_path": {
                        "executing-start": "Mobile...",
                        "executing-complete": "Je l'ai déplacé."
                    },
                    "open_path": {
                        "executing-start": "Ouverture...",
                        "executing-complete": "Je l'ai ouvert."
                    },
                    "read_user_file": {
                        "executing-start": "Lecture du fichier...",
                        "executing-complete": "J'ai lu le fichier."
                    },
                    "run_command": {
                        "executing-start": "Exécution d'une commande...",
                        "executing-complete": "J'ai exécuté la commande."
                    },
                    "search_files": {
                        "executing-start": "Recherche de fichiers...",
                        "executing-complete": "J'ai trouvé des fichiers correspondants."
                    },
                    "search_in_files": {
                        "executing-start": "Recherche dans les fichiers...",
                        "executing-complete": "J'ai cherché dans les fichiers."
                    },
                    "write_user_file": {
                        "executing-start": "Écriture du fichier...",
                        "executing-complete": "J'ai écrit le fichier."
                    }
                },
                "networkError": "Connexion interrompue lors du téléchargement du modèle. Veuillez vérifier votre connexion Internet et réessayer en envoyant une invite ou en redémarrant l'application.",
                "executing-org-block": "Impossible d'utiliser {{params.toolName}} car l'interaction avec {{params.appOrDomain}} est bloquée par l'organisation.",
                "executing-destructive-block": "Toute interaction avec {{params.elementName}} est bloquée. Veuillez vérifier et effectuer cette action manuellement.",
                "executing-type-focus-block": "J'ai rencontré un problème lors de la saisie du contenu. Il a été copié dans votre presse-papiers ; veuillez le coller manuellement.",
                "executing-permission-block": "J'ai eu un problème pour accéder au fichier.",
                "stopped": "Arrêté.",
                "unsupportedOSVersion": "Votre système macOS est obsolète, veuillez le mettre à jour et réessayer."
            },
            "ready": {
                "waiting": "AI Workflows est prêt. Nous attendons vos instructions.",
                "execute": "Les flux de travail IA sont prêts. À partir de votre demande…"
            },
            "start": "Commencer",
            "progress": "Fonctionnement...",
            "title": "Vos flux de travail d'IA sont prêts",
            "steps": {
                "thinking": "Pensée",
                "tool": "Outil",
                "details": "Détails",
                "chunkProgress": "partie {{current}} de {{total}}",
                "output": "Sortir",
                "showMore": "Afficher plus",
                "showLess": "Afficher moins"
            },
            "prefix": "Flux de travail :",
            "files": {
                "sectionTitle": "Fichiers",
                "open": "Ouvrir",
                "openFile": "Ouvrir le fichier",
                "openFolder": "Ouvrir le dossier",
                "openError": "Impossible d'ouvrir « {{name}} ». Ce fichier a peut-être été déplacé ou supprimé."
            },
            "input": {
                "other": "Autre…",
                "otherPlaceholder": "Saisissez votre réponse",
                "submit": "Envoyer"
            },
            "continue": {
                "label": "Continuer",
                "placeholder": "Demandez à Cephable d'exploiter davantage ce résultat…"
            },
            "retry": {
                "label": "Réessayer"
            },
            "context": {
                "approaching": "Cette conversation est longue ({{percent}}% de la mémoire de l'IA utilisée). Les messages les plus anciens risquent d'être supprimés.",
                "trimmed": "Cette conversation a atteint la limite de mémoire de l'IA ; elle risque donc d'oublier les messages précédents. Veuillez démarrer un nouveau flux de travail pour réinitialiser la conversation."
            },
            "approval": {
                "title": "Confirmer l'action",
                "approve": "Approuver",
                "reject": "Rejeter",
                "edit": "Modifier",
                "deletePath": "Supprimer ce fichier/dossier ? Cette action est définitive.",
                "runCommand": "Exécuter cette commande shell ?",
                "movePath": "Déplacer/renommer ce chemin ? Cela pourrait écraser la destination.",
                "confirmDelete": "Supprimer",
                "confirmRun": "Exécuter la commande",
                "confirmMove": "Se déplacer",
                "badgeDestructive": "Destructeur",
                "badgeCaution": "Prudence"
            },
            "browser": {
                "sectionTitle": "Navigateur",
                "view": "Afficher le navigateur",
                "open": "Ouvrir",
                "openError": "Impossible d'ouvrir le navigateur."
            }
        },
        "generatedByAI": "Fonctionne grâce à l'IA embarquée, veuillez vérifier l'exactitude des informations.",
        "networkError": "Connexion interrompue lors du téléchargement du modèle. Veuillez vérifier votre connexion Internet et réessayer en envoyant une invite ou en redémarrant l'application.",
        "genericError": "Une erreur inattendue s'est produite. Veuillez réessayer.",
        "download": {
            "title": "Téléchargez des modèles d'IA pour débloquer davantage de fonctionnalités",
            "description": "Pour utiliser les tâches intelligentes, un modèle local doit être téléchargé sur votre appareil. Cela garantit la confidentialité de vos données, qui ne sont jamais envoyées sur le cloud.",
            "confirm": "Télécharger",
            "cancel": "Pas maintenant"
        },
        "runningInBackground": {
            "generate": "Génération en arrière-plan...",
            "rewrite": "Réécriture en arrière-plan...",
            "translate": "Traduction en arrière-plan...",
            "summarize": "En résumé...",
            "generic": "Fonctionne en arrière-plan..."
        }
    },
    "inputMethod": "Méthode de saisie :",
    "hotkey": {
        "title": "Bouton d'action rapide",
        "titlePlural": "Boutons d'action rapide",
        "titlePanel": "Actions rapides",
        "label": "Nom d'affichage du bouton d'action rapide",
        "placeholder": "Nom à afficher",
        "question": "Comment souhaitez-vous nommer ce bouton ?",
        "when": "Quand je tape...",
        "description": "Les boutons d'action rapide sont des boutons personnalisables qui permettent d'effectuer des actions pertinentes dans votre application. Un simple clic peut exécuter plusieurs étapes ou une seule action.",
        "usagePrompt": "Les boutons d'action rapide sont des boutons personnalisables qui permettent d'effectuer des actions pertinentes dans votre application. Vous pouvez ajouter, supprimer ou modifier leur nom depuis la page principale des paramètres de contrôle de l'application.",
        "reorder": "Vous pouvez réorganiser l'ordre en utilisant les boutons de déplacement vers le haut et vers le bas.",
        "emptyTitle": "Pas de boutons d'action rapide",
        "edit": "Modifier les boutons d'action rapide",
        "tap": "Appuyez sur {{value}}",
        "copySuffix": "{{name}}_copie",
        "hotkeysOnly": "Boutons personnalisés",
        "allControls": "Toutes les commandes de l'application",
        "show": "Afficher les boutons d'action rapide",
        "deprecatedDialog": {
            "title": "Les contrôles de votre application nécessitent une mise à jour.",
            "description2": "Une simple mise à jour suffit – une seconde à peine – et vous profiterez d'une personnalisation fluide des boutons. Dites adieu aux étapes supplémentaires et bonjour à une interface plus conviviale. Prêt à passer à l'action ?",
            "confirm": "Faisons-le!",
            "description1": "Il semble que vous utilisiez d'anciennes commandes d'application avec des boutons d'action rapide. Nous vous réservons des mises à jour intéressantes ! Nous avons repensé le système pour simplifier la création et la modification des boutons d'action rapide, sans avoir à explorer les paramètres avancés."
        },
        "demo": {
            "title": "Boutons d'action rapide de démonstration",
            "step1": "Activer les boutons d'action rapide",
            "step2": "Utilisez les exemples d’invite ci-dessous pour contrôler le bloc de texte.",
            "command1": "Appuyez sur le bouton 1 pour « Agrandir le texte »",
            "command2": "Appuyez sur le bouton 2 pour « mettre le texte en gras »",
            "command3": "",
            "continue": "Continuer avec les boutons d'action rapide",
            "description": "La zone de démonstration ci-dessous vous permettra d'essayer les boutons d'action rapide. Elle se limite au contrôle spécifique de la zone de texte ci-dessous."
        },
        "example": {
            "title": "Exemples de boutons d'action rapide",
            "command1": "Appuyez sur Pause",
            "example1": "Exemple « mettre la vidéo en pause »",
            "command2": "Appuyez sur Suivant",
            "example2": "Exemple « zoom arrière »",
            "command3": "Appuyez sur Arrêter",
            "example3": "Exemple « fermer la fenêtre »",
            "description": "Ces exemples illustrent la polyvalence des boutons d'action rapide pour contrôler votre appareil ou votre connexion. Ils permettent d'exécuter des commandes, de naviguer dans les interfaces ou d'effectuer des actions d'un simple toucher."
        },
        "emptySearch": "Aucune action rapide ne correspond à ce critère.",
        "empty": "Il semble que vous n'ayez actuellement aucune action rapide.",
        "emptyLong": "Aucun bouton d'action rapide n'est configuré dans ces commandes d'application. Une fois que vous aurez ajouté des boutons d'action rapide ou choisi des commandes d'application avec un bouton d'action rapide, ils apparaîtront ici."
    },
    "reset": "Réinitialiser",
    "info": "Plus d'informations",
    "device": {
        "title": "Connexion",
        "titlePlural": "Relations",
        "status": {
            "title": "État de la connexion :",
            "connected": {
                "application": "Application connectée",
                "connection": "Connecté",
                "device": "Appareil connecté",
                "game": "Jeu connecté"
            },
            "disconnected": {
                "application": "Application déconnectée",
                "connection": "Déconnecté",
                "device": "Appareil déconnecté",
                "game": "Jeu déconnecté"
            }
        },
        "running": "En cours d'exécution",
        "offline": "Hors ligne",
        "otherDevices": "Autres connexions de sortie",
        "currentStatus": "Statut actuel :",
        "connectionStatus": "État de la connexion :",
        "profileStatus": "Contrôles actuels de l'application :",
        "name": {
            "title": "Nom de la connexion",
            "question": "Comment voulez-vous appeler cette connexion ?",
            "description": "Donnez un nom à votre connexion afin de pouvoir la retrouver facilement plus tard.",
            "placeholder": "nom de la connexion",
            "edit": "Modifier le nom de la connexion"
        },
        "updates": {
            "title": "Mises à jour de connexion",
            "settings": "Paramètres de mise à jour de la connexion",
            "description": "Vérifiez les mises à jour du micrologiciel de connexion et modifiez les paramètres de mise à jour automatique",
            "edit": "Modifier les paramètres de mise à jour",
            "check": {
                "title": "Vérifier les mises à jour",
                "processing": "Vérification des mises à jour ! Cela peut prendre quelques minutes et votre connexion peut redémarrer pendant les mises à jour.",
                "description": "Appuyez pour vérifier les mises à jour de votre connexion. Si une mise à jour est disponible et que votre connexion est active, la mise à jour commencera. Les mises à jour peuvent prendre quelques minutes."
            },
            "auto": {
                "title": "Mise à jour automatique",
                "description": "Lorsque ce paramètre est activé, votre connexion se met automatiquement à jour dès qu'une mise à jour est disponible. Si ce paramètre est désactivé, appuyez sur le bouton de mise à jour pour obtenir la dernière version.",
                "option": "Utiliser la mise à jour automatique ?"
            }
        },
        "delete": {
            "title": "Dissocier {{name}}",
            "titleLong": "Dissocier du compte",
            "description": "La dissociation déconnecte Cephable de cet ordinateur ou de ce jeu et le supprime de votre compte. Vous ne pourrez plus vous y connecter, lui envoyer de commandes ni le mettre à jour. Cette action est irréversible, mais vous pourrez créer une nouvelle connexion avec le même ordinateur ou le même jeu si vous souhaitez l'utiliser à nouveau ultérieurement.",
            "confirm": "Êtes-vous sûr de vouloir dissocier cette connexion ?",
            "confirmLong": "Êtes-vous sûr de vouloir désenregistrer et réinitialiser cette connexion ? Vous ne pourrez plus vous y connecter, envoyer de commandes ni la mettre à jour. Après cette désinscription et réinitialisation, n'importe qui pourra établir cette connexion.",
            "confirmButton": "Oui, supprimez cette connexion."
        },
        "manage": {
            "title": "Cliquez pour afficher et gérer les détails de vos connexions.",
            "description": "",
            "name": "Personnalisez le nom de votre connexion pour une gestion plus facile."
        },
        "error": {
            "save": "Erreur lors de l'enregistrement de la connexion.",
            "load": "Erreur lors du chargement de la connexion.",
            "add": "Erreur lors de l'ajout de la connexion.",
            "delete": "Erreur lors de la suppression de la connexion.",
            "updates": "Erreur lors de la vérification des mises à jour.",
            "connection": "La connexion n'est pas établie. Vérifiez qu'elle est bien établie avant de réessayer.",
            "deleteLong": "Nous n'avons pas pu supprimer cette connexion de votre compte. Si vous vous reconnectez à ce compte, vous devrez peut-être la supprimer manuellement dans les paramètres de connexion."
        },
        "success": {
            "save": "Connexion enregistrée.",
            "add": "Connexion ajoutée.",
            "delete": "Connexion supprimée."
        },
        "description": "Cephable prend en charge plusieurs appareils et connexions. Vous pouvez gérer les paramètres ou sélectionner l'un d'entre eux. Cet ordinateur sera toujours votre connexion principale. Vous pourrez ajouter d'autres connexions ultérieurement.",
        "swap": {
            "titlePlural": "Connexions d'échange",
            "description": "Cephable prend en charge plusieurs appareils et connexions. Vous pouvez en sélectionner un ici. Cet ordinateur sera toujours votre connexion principale. Vous pourrez ajouter d'autres connexions ultérieurement."
        },
        "control": {
            "button": "Contrôle {{name}}",
            "description": {
                "application": "Contrôlez cette application connectée avec votre voix, des actions rapides, des mouvements de tête, etc. Par exemple, si vous dites « Enregistrer », cela enregistrera l'application en cours d'exécution.",
                "connection": "Contrôlez cette connexion avec votre voix, des actions rapides, des mouvements de tête, etc. Par exemple, si vous dites « Enregistrer », votre connexion en cours sera sauvegardée.",
                "device": "Contrôlez cet appareil connecté avec votre voix, des actions rapides, des mouvements de tête, etc. Par exemple, si vous dites « Ouvrir Spotify », Spotify s'ouvrira sur l'appareil en cours d'exécution.",
                "game": "Contrôlez ce jeu connecté avec votre voix, des actions rapides, des mouvements de tête et bien plus encore. Par exemple, si vous dites « Go », le joueur se déplacera en course."
            },
            "generic": "Connexion de contrôle"
        },
        "titleShort": "Connecter",
        "titleLong": "Connexions et extensions",
        "viewAll": "Afficher toutes les connexions",
        "add": {
            "short": "Étendre",
            "title": "Ajouter une nouvelle connexion ou extension",
            "description": "Les connexions et les extensions vous permettent d'enrichir votre expérience Cephable. Vous pouvez ajouter de nouvelles connexions pour vous connecter à davantage d'appareils, d'applications ou de jeux. Passez à la vitesse supérieure avec Cephable !",
            "action": "Ajouter une nouvelle connexion",
            "notAvailable": "Cette connexion ou extension n'est pas accessible au public pour le moment. Cela se produit souvent avec les extensions créées par les utilisateurs. Veuillez réessayer plus tard.",
            "isNotPublic": "APERÇU : Cette extension est en version préliminaire pour développeurs et peut être incomplète. Les développeurs doivent finaliser toutes les étapes avant sa publication publique. Les utilisateurs pourront consulter cette page ultérieurement pour obtenir la version complète."
        },
        "new": "Vous avez une nouvelle connexion !",
        "newLong": "Vous avez une nouvelle connexion ! Pour commencer à l'utiliser, sélectionnez-la dans le menu ci-dessous."
    },
    "explore": "Explorer",
    "shortcuts": {
        "title": "Raccourcis mondiaux",
        "description": "Personnalisez les raccourcis clavier pour un accès rapide aux commandes Cephable depuis n'importe où sur votre système.",
        "info": "Ces raccourcis fonctionnent globalement et peuvent être utilisés même lorsque Cephable n'est pas la fenêtre active.",
        "shortcut": "Raccourci",
        "toggleMicrophone": "Basculer le microphone",
        "toggleDictation": "Basculer le mode dictée",
        "toggleVoiceControl": "Basculer le mode de commande vocale",
        "togglePanel": "Basculer le panneau",
        "registrationFailed": "Certains raccourcis globaux n'ont pas pu être enregistrés. Ils sont peut-être utilisés par une autre application :",
        "record": {
            "title": "Raccourci d'enregistrement",
            "start": "Cliquez pour enregistrer",
            "listening": "Appuyez sur la combinaison de touches souhaitée...",
            "pressKeys": "Appuyez sur les touches maintenant"
        },
        "formatHint": "Sélectionnez au moins une touche de modification ({{modifierKey}}, {{modifierKey2}}, Shift) et une autre touche."
    },
    "gamepad": {
        "title": "Prise en charge de la manette de jeu",
        "description": "Configurer la sortie du gamepad et du joystick pour les jeux sur PC",
        "driver": {
            "description": "Pour prendre en charge les sorties de la manette de jeu, Cephable doit télécharger et installer un pilote externe appelé ViGEm. Ce pilote active la fonctionnalité de manette virtuelle Xbox 360, reconnue nativement par les jeux.",
            "installed": "Pilote de manette de jeu installé : vous pouvez utiliser les sorties de la manette ! Si vous rencontrez toujours des problèmes, vous pouvez essayer de réinstaller le pilote.",
            "notInstalled": "Pilote du contrôleur de jeu non installé",
            "install": "Installer le pilote du contrôleur de jeu",
            "reinstall": "Réinstaller le pilote du contrôleur de jeu",
            "installing": "Installation du pilote du contrôleur de jeu ViGEm...",
            "installSuccess": "Le pilote de la manette de jeu ViGEm a été installé avec succès ! Vous pouvez désormais utiliser les sorties de la manette dans vos commandes.",
            "installFailed": "Échec de l'installation du pilote ViGEm. Veuillez réessayer ou procéder à l'installation manuelle depuis le site web de ViGEm.",
            "title": "Pilote de manette de jeu",
            "disclosure": {
                "title": "Installer un pilote de manette tiers ?",
                "description": "La prise en charge des manettes nécessite l'installation de ViGEm, un pilote tiers non officiel permettant à Cephable d'émuler une manette Xbox virtuelle. Poursuivez uniquement si vous souhaitez que Cephable installe ce pilote.",
                "confirm": "Installer le pilote ViGEm"
            }
        },
        "platform": {
            "unsupported": "Plateforme non prise en charge pour les fonctionnalités de la manette",
            "unsupportedDescription": "La fonctionnalité de sortie manette est actuellement prise en charge uniquement sur les systèmes Windows x64. La prise en charge sur Mac et Windows ARM64 n'est pas encore disponible."
        },
        "usage": "Une fois le pilote du contrôleur de jeu installé, vous pouvez utiliser les mouvements du joystick et les pressions sur les boutons de la manette dans vos macros et commandes vocales pour contrôler les jeux."
    },
    "youtube": {
        "unavailable": {
            "title": "Vidéo indisponible",
            "description": "Cette vidéo est actuellement indisponible. Veuillez la réessayer ultérieurement.",
            "retry": "Réessayer"
        },
        "watch": {
            "title": "Oups.",
            "description": "Il semble qu'un problème soit survenu lors du chargement de la vidéo. Vous pouvez la regarder directement sur YouTube.",
            "button": "Regarder sur YouTube"
        },
        "offline": {
            "title": "Vidéo indisponible",
            "description": "Cette vidéo YouTube nécessite une connexion internet pour se charger. Veuillez vérifier votre connexion et réessayer."
        }
    },
    "metrics": {
        "download": {
            "success": "Accès réussi au fichier de métriques.",
            "manualPath": "Fichier de métriques disponible à : {{path}}",
            "error": "Erreur lors du téléchargement du fichier de métriques.",
            "noFile": "Aucun fichier de métriques trouvé."
        },
        "clear": {
            "success": "Le fichier de métriques a été effacé avec succès.",
            "error": "Erreur lors de l'effacement du fichier de métriques.",
            "noFile": "Aucun fichier de métriques n'a été trouvé pour être effacé.",
            "confirm": "Voulez-vous vraiment effacer toutes les données ? Cette action est irréversible."
        }
    },
    "suggestedPrompts": {
        "title": "Suggestions d'invites",
        "description": "Personnalisez les invites suggérées qui s'affichent dans les tâches d'IA pour vous aider à démarrer rapidement.",
        "edit": "Modifier les invites suggérées",
        "generate": "Générer du texte",
        "rewrite": "Réécrire le texte",
        "addGenerate": "Ajouter une invite de génération",
        "addRewrite": "Ajouter une invite de réécriture",
        "remove": "Supprimer l'invite",
        "generatePlaceholder": "Entrez une invite pour la génération de texte...",
        "rewritePlaceholder": "Entrez une invite pour la réécriture du texte...",
        "suggested": "Suggestions d'invites",
        "suggestedFor": "Suggéré pour {{profileName}}",
        "seeAll": "Voir toutes les invites",
        "showLess": "Afficher moins",
        "allPrompts": "Toutes les invites",
        "customFor": "Invites personnalisées pour {{profileName}}",
        "defaultPrompts": "Invites par défaut",
        "defaultGenerate": [
            "Un e-mail professionnel présentant notre nouveau produit",
            "Un ordre du jour pour la discussion d'équipe de la semaine prochaine",
            "Un aperçu de la proposition de projet pour une nouvelle initiative",
            "Un modèle de lettre commerciale formelle",
            "Une section de documentation technique",
            "Introduction au manuel d'utilisation",
            "Un aperçu du document de formation",
            "Un projet de document de politique",
            "Un e-mail de suivi après une réunion",
            "Un message de remerciement à un client",
            "Un e-mail de mise à jour de l'état du projet",
            "Une invitation à un événement d'entreprise",
            "Un e-mail de rappel pour les échéances à venir",
            "Un e-mail de bienvenue pour les nouveaux membres de l'équipe",
            "Un e-mail d'excuses pour l'interruption de service",
            "Une introduction à la newsletter",
            "Une liste de brainstorming pour les campagnes marketing",
            "Solutions créatives pour améliorer la productivité des équipes",
            "Idées d'activités pour une retraite d'entreprise",
            "Concepts pour une nouvelle fonctionnalité d'application mobile",
            "Suggestions pour améliorer l'expérience client",
            "Idées d'innovation pour le développement de nos produits",
            "Idées de contenu pour les publications sur les réseaux sociaux",
            "Thèmes d'atelier pour le développement professionnel",
            "Une fonction qui valide la saisie de l'utilisateur",
            "Une requête de base de données pour la gestion des utilisateurs",
            "Code de gestion des erreurs pour les requêtes API",
            "Un modèle de fichier de configuration",
            "Commentaires expliquant un algorithme complexe",
            "Cas de tests unitaires pour une nouvelle fonctionnalité",
            "Documentation pour les points de terminaison de l'API",
            "Un script pour un déploiement automatisé"
        ],
        "defaultRewrite": [
            "Rendre ce texte plus concis et précis",
            "Développez ce résumé avec plus de détails",
            "Reformater ceci comme une liste numérotée",
            "Convertissez ceci en puces",
            "Restructurez ceci en paragraphes clairs",
            "Rendre ce texte plus facile à parcourir rapidement",
            "Organiser ces informations de manière hiérarchique",
            "Formatez ceci comme un guide étape par étape",
            "Rendez ce message plus professionnel et formel",
            "Réécrivez ceci pour qu'il paraisse plus décontracté et amical",
            "Ajustez le ton pour être plus encourageant",
            "Rendez ce son plus confiant et affirmé",
            "Adoucir le ton pour être plus diplomate",
            "Ajoutez de l'enthousiasme et de l'énergie à ce texte",
            "Rendez cela plus empathique et compréhensif",
            "Réécrire avec un ton plus collaboratif",
            "Simplifiez ceci pour un public général",
            "Rendre cette explication plus technique et détaillée",
            "Décomposez ce concept complexe en termes plus simples",
            "Ajoutez plus de contexte et d'informations générales",
            "Résumez ceci en points clés à retenir",
            "Développez les points principaux avec des exemples",
            "Rendre cela plus accessible aux débutants",
            "Condensez ceci tout en gardant les informations essentielles",
            "Améliorer la clarté et la lisibilité",
            "Rendez cela plus engageant et intéressant",
            "Ajuster pour une meilleure grammaire et un meilleur flux",
            "Réécrire pour mettre l'accent sur les avantages"
        ],
        "defaultSummarize": [
            "Résumez en 3 points",
            "Extraire les décisions clés",
            "Liste des principales actions à entreprendre",
            "Fournissez un résumé en une phrase",
            "Mettez en évidence les faits les plus importants",
            "Résumer pour un public non spécialisé",
            "Extraire les points clés",
            "Résumez en 5 points",
            "Identifier le problème principal et la solution proposée",
            "Énumérer toutes les conclusions et recommandations",
            "Fournir un résumé exécutif",
            "Résumez la chronologie des événements",
            "Extraire toutes les questions posées",
            "Énumérez les avantages et les inconvénients mentionnés",
            "Résumez les arguments principaux"
        ]
    },
    "accessibilityService": {
        "error": {
            "generic": "Erreur interne. Veuillez réessayer plus tard.",
            "elementNotFound": "Aucun résultat trouvé. Veuillez vérifier que la recherche existe et réessayer.",
            "highlightOnConflict": "Plusieurs éléments ont été trouvés. Veuillez préciser votre commande pour indiquer celui que vous souhaitez sélectionner.",
            "clickNotInitialized": "La fonction « Appuyer par nom » n'est pas disponible pour le moment. Veuillez contacter l'assistance si le problème persiste.",
            "platformUnsupported": "La saisie par nom n'est pas prise en charge sur cette plateforme."
        },
        "clickWait": "Initialisation en cours. Veuillez patienter un instant et réessayer."
    },
    "deprecated": "Déprécié",
    "view": "Voir",
    "aiWorkflows": {
        "settings": {
            "title": "Paramètres automatisés",
            "description": "Configurez les modèles d'IA et les appareils utilisés pour les flux de travail d'IA. Ces flux de travail vous permettent d'automatiser les tâches de bureau et de navigateur grâce à l'IA embarquée.",
            "configType": {
                "title": "Type de configuration du modèle",
                "description": "Sélectionnez le type de configuration de modèle à utiliser pour les flux de travail d'IA. Différentes configurations sont optimisées pour différents modèles.",
                "label": "Type de configuration"
            },
            "reasoningModel": {
                "title": "Modèle de raisonnement",
                "description": "Sélectionnez le modèle d'IA à utiliser pour les tâches de raisonnement et de planification. Ce modèle analysera vos demandes et créera des plans d'action.",
                "label": "Modèle de raisonnement"
            },
            "reasoningDevice": {
                "label": "Dispositif de raisonnement"
            },
            "generationModel": {
                "title": "Modèle de génération",
                "description": "Sélectionnez le modèle d'IA à utiliser pour les tâches de génération de texte. Ce modèle crée du contenu textuel en fonction des besoins des flux de travail.",
                "label": "Modèle de génération"
            },
            "generationDevice": {
                "label": "Dispositif de génération"
            },
            "noModelsFound": "Aucun modèle trouvé",
            "terminate": {
                "title": "Ressources de flux de travail clair",
                "description": "Cliquez pour interrompre le processus et libérer des ressources. Cela arrêtera tout flux de travail en cours et libérera la mémoire utilisée par les modèles d'IA.",
                "button": "Mettre fin au flux de travail",
                "success": "Le processus de travail a été interrompu.",
                "confirm": {
                    "title": "Mettre fin au flux de travail",
                    "description": "Êtes-vous sûr de vouloir interrompre le processus de workflow ? Cela arrêtera tout workflow en cours et libérera des ressources.",
                    "confirm": "Oui, terminez"
                }
            },
            "autoWarm": {
                "title": "Flux de travail d'IA à démarrage automatique",
                "description": "Initialisation automatique des modèles de flux de travail d'IA au démarrage de l'application. Les modèles seront préchargés afin que les flux de travail puissent démarrer immédiatement.",
                "option": "Démarrage automatique des modèles de flux de travail IA au lancement de l'application"
            },
            "prompt": {
                "title": "Informations complémentaires pour les flux de travail d'IA",
                "description": "Saisissez des informations supplémentaires qui seront utilisées par l'IA de Cephable lors de l'exécution des workflows. Utilisez ce champ pour indiquer vos préférences concernant le ton, le comportement ou tout autre détail.",
                "field": "Invite supplémentaire",
                "placeholder": "Par exemple, confirmez toujours avant d'envoyer des courriels. Privilégiez les réponses concises. Utilisez un langage formel dans vos documents."
            },
            "disableButtonNames": {
                "edit": "Interactions avec le bouton Bloquer",
                "input": {
                    "label": "Nom du bouton",
                    "question": "Quels boutons souhaitez-vous bloquer ? Vous pouvez saisir des noms de boutons complets ou partiels.",
                    "remove": "Supprimer le nom du bouton"
                },
                "button": "Bloquer les boutons",
                "description": "Contrôlez les boutons avec lesquels les flux de travail d'IA sont autorisés à interagir. Par défaut, Cephable peut cliquer sur n'importe quel bouton de votre écran. Utilisez ce paramètre pour éviter les actions accidentelles (par exemple, « acheter », « supprimer »)."
            },
            "remoteWorkflows": {
                "title": "Exécutez des flux de travail d'IA sur tous vos appareils",
                "option": "Autoriser mes autres appareils à démarrer et à suivre les automatisations sur cet appareil",
                "description": "Activé par défaut. Lorsqu'il est activé, vous pouvez démarrer, suivre et répondre aux automatisations de cet appareil depuis vos autres appareils connectés : la progression de l'automatisation (titres des étapes et raisonnement de l'IA) ainsi que les questions posées sont envoyées en temps réel à ces appareils, vous permettant ainsi de répondre où que vous soyez. Ces données sont partagées uniquement entre vos appareils et ne sont jamais stockées sur les serveurs de Cephable. Désactivez cette option pour que les automatisations restent exclusivement sur cet appareil : elles continueront de s'exécuter, mais aucune donnée ne sera envoyée à vos autres appareils, et ces derniers ne pourront pas démarrer d'automatisation sur cet appareil."
            },
            "thinkingLevel": {
                "field": "Effort de raisonnement",
                "description": "Le niveau de réflexion de l'IA avant chaque action est plus élevé. Plus ce niveau est élevé, plus elle choisit et ordonne les actions avec précision pour les tâches complexes, mais chaque étape est légèrement plus lente. Le niveau moyen est recommandé pour la plupart des utilisateurs.",
                "low": "Bas (le plus rapide)",
                "medium": "Moyen (recommandé)",
                "high": "Haut",
                "max": "Max (le plus minutieux)"
            }
        }
    },
    "control": "Contrôle",
    "automate": "Automatiser",
    "deviceCommandThrottled": {
        "macroLength": "Cette connexion ne permet pas les macros longues. Votre macro a été raccourcie automatiquement.",
        "commandCount": "Cette connexion limite la vitesse d'envoi des commandes. Veuillez patienter et réessayer ultérieurement.",
        "incompatibleActions": "Ce contrôle contient des actions qui ne peuvent pas être utilisées ensemble et n'a pas été envoyé."
    },
    "tos": {
        "title": "Mise à jour des conditions d'utilisation",
        "description": "Nos conditions d'utilisation ont été mises à jour. Veuillez consulter et accepter les conditions mises à jour pour continuer à utiliser Cephable.",
        "effectiveDate": "Date d'entrée en vigueur : {{date}}",
        "accept": "Accepter les conditions d'utilisation",
        "loadError": "Impossible de charger les conditions d'utilisation. Veuillez réessayer.",
        "viewInBrowser": "Afficher les conditions d'utilisation dans le navigateur",
        "acceptCheckbox": "J'ai lu et j'accepte les conditions d'utilisation"
    },
    "appearance": {
        "title": "Apparence"
    },
    "troubleshooting": {
        "title": "Dépannage"
    },
    "extensions": {
        "title": "Extensions",
        "titleShort": "Extensions",
        "description": "Activez les fonctionnalités, connectez les applications complémentaires et étendez les capacités de Cephable.",
        "searchPlaceholder": "Extensions de recherche",
        "noResults": "Aucune extension ne correspond à votre recherche.",
        "comingSoon": "À venir",
        "done": "Fait",
        "getStarted": "Commencer",
        "viewDetails": "Afficher les détails et les paramètres",
        "enable": "Activer",
        "publisher": {
            "official": "Céphable",
            "officialTitle": "Officiel — construit et maintenu par Cephable",
            "byline": "Par {{publisher}}",
            "thirdPartyTitle": "Intégration tierce par {{publisher}}"
        },
        "category": {
            "inputControls": {
                "title": "Entrée et contrôle",
                "description": "Activez les modes de contrôle de votre appareil avec Cephable."
            },
            "companionApps": {
                "title": "Applications et outils complémentaires",
                "description": "Étendez les possibilités de Cephable grâce à notre application mobile et à nos créateurs web."
            },
            "buildExtend": {
                "title": "Construire et étendre",
                "description": "Créez vos propres extensions avec l'API et les SDK de Cephable."
            },
            "marketplace": {
                "title": "Marché",
                "description": "De nouvelles compétences, de nouveaux outils et de nouveaux contacts sont à venir."
            }
        },
        "camera": {
            "title": "Commandes de la caméra",
            "description": "Contrôlez votre appareil par les mouvements du visage et de la tête grâce à votre caméra.",
            "detail": "Les commandes de la caméra vous permettent d'utiliser les expressions faciales et les mouvements de la tête (y compris la tête comme souris) pour contrôler votre appareil. Activez-les à l'aide du commutateur sur la carte, puis ajustez le comportement ici.",
            "settings": {
                "title": "Expressions et gestes",
                "description": "Dans les Paramètres, vous pouvez associer des expressions faciales et des mouvements de tête à des actions."
            },
            "advancedSettings": "Ouvrir les paramètres de l'appareil photo"
        },
        "gamepad": {
            "title": "Prise en charge des manettes de jeu",
            "description": "Émulez une manette Xbox pour que les jeux reconnaissent vos entrées Cephable.",
            "detail": "La prise en charge des manettes nécessite l'installation de ViGEm, un pilote tiers non officiel, pour émuler une manette Xbox virtuelle reconnue nativement par les jeux. Installez ou mettez à jour le pilote ci-dessous. Disponible pour Windows x64."
        },
        "mobile": {
            "title": "Application mobile Cephable",
            "description": "Utilisez votre téléphone comme manette avec l'application mobile Cephable.",
            "detail": "Téléchargez l'application mobile Cephable pour utiliser votre téléphone comme manette. Scannez un code ou utilisez les liens pour la télécharger sur iOS ou Android, puis prévisualisez l'application ci-dessous.",
            "screenshotsTitle": "Aperçu",
            "screenshotPlaceholder": "Capture d'écran",
            "screenshotAlt": "Capture d'écran de l'application mobile Cephable {{number}}",
            "scanTitle": "Scannez pour télécharger",
            "ios": "iOS — App Store",
            "android": "Android — Google Play",
            "iosAction": "Téléchargez-la sur l'App Store",
            "androidAction": "Téléchargez-le sur Google Play"
        },
        "controllerCreator": {
            "title": "Créateur de manettes personnalisées",
            "description": "Concevez vos propres manettes à l'écran sur controller.cephable.com.",
            "detail": "Le créateur de manettes personnalisées vous permet de concevoir et de partager vos propres manettes à l'écran dans le navigateur.",
            "qrCaption": "contrôleur.cephable.com",
            "action": "Créateur de contrôleurs ouverts",
            "screenshotsTitle": "Aperçu",
            "screenshotPlaceholder": "Capture d'écran du créateur de manette",
            "screenshotAlt": "Capture d'écran de Custom Controller Creator {{number}}"
        },
        "developer": {
            "title": "Créez votre propre extension",
            "description": "Utilisez l'API et les SDK de Cephable pour créer et partager vos propres extensions.",
            "detail": "Créez vos propres extensions et intégrations avec Cephable. Explorez l'API et les SDK, puis publiez et partagez vos créations sur developers.cephable.com.",
            "api": {
                "title": "API Cephable",
                "description": "Gérez par programmation les profils, les appareils, les commandes et les événements en temps réel."
            },
            "sdk": {
                "title": "Kits de développement logiciel (SDK) et exemples",
                "description": "Démarrez rapidement grâce à nos kits de développement logiciel (SDK), nos exemples et nos guides d'intégration."
            },
            "action": "Rendez-vous sur developers.cephable.com"
        },
        "portal": {
            "title": "Projets et équipes",
            "description": "Gérez vos projets et vos équipes dans le portail Cephable.",
            "detail": "Utilisez le portail Cephable pour gérer vos projets, vos équipes et les paramètres de votre organisation depuis un seul et même endroit.",
            "projects": {
                "title": "Projets",
                "description": "Créer et gérer des projets, des clés API et des intégrations."
            },
            "teams": {
                "title": "Équipes",
                "description": "Invitez des membres, attribuez des rôles et gérez les accès au sein de votre organisation."
            },
            "action": "Ouvrir le portail Cephable"
        },
        "mcpTools": {
            "title": "Outils MCP",
            "description": "Utilisez les outils du protocole MCP (Model Context Protocol) pour étendre les capacités de Cephable."
        },
        "aiSkills": {
            "title": "Compétences en IA",
            "description": "Ajoutez des compétences d'IA réutilisables que Cephable peut déclencher à la demande."
        },
        "workflows": {
            "title": "Flux de travail réutilisables",
            "description": "Partagez et installez des flux de travail d'automatisation prédéfinis."
        },
        "controlBundles": {
            "title": "Packs de contrôle",
            "description": "Installez des ensembles de contrôles d'applications et de jeux soigneusement sélectionnés en un seul clic."
        },
        "connections": {
            "title": "Connexions jeux et applications",
            "description": "Découvrez les jeux et applications que vous pouvez contrôler avec Cephable, comme Call of Duty: Black Ops 7."
        }
    },
    "sensitivityValues": {
        "verySensitive": "Très sensible",
        "high": "Haut",
        "medium": "Moyen",
        "low": "Faible",
        "notSensitive": "Non sensible"
    },
    "summarize": "Résumer",
    "appControlsPanel": {
        "searchPlaceholder": "Commandes de recherche...",
        "searchLabel": "Commandes de recherche",
        "favorites": {
            "title": "Favoris",
            "description": "Les favoris sont des commandes que vous utilisez fréquemment. Vous pouvez marquer une commande comme favorite en cliquant sur l'icône en forme d'étoile située à côté."
        },
        "noCommandsFound": "Aucune commande trouvée",
        "globalCommands": "Mondial",
        "prefixCommandToast": "Il s'agit d'une commande par préfixe : prononcez ou saisissez le préfixe suivi de la phrase pour la déclencher."
    },
    "collapse": "Effondrement",
    "intelligentTasks": {
        "loading": {
            "loadingModels": "Chargement des modèles d'IA...",
            "extractingModels": "Extraction de modèles d'IA..."
        }
    },
    "sidebar": {
        "collapse": "Réduire la barre latérale",
        "expand": "Développer la barre latérale"
    },
    "workspace": {
        "title": "Espace de travail",
        "badge": "Sur l'appareil · privé",
        "subtitle": "Votre assistant IA fonctionne entièrement sur cet appareil. Lancez des commandes, créez, automatisez ou discutez simplement.",
        "control": {
            "title": "Contrôle",
            "description": "Commandes vocales, raccourcis clavier et boutons d'action rapide : fonctionnent dans toutes les applications de votre appareil.",
            "voice": {
                "title": "commandes vocales",
                "description": "Commandes mains libres"
            },
            "dictation": {
                "title": "Dictée",
                "description": "Parlez au type"
            },
            "computerUse": {
                "title": "Utilisation de l'ordinateur",
                "description": "Laissez l'assistant agir"
            }
        },
        "create": {
            "title": "Créer",
            "description": "Rédigez, réécrivez, reformatez et traduisez — directement dans l'application que vous utilisez, en utilisant du texte copié et surligné.",
            "items": {
                "draftEmail": "Rédigez un courriel",
                "writeDocument": "Rédigez un document",
                "summarizeNotes": "Résumer en notes",
                "polishWriting": "Corrigez mon écriture",
                "translateText": "Traduire le texte",
                "socialPost": "Rédigez une publication pour les réseaux sociaux",
                "cd_brief": "Rédiger un brief créatif",
                "cd_caption": "Rédigez une légende et un texte alternatif",
                "ar_insights": "Synthétiser les résultats pour en tirer des enseignements",
                "ar_exec": "Rédiger un résumé",
                "cc_followup": "Rédigez un courriel de suivi",
                "cc_meetingNotes": "Transformer les notes en compte-rendu de réunion",
                "bd_commit": "Rédigez un message de commit",
                "bd_review": "Résumer une revue de code",
                "gp_bio": "Rédigez une biographie de streamer",
                "gp_recap": "Résumé de la session d'hier soir",
                "lt_lesson": "Élaborer un plan de leçon",
                "lt_studyNotes": "Résumer sous forme de notes de cours",
                "mo_agenda": "Élaborer un ordre du jour de la réunion",
                "mo_update": "Rédiger une mise à jour du projet",
                "aa_simplify": "Simplifiez en langage clair",
                "aa_describe": "Décrivez une image en mots"
            },
            "contextRow": {
                "highlightedText": "Surligner / texte du presse-papiers",
                "output": "Saisie en cours :",
                "input": "Utilisations :",
                "background": "Arrière-plan",
                "currentapp": "Application actuelle"
            },
            "prompts": {
                "draftEmail": "Rédigez un courriel clair et professionnel à ce sujet.",
                "writeDocument": "Rédigez un document à ce sujet.",
                "summarizeNotes": "Résumez cela en notes concises et bien organisées sous forme de points clés.",
                "polishWriting": "Réécrivez ceci pour que ce soit plus clair et plus soigné, tout en conservant le sens et le ton.",
                "socialPost": "Rédigez un court message attrayant pour les réseaux sociaux à ce sujet.",
                "cd_brief": "Rédigez un brief créatif pour ce projet.",
                "ar_insights": "Résumez les principaux résultats et enseignements tirés de ces données.",
                "ar_exec": "Rédigez un résumé concis pour ce sujet.",
                "cc_followup": "Rédigez un courriel de suivi à ce sujet.",
                "cc_meetingNotes": "Transformez ces notes en comptes rendus de réunion clairs, comportant des points d'action.",
                "bd_commit": "Rédigez un message de commit clair pour ces modifications :",
                "bd_review": "Résumez cette revue de code en points clés et modifications requises.",
                "gp_bio": "Rédigez une bio percutante pour mon stream/profil.",
                "lt_lesson": "Élaborez un plan de leçon sur ce sujet.",
                "lt_studyNotes": "Résumez ces informations sous forme de notes d'étude que je puisse consulter.",
                "mo_agenda": "Élaborez un ordre du jour de réunion couvrant ce sujet.",
                "mo_update": "Rédigez une mise à jour de l'état d'avancement du projet à l'intention des parties prenantes en vous basant sur ces informations.",
                "aa_simplify": "Réécrivez ceci dans un langage clair et facile à lire."
            }
        },
        "automate": {
            "title": "Automatiser",
            "description": "Décrivez une tâche en langage clair et Cephable l'exécutera sur vos applications, vos fichiers, voire même votre ligne de commande.",
            "items": {
                "triage": "Triez ma boîte de réception",
                "cd_exportAssets": "Renommer et archiver les ressources",
                "cd_moodboard": "Collectez des références",
                "cc_triage": "Tri et ébauche des réponses",
                "cc_recap": "Récapitulatif et envoi à l'équipe",
                "bd_scaffold": "Échafauder un projet",
                "gp_schedule": "Planifiez un horaire de diffusion",
                "lt_handout": "Préparer un document de travail",
                "summarizeSend": "Résumer et envoyer par courriel",
                "researchDoc": "Rechercher et rédiger un document",
                "organizeFiles": "Organiser mes fichiers",
                "cleanUp": "Nettoyer un dossier",
                "wordDoc": "Créer un document Word",
                "ar_summarizeSend": "Résumer et envoyer par courriel",
                "ar_analyzeData": "Analyser une feuille de calcul",
                "ar_deck": "Construisez un deck à partir de données",
                "cc_summarizeEmail": "Résumez dans un e-mail",
                "cc_socialPost": "Publier à partir d'un lien",
                "bd_buildTest": "Créer et tester un projet",
                "bd_cleanup": "Suggestions de nettoyage du code",
                "lt_studyMaterial": "Créer du matériel d'étude",
                "lt_accommodation": "Prenez des notes accessibles",
                "lt_research": "Rechercher et comparer",
                "mo_meetingActions": "Transformer les notes en actions",
                "mo_organizeFiles": "Organiser mes fichiers",
                "mo_cleanup": "Nettoyer les téléchargements",
                "aa_translate": "Traduire un document"
            },
            "prompts": {
                "summarizeSend": "Résumez le contenu du dossier <folder> et envoyez-le par courriel à <team email>.",
                "researchDoc": "Analysez les tendances dans <dossier ou document> et rédigez un compte rendu de vos découvertes dans un nouveau document.",
                "organizeFiles": "Copiez les fichiers depuis<source folder> dans<destination folder> .",
                "cleanUp": "Supprimez tous les fichiers de type <type de fichier, par exemple des captures d'écran> de mon <dossier>.",
                "wordDoc": "Utiliser<article or notes> créer un document Microsoft Word qui<does what> .",
                "triage": "Veuillez consulter ma boîte de réception et me dire ce qui requiert mon attention, puis rédiger des réponses lorsque cela est nécessaire.",
                "cd_exportAssets": "Renommez les ressources de conception dans <dossier> en utilisant ce schéma — <schéma de nommage> — et triez-les dans des dossiers.",
                "cd_moodboard": "Trouvez des références pour <idée> en ligne et rassemblez-les dans un document.",
                "ar_summarizeSend": "Résumez le contenu du dossier <folder> et envoyez-le par courriel à <team email>.",
                "ar_analyzeData": "Analysez la feuille de calcul et trouvez ce qu'il faut rechercher, par exemple les pertes importantes.",
                "ar_deck": "Transformez les résultats contenus dans <document ou dossier> en une présentation PowerPoint mettant en évidence <points clés>.",
                "cc_triage": "Je consulte ma boîte de réception et je rédige des réponses à tous les messages qui en nécessitent une.",
                "cc_summarizeEmail": "Rédigez un courriel récapitulatif<article or document> et souligner les principaux détails techniques.",
                "cc_recap": "Rédigez un compte rendu de la réunion et envoyez-le par courriel à l'adresse électronique de l'équipe.",
                "cc_socialPost": "Lire<article or website> et écrire un<platform, e.g. Discord> -Publiez un message convivial à ce sujet, puis enregistrez-le dans une nouvelle note.",
                "bd_buildTest": "Veuillez examiner le code dans le dossier du projet, le compiler et exécuter les tests. En cas d'erreur, consultez l'historique Git et indiquez-moi la cause probable du problème.",
                "bd_cleanup": "Examinez le code dans <dossier du projet> et dites-moi comment le rendre plus propre.",
                "bd_scaffold": "Créez un nouveau projet <type de projet> dans <dossier> avec les fichiers de démarrage nécessaires.",
                "gp_schedule": "Planifiez un calendrier de diffusion en continu pour<time period> revêtement<games or activities> .",
                "lt_studyMaterial": "Utiliser<article or notes> créer un document Word pour<grade level> étudiants avec<reflection questions or a study guide> .",
                "lt_accommodation": "Créez un document Word de notes de cours sur <sujet> formaté pour un étudiant bénéficiant d'un <aménagement>.",
                "lt_handout": "Compilez les lectures du dossier <folder> en un seul document à distribuer.",
                "lt_research": "Trouvez en ligne des ouvrages sur le sujet <par exemple, des livres sur la neurodiversité> et créez un document résumant chaque ouvrage afin que je puisse les comparer.",
                "mo_meetingActions": "Lisez le compte rendu de la réunion : que reste-t-il à faire, qui est responsable et quels éléments nécessitent des recherches supplémentaires ? Répartissez-le dans des fichiers organisés dans un dossier.",
                "mo_organizeFiles": "Copiez les fichiers depuis<source folder> dans<destination folder> .",
                "mo_cleanup": "Supprimez tous les fichiers de type <ex. installateurs> de mon dossier Téléchargements.",
                "aa_translate": "Traduisez <document> en <langue> et enregistrez-le dans <dossier>."
            }
        },
        "history": {
            "title": "Histoire récente de l'IA",
            "description": "Vos dernières tâches intelligentes et automatisations.",
            "viewAll": "Afficher tout l'historique",
            "empty": "Vos tâches d'IA et automatisations récentes apparaîtront ici."
        },
        "badgeRemote": "Appareil distant · sécurisé",
        "browser": {
            "openButton": "Ouvrir le navigateur",
            "windowTitle": "Navigateur Cephable",
            "newTab": "Nouvel onglet",
            "reload": "Recharger",
            "forward": "Avant",
            "openExternal": "Ouvrir dans le navigateur par défaut",
            "showWindow": "Afficher le navigateur caché",
            "addressPlaceholder": "Recherchez sur Google ou saisissez une URL.",
            "clearData": {
                "description": "Effacer l'historique, les cookies, les données en cache et les identifiants enregistrés du navigateur Cephable. Vous serez ainsi déconnecté de tous les sites web dans le navigateur Cephable.",
                "button": "Effacer les données du navigateur",
                "cleared": "Données de navigation effacées.",
                "error": "Impossible d'effacer les données du navigateur.",
                "confirmTitle": "Effacer les données de navigation ?",
                "confirmMessage": "Se déconnecter de tout dans le navigateur Cephable ?",
                "confirmDetail": "Cette action efface définitivement l'historique, les cookies, les données en cache et les identifiants enregistrés pour le navigateur Cephable. Cette action est irréversible.",
                "confirm": "Données claires",
                "cancel": "Annuler"
            },
            "context": {
                "newTab": "Nouvel onglet",
                "reload": "Recharger",
                "duplicate": "Onglet dupliqué",
                "close": "Fermer l'onglet",
                "closeOthers": "Fermez les autres onglets",
                "closeRight": "Fermez les onglets à droite",
                "back": "Dos",
                "forward": "Avant",
                "openLinkNewTab": "Ouvrir le lien dans un nouvel onglet",
                "openLinkExternal": "Ouvrir le lien dans le navigateur par défaut",
                "openExternal": "Ouvrir dans le navigateur par défaut",
                "openAllExternal": "Ouvrir tous les onglets dans le navigateur par défaut"
            },
            "home": {
                "tabTitle": "Maison",
                "title": "Le navigateur Cephable",
                "tagline": "Cephable peut piloter un navigateur distinct pour vous.",
                "description": "C'est ici que Cephable automatise les tâches web pour vous. Fonctionnant indépendamment de votre navigateur habituel, il permet de garder vos onglets, connexions et navigations ouverts intacts pendant l'exécution des automatisations, même en arrière-plan.",
                "searchPlaceholder": "Effectuez une recherche sur Google ou saisissez une URL pour commencer.",
                "go": "Aller",
                "features": {
                    "separate": {
                        "title": "Fonctionne de manière autonome",
                        "description": "Conservé séparément de votre navigateur par défaut afin que les automatisations ne perturbent jamais votre navigation personnelle."
                    },
                    "automate": {
                        "title": "Conçu pour l'automatisation",
                        "description": "Cephable permet d'ouvrir des pages, de remplir des formulaires et de recueillir des informations ici, sans utiliser les mains."
                    },
                    "handoff": {
                        "title": "Passez le relais à tout moment",
                        "description": "Ouvrez n'importe quelle page dans votre navigateur par défaut lorsque vous souhaitez prendre le contrôle."
                    }
                }
            }
        }
    },
    "noResults": "Aucun résultat",
    "noResultsSearch": "Aucun résultat trouvé pour votre recherche.",
    "interrupted": "Interrompu",
    "aiHistory": {
        "title": "Histoire de l'IA",
        "description": "Consultez, recherchez et gérez votre historique de conversations avec l'IA locale.",
        "empty": {
            "title": "Pas encore d'histoire de l'IA",
            "description": "L'historique de vos conversations avec l'IA apparaîtra ici après l'utilisation de tâches intelligentes."
        },
        "search": {
            "placeholder": "Rechercher des conversations..."
        },
        "pagination": {
            "range": "Affichage de {{start}}–{{end}} sur {{total}}"
        },
        "source": {
            "create": "Créer",
            "automate": "Automatiser"
        },
        "workflow": {
            "plan": "Plan",
            "steps": "Mesures",
            "files": "Fichiers",
            "folders": "Dossiers"
        },
        "trace": {
            "thinking": "Pensée",
            "toolCalls": "Appels d'outils",
            "roles": {
                "tool": "Résultat de l'outil"
            },
            "thought": "Pensée",
            "action": "Action",
            "parameters": "Paramètres",
            "result": "Résultat",
            "reply": "Vous avez répondu",
            "sources": "Sources"
        },
        "task": {
            "instructions": "Instructions",
            "language": "Langue",
            "types": {
                "generate": "Générer",
                "rewrite": "Récrire",
                "translate": "Traduire",
                "summarize": "Résumer"
            }
        },
        "session": {
            "messages": "messages",
            "deleteTitle": "Supprimer la conversation",
            "deleteDescription": "Êtes-vous sûr de vouloir supprimer cette conversation ? Cette action est irréversible.",
            "deleteConfirm": "Supprimer",
            "deleteCancel": "Annuler"
        },
        "clear": {
            "title": "Effacer l'historique de l'IA",
            "description": "Supprimer tout l'historique des conversations IA stockées localement sur cet appareil.",
            "confirm": {
                "title": "Effacer l'historique de l'IA",
                "description": "Êtes-vous sûr de vouloir effacer tout l'historique des conversations avec l'IA ? Cette action est irréversible.",
                "confirm": "Effacer tout",
                "cancel": "Annuler"
            },
            "success": "Historique de l'IA effacé avec succès.",
            "error": "Impossible d'effacer l'historique de l'IA."
        },
        "export": {
            "title": "Exporter",
            "description": "Exportez l'historique de vos conversations IA vers un fichier JSONL.",
            "success": "Historique de l'IA exporté avec succès.",
            "error": "Échec de l'exportation de l'historique de l'IA."
        },
        "retention": {
            "note": "Vos {{count}} conversations les plus récentes sont conservées. Vos favoris sont toujours sauvegardés.",
            "label": "Garder"
        },
        "filter": {
            "label": "Filtrer par type",
            "all": "Tous types"
        },
        "favorites": {
            "title": "Favoris",
            "add": "Ajouter aux favoris",
            "remove": "Retirer des favoris"
        },
        "select": {
            "selectOne": "Sélectionner la conversation",
            "selected": "{{count}} sélectionné",
            "deleteSelected": "Supprimer la sélection",
            "clear": "Clair",
            "deleteTitle": "Supprimer les conversations sélectionnées",
            "deleteDescription": "Supprimer {{count}} conversation(s) sélectionnée(s) ? Cette action est irréversible."
        },
        "copy": {
            "label": "Copie",
            "success": "Copié dans le presse-papiers.",
            "error": "Impossible de copier dans le presse-papiers."
        },
        "live": "En direct",
        "keychain": {
            "continue": "Continuer",
            "title": "Protéger l'histoire de l'IA",
            "message": "Cephable chiffre votre historique d'IA, y compris l'historique des flux de travail, sur ce Mac.",
            "detail": "macOS vous demandera ensuite l'autorisation d'accéder à « Cephable Safe Storage ». Ce dernier contient uniquement la clé de chiffrement, et non votre flux de travail ni le contenu de vos tâches. Choisissez « Toujours autoriser » pour que votre historique chiffré reste accessible sans que cette demande ne soit répétée. En choisissant « Autoriser », Cephable y accède cette fois-ci, mais macOS pourrait vous redemander l'autorisation lors d'un prochain lancement."
        }
    },
    "uses": "Utilisations : {{valeur}}"
}
